/* PDFCommunity - four more tools (v34): Extract pages, Watermark,
   JPG/PNG to PDF, PDF to JPG.
   Loaded as its own <script> after app.js (and tools-extra.js) so none of
   the existing, already-tested code has to change. Reuses the shared
   top-level helpers from app.js (setupDropzone, escapeHtml, fmtSize,
   baseFileName, offerResults, updateLargeFileWarning,
   isProcessing). Every tool only starts when its own panel is on the page,
   so this file is safe to load anywhere.
   Messages are translated here directly (by <html lang>), so the tools
   need no extra translation rules. Everything runs locally in the
   browser: no file is ever sent anywhere. */
(function(){
  'use strict';
  var LANG = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2);
  var NB = ' ';

  var MSG = {
    en: {
      remove: 'Remove {0}',
      last: 'Last step — preparing file for download…',
      error: 'Something went wrong. Please try again.',
      password: "This file is password-protected. Run it on its own to type its password, or remove the password first (e.g. with Unlock PDF on this site).",
      invalidPdf: 'Could not open this file. Is it a valid PDF?',
      pageFailed: 'stopped at page {0} of {1}; no images were saved for this file',
      noneProcessed: 'None of the files could be processed.',
      couldNot: 'Could not process: {0}',
      extracting: 'Extracting pages…',
      extractNeed: 'Enter at least one valid page number (e.g. "1, 3-5").',
      extractInfoOne: '1 file created',
      extractInfoMany: '{0} files created',
      watermarking: 'Adding watermark…',
      wmNeed: 'Type the watermark text first.',
      wmChars: 'The watermark text contains characters that can\'t be drawn here (for example emoji or rare symbols). Letters of any alphabet, digits and common punctuation work.',
      wmFont: 'The letter shapes for this alphabet could not be loaded. Check your internet connection and try again.',
      wmInfoOne: '1 file watermarked',
      wmInfoMany: '{0} files watermarked',
      wmImgNeed: 'Choose the image for the watermark first (PNG or JPG).',
      wmColor: "Colour",
      wmColorOpts: "Grey|Black|Red|Blue|Green",
      wmSize: "Text size",
      wmSizeOpts: "Small|Medium|Large",
      wmOpacity: "Opacity",
      wmOpacityAuto: "Automatic",
      wmImgType: 'This file is not a PNG or JPG image. Choose a PNG or JPG file.',
      wmImgBig: 'This image is too large. Use an image of up to {0} MB and {1} megapixels.',
      wmImgBad: 'This image can\'t be read (the file may be damaged or incomplete). Save it again as PNG or JPG.',
      pct: '{0}%',
      building: 'Creating PDF…',
      imageN: 'Image {0} of {1}…',
      imgUnsupported: 'This image format can\'t be read by your browser. Use JPG or PNG.',
      imgTruncated: 'This image is incomplete (the file was cut off, for example by an interrupted download). Save or download it again.',
      noImages: 'None of the images could be read. Use JPG or PNG files.',
      jpgpdfInfo: '1 PDF, {0} pages, {1}',
      jpgpdfInfoOne: '1 PDF, 1 page, {0}',
      pjFormat: "Image format",
      pjFormatOpts: "JPG (smaller files)|PNG (sharp, lossless)",
      jpgOrient: "Orientation",
      jpgOrientOpts: "Automatic|Portrait|Landscape",
      jpgMargin: "Margin",
      jpgMarginOpts: "None|Small (1 cm)|Large (2 cm)",
      jpgEach: "A separate PDF for every image",
      jpgEachInfo: "{0} PDFs, one per image",
      rendering: 'Converting…',
      pageN: 'File {0} of {1} — page {2} of {3}…',
      pdfjpgInfoOne: '1 image created',
      pdfjpgInfoMany: '{0} images created',
      protecting: 'Adding password…',
      unlocking: 'Removing password…',
      pwNeed: 'Type a password first.',
      pwMismatch: 'The two passwords are not the same. Type the same password twice.',
      pwAlready: 'This file already has a password. Remove it first with Unlock PDF, then set a new one.',
      protectInfoOne: '1 file protected (AES-256)',
      protectInfoMany: '{0} files protected (AES-256)',
      unlockNeed: 'This file needs a password to open. Type it in the password field.',
      unlockWrong: 'That password is not correct for this file.',
      unlockNone: 'this file has no password',
      unlockInfoOne: '1 file unlocked',
      unlockInfoMany: '{0} files unlocked',
      noCrypto: 'Your browser does not support the encryption this needs. Use an up-to-date browser.',
      pwTooLong: 'This password is too long for a PDF. Use a shorter one: up to 127 plain letters and digits (accented letters, symbols and other alphabets count double or triple).',
      protectDamaged: 'This PDF has damaged parts that can\'t be encrypted safely, so it was not protected. Save it again from a PDF reader (e.g. print to PDF) and try again.',
      excelWorking: "Converting to Excel…",
      excelInfoOne: "1 Excel file",
      excelInfoMany: "{0} Excel files",
      excelCounts: "sheets: {0}, tables found: {1}",
      excelNoTables: "No tables were recognized, so the text is in the sheets line by line. A table that is a picture in the PDF (a scan, a screenshot) can’t be read as text.",
      excelNoText: "This PDF has no text that can be read (it is probably a scan or photo), so there is nothing to put in a spreadsheet.",
      sheetPage: "Page {0}",
      sheetAll: "All pages",
      signing: "Signing…",
      signNeed: "Create your signature first: draw it in the box or choose a picture of it.",
      signType: "Type",
      signTypeHint: "Your name in a handwriting style",
      signTypeName: "Your name",
      signTypeStyle: "Style",
      signTypeColor: "Colour",
      signTypeColors: "Black|Blue",
      signTypeFontFail: "The handwriting style could not be loaded. Check your connection, or draw your signature instead.",
      signPos: "Signature moved: {0} from the left, {1} from the top.",
      signImgBad: "This picture can’t be read. Use a PNG or JPG file.",
      signPage: "Page {0} of {1}",
      signInfoOne: "1 file signed",
      signInfoMany: "{0} files signed",
      signImgBig: "This picture is too large. Use a smaller photo (up to 25 MB).",
      signBrokeCert: "Note: {0} already had a certificate-based digital signature. That signature is no longer valid in the signed copy.",
      excelCellsCut: "A few cells held more text than Excel allows (32,767 characters) and were cut at that limit.",
      nupWorking: "Placing pages on sheets…",
      nupInfo: "1 PDF, {0} pages on {1} sheets",
      nupInfoSheet: "1 PDF, {0} pages on 1 sheet",
      nupInfoPage: "1 PDF, 1 page on 1 sheet",
      nupInfoMany: "{0} PDFs created",
      nupFormNote: "In {0}, the contents of some form fields could not be drawn on the sheets.",
      imgTooBig: "This image is too large ({0} megapixels). Use an image of up to {1} megapixels, or make it smaller first.",
      certBroke: "Note: {0} had a certificate-based digital signature. That signature is no longer valid in the new copy.",
      jpgBigWarn: "Note: these images need about {0} of memory, which may be too much for this device. If the page stops responding, choose a lower DPI or fewer pages (e.g. \"1-20\").",
      jpgBigStop: "These images would need about {0} of memory, too much for this phone or tablet. Choose a lower DPI or fewer pages (e.g. \"1-20\")."
    },
    nl: {
      remove: 'Verwijder {0}',
      last: 'Laatste stap – bestand klaarmaken om te downloaden…',
      error: 'Er ging iets mis. Probeer het opnieuw.',
      password: "Dit bestand is beveiligd met een wachtwoord. Verwerk het apart om het wachtwoord te typen, of verwijder eerst het wachtwoord (bv. met PDF ontgrendelen op deze site).",
      invalidPdf: 'Dit bestand kon niet geopend worden. Is het een geldige PDF?',
      pageFailed: 'gestopt bij pagina {0} van {1}; voor dit bestand zijn geen afbeeldingen bewaard',
      noneProcessed: 'Geen enkel bestand kon verwerkt worden.',
      couldNot: 'Kon niet verwerken: {0}',
      extracting: "Bezig met pagina's extraheren…",
      extractNeed: 'Vul minstens één geldig paginanummer in (bv. "1, 3-5").',
      extractInfoOne: '1 bestand gemaakt',
      extractInfoMany: '{0} bestanden gemaakt',
      watermarking: 'Bezig met watermerk toevoegen…',
      wmNeed: 'Typ eerst de tekst van het watermerk.',
      wmChars: 'De watermerktekst bevat tekens die hier niet getekend kunnen worden (bv. emoji of zeldzame symbolen). Letters van elk alfabet, cijfers en gewone leestekens werken wel.',
      wmFont: 'De lettervormen voor dit alfabet konden niet geladen worden. Controleer je internetverbinding en probeer het opnieuw.',
      wmInfoOne: '1 bestand met watermerk',
      wmInfoMany: '{0} bestanden met watermerk',
      wmImgNeed: 'Kies eerst de afbeelding voor het watermerk (PNG of JPG).',
      wmColor: "Kleur",
      wmColorOpts: "Grijs|Zwart|Rood|Blauw|Groen",
      wmSize: "Tekstgrootte",
      wmSizeOpts: "Klein|Middel|Groot",
      wmOpacity: "Dekking",
      wmOpacityAuto: "Automatisch",
      wmImgType: 'Dit bestand is geen PNG- of JPG-afbeelding. Kies een PNG- of JPG-bestand.',
      wmImgBig: 'Deze afbeelding is te groot. Gebruik een afbeelding van maximaal {0} MB en {1} megapixels.',
      wmImgBad: 'Deze afbeelding kan niet gelezen worden (het bestand is misschien beschadigd of onvolledig). Sla ze opnieuw op als PNG of JPG.',
      pct: '{0}%',
      building: 'Bezig met PDF maken…',
      imageN: 'Afbeelding {0} van {1}…',
      imgUnsupported: 'Je browser kan dit afbeeldingsformaat niet lezen. Gebruik JPG of PNG.',
      imgTruncated: 'Deze afbeelding is onvolledig (het bestand is afgebroken, bv. door een onderbroken download). Sla ze opnieuw op of download ze opnieuw.',
      noImages: 'Geen enkele afbeelding kon gelezen worden. Gebruik JPG- of PNG-bestanden.',
      jpgpdfInfo: "1 PDF, {0} pagina's, {1}",
      jpgpdfInfoOne: '1 PDF, 1 pagina, {0}',
      pjFormat: "Afbeeldingsformaat",
      pjFormatOpts: "JPG (kleinere bestanden)|PNG (scherp, zonder verlies)",
      jpgOrient: "Oriëntatie",
      jpgOrientOpts: "Automatisch|Staand|Liggend",
      jpgMargin: "Marge",
      jpgMarginOpts: "Geen|Klein (1 cm)|Groot (2 cm)",
      jpgEach: "Een aparte PDF per afbeelding",
      jpgEachInfo: "{0} PDF's, één per afbeelding",
      rendering: 'Bezig met omzetten…',
      pageN: 'Bestand {0} van {1} – pagina {2} van {3}…',
      pdfjpgInfoOne: '1 afbeelding gemaakt',
      pdfjpgInfoMany: '{0} afbeeldingen gemaakt',
      protecting: 'Bezig met wachtwoord instellen…',
      unlocking: 'Bezig met wachtwoord verwijderen…',
      pwNeed: 'Typ eerst een wachtwoord.',
      pwMismatch: 'De twee wachtwoorden zijn niet hetzelfde. Typ twee keer hetzelfde wachtwoord.',
      pwAlready: 'Dit bestand heeft al een wachtwoord. Verwijder het eerst met PDF ontgrendelen en stel dan een nieuw in.',
      protectInfoOne: '1 bestand beveiligd (AES-256)',
      protectInfoMany: '{0} bestanden beveiligd (AES-256)',
      unlockNeed: 'Dit bestand vraagt een wachtwoord om te openen. Typ het in het wachtwoordveld.',
      unlockWrong: 'Dat wachtwoord klopt niet voor dit bestand.',
      unlockNone: 'dit bestand heeft geen wachtwoord',
      unlockInfoOne: '1 bestand ontgrendeld',
      unlockInfoMany: '{0} bestanden ontgrendeld',
      noCrypto: 'Je browser ondersteunt de versleuteling niet die hiervoor nodig is. Gebruik een recente browser.',
      pwTooLong: 'Dit wachtwoord is te lang voor een PDF. Kies een korter: tot 127 gewone letters en cijfers (letters met accenten, symbolen en andere alfabetten tellen dubbel of driedubbel).',
      protectDamaged: 'Deze PDF heeft beschadigde onderdelen die niet veilig versleuteld kunnen worden, dus hij is niet beveiligd. Sla hem opnieuw op vanuit een PDF-lezer (bv. afdrukken als PDF) en probeer opnieuw.',
      excelWorking: "Bezig met omzetten naar Excel…",
      excelInfoOne: "1 Excel-bestand",
      excelInfoMany: "{0} Excel-bestanden",
      excelCounts: "werkbladen: {0}, tabellen gevonden: {1}",
      excelNoTables: "Er zijn geen tabellen herkend, dus de tekst staat regel per regel in de werkbladen. Een tabel die als afbeelding in de PDF staat (een scan, een schermafbeelding), kan niet als tekst gelezen worden.",
      excelNoText: "Deze PDF heeft geen tekst die gelezen kan worden (waarschijnlijk een scan of foto), dus er is niets om in een rekenblad te zetten.",
      sheetPage: "Pagina {0}",
      sheetAll: "Alle pagina's",
      signing: "Bezig met ondertekenen…",
      signNeed: "Maak eerst je handtekening: teken ze in het vak of kies een afbeelding ervan.",
      signType: "Typen",
      signTypeHint: "Je naam in een handschrift",
      signTypeName: "Je naam",
      signTypeStyle: "Stijl",
      signTypeColor: "Kleur",
      signTypeColors: "Zwart|Blauw",
      signTypeFontFail: "De handschriftstijl kon niet laden. Controleer je verbinding, of teken je handtekening.",
      signPos: "Handtekening verplaatst: {0} van links, {1} van boven.",
      signImgBad: "Deze afbeelding kan niet gelezen worden. Gebruik een PNG- of JPG-bestand.",
      signPage: "Pagina {0} van {1}",
      signInfoOne: "1 bestand ondertekend",
      signInfoMany: "{0} bestanden ondertekend",
      signImgBig: "Deze afbeelding is te groot. Gebruik een kleinere foto (tot 25 MB).",
      signBrokeCert: "Let op: {0} had al een digitale handtekening met certificaat. Die handtekening is in de ondertekende kopie niet meer geldig.",
      excelCellsCut: "Enkele cellen bevatten meer tekst dan Excel toelaat (32.767 tekens) en zijn op die grens afgekapt.",
      nupWorking: "Pagina's op bladen zetten…",
      nupInfo: "1 PDF, {0} pagina's op {1} bladen",
      nupInfoSheet: "1 PDF, {0} pagina's op 1 blad",
      nupInfoPage: "1 PDF, 1 pagina op 1 blad",
      nupInfoMany: "{0} PDF's gemaakt",
      nupFormNote: "In {0} kon de inhoud van enkele formuliervelden niet op de bladen getekend worden.",
      imgTooBig: "Deze afbeelding is te groot ({0} megapixels). Gebruik een afbeelding van maximaal {1} megapixels, of maak ze eerst kleiner.",
      certBroke: "Let op: {0} had een digitale handtekening met certificaat. Die handtekening is in de nieuwe kopie niet meer geldig.",
      jpgBigWarn: "Let op: deze afbeeldingen hebben ongeveer {0} geheugen nodig, mogelijk te veel voor dit toestel. Reageert de pagina niet meer, kies dan een lagere DPI of minder pagina's (bv. \"1-20\").",
      jpgBigStop: "Deze afbeeldingen zouden ongeveer {0} geheugen nodig hebben, te veel voor deze telefoon of tablet. Kies een lagere DPI of minder pagina's (bv. \"1-20\")."
    },
    fr: {
      remove: 'Retirer {0}',
      last: 'Dernière étape – préparation du téléchargement…',
      error: 'Une erreur est survenue. Veuillez réessayer.',
      password: "Ce fichier est protégé par un mot de passe. Traitez-le seul pour saisir son mot de passe, ou retirez d’abord le mot de passe (par ex. avec Déverrouiller un PDF sur ce site).",
      invalidPdf: "Impossible d'ouvrir ce fichier. Est-ce un PDF valide" + NB + '?',
      pageFailed: 'arrêt à la page {0} sur {1}' + NB + "; aucune image n'a été enregistrée pour ce fichier",
      noneProcessed: "Aucun fichier n'a pu être traité.",
      couldNot: 'Traitement impossible' + NB + ': {0}',
      extracting: 'Extraction des pages…',
      extractNeed: 'Indiquez au moins un numéro de page valide (par ex. «' + NB + '1, 3-5' + NB + '»).',
      extractInfoOne: '1 fichier créé',
      extractInfoMany: '{0} fichiers créés',
      watermarking: 'Ajout du filigrane…',
      wmNeed: "Saisissez d'abord le texte du filigrane.",
      wmChars: 'Le texte du filigrane contient des caractères qui ne peuvent pas être dessinés ici (par ex. des emoji ou des symboles rares). Les lettres de tout alphabet, les chiffres et la ponctuation courante fonctionnent.',
      wmFont: 'Les formes de lettres de cet alphabet n\'ont pas pu être chargées. Vérifiez votre connexion internet et réessayez.',
      wmInfoOne: '1 fichier avec filigrane',
      wmInfoMany: '{0} fichiers avec filigrane',
      wmImgNeed: "Choisissez d'abord l'image du filigrane (PNG ou JPG).",
      wmColor: "Couleur",
      wmColorOpts: "Gris|Noir|Rouge|Bleu|Vert",
      wmSize: "Taille du texte",
      wmSizeOpts: "Petite|Moyenne|Grande",
      wmOpacity: "Opacité",
      wmOpacityAuto: "Automatique",
      wmImgType: "Ce fichier n'est pas une image PNG ou JPG. Choisissez un fichier PNG ou JPG.",
      wmImgBig: 'Cette image est trop volumineuse. Utilisez une image de {0}\u00a0Mo et {1}\u00a0mégapixels au maximum.',
      wmImgBad: "Cette image ne peut pas être lue (le fichier est peut-être endommagé ou incomplet). Enregistrez-la de nouveau en PNG ou JPG.",
      pct: '{0}\u00a0%',
      building: 'Création du PDF…',
      imageN: 'Image {0} sur {1}…',
      imgUnsupported: "Votre navigateur ne peut pas lire ce format d'image. Utilisez JPG ou PNG.",
      imgTruncated: "Cette image est incomplète (le fichier a été tronqué, par exemple par un téléchargement interrompu). Enregistrez-la ou téléchargez-la à nouveau.",
      noImages: "Aucune image n'a pu être lue. Utilisez des fichiers JPG ou PNG.",
      jpgpdfInfo: '1 PDF, {0} pages, {1}',
      jpgpdfInfoOne: '1 PDF, 1 page, {0}',
      pjFormat: "Format d’image",
      pjFormatOpts: "JPG (fichiers plus légers)|PNG (net, sans perte)",
      jpgOrient: "Orientation",
      jpgOrientOpts: "Automatique|Portrait|Paysage",
      jpgMargin: "Marge",
      jpgMarginOpts: "Aucune|Petite (1 cm)|Grande (2 cm)",
      jpgEach: "Un PDF séparé par image",
      jpgEachInfo: "{0} PDF, un par image",
      rendering: 'Conversion en cours…',
      pageN: 'Fichier {0} sur {1} – page {2} sur {3}…',
      pdfjpgInfoOne: '1 image créée',
      pdfjpgInfoMany: '{0} images créées',
      protecting: 'Ajout du mot de passe…',
      unlocking: 'Suppression du mot de passe…',
      pwNeed: 'Saisissez d\'abord un mot de passe.',
      pwMismatch: 'Les deux mots de passe ne sont pas identiques. Saisissez deux fois le même mot de passe.',
      pwAlready: 'Ce fichier a déjà un mot de passe. Retirez-le d\'abord avec Déverrouiller un PDF, puis définissez-en un nouveau.',
      protectInfoOne: '1 fichier protégé (AES-256)',
      protectInfoMany: '{0} fichiers protégés (AES-256)',
      unlockNeed: 'Ce fichier demande un mot de passe pour s\'ouvrir. Saisissez-le dans le champ du mot de passe.',
      unlockWrong: 'Ce mot de passe n\'est pas correct pour ce fichier.',
      unlockNone: 'ce fichier n\'a pas de mot de passe',
      unlockInfoOne: '1 fichier déverrouillé',
      unlockInfoMany: '{0} fichiers déverrouillés',
      noCrypto: 'Votre navigateur ne prend pas en charge le chiffrement nécessaire. Utilisez un navigateur à jour.',
      pwTooLong: 'Ce mot de passe est trop long pour un PDF. Choisissez-en un plus court : jusqu\'à 127 lettres simples et chiffres (les lettres accentuées, les symboles et les autres alphabets comptent double ou triple).',
      protectDamaged: 'Ce PDF contient des parties endommagées qui ne peuvent pas être chiffrées en toute sécurité : il n\'a donc pas été protégé. Enregistrez-le à nouveau depuis un lecteur PDF (par ex. imprimer en PDF) et réessayez.',
      excelWorking: "Conversion en Excel…",
      excelInfoOne: "1 fichier Excel",
      excelInfoMany: "{0} fichiers Excel",
      excelCounts: "feuilles\u00a0: {0}, tableaux trouvés\u00a0: {1}",
      excelNoTables: "Aucun tableau n'a été reconnu, le texte figure donc ligne par ligne dans les feuilles. Un tableau présent sous forme d'image dans le PDF (un scan, une capture d'écran) ne peut pas être lu comme du texte.",
      excelNoText: "Ce PDF ne contient aucun texte lisible (c'est probablement un scan ou une photo)\u00a0: il n'y a donc rien à mettre dans un tableur.",
      sheetPage: "Page {0}",
      sheetAll: "Toutes les pages",
      signing: "Signature en cours…",
      signNeed: "Créez d'abord votre signature\u00a0: dessinez-la dans le cadre ou choisissez une image de celle-ci.",
      signType: "Saisir",
      signTypeHint: "Votre nom dans une écriture manuscrite",
      signTypeName: "Votre nom",
      signTypeStyle: "Style",
      signTypeColor: "Couleur",
      signTypeColors: "Noir|Bleu",
      signTypeFontFail: "Le style manuscrit n’a pas pu être chargé. Vérifiez votre connexion, ou dessinez votre signature.",
      signPos: "Signature déplacée\u00a0: {0} depuis la gauche, {1} depuis le haut.",
      signImgBad: "Cette image ne peut pas être lue. Utilisez un fichier PNG ou JPG.",
      signPage: "Page {0} sur {1}",
      signInfoOne: "1 fichier signé",
      signInfoMany: "{0} fichiers signés",
      signImgBig: "Cette image est trop volumineuse. Utilisez une photo plus petite (jusqu'à 25 Mo).",
      signBrokeCert: "Attention\u00a0: {0} portait déjà une signature numérique avec certificat. Cette signature n'est plus valide dans la copie signée.",
      excelCellsCut: "Quelques cellules contenaient plus de texte qu'Excel n'en accepte (32\u202f767 caractères) et ont été coupées à cette limite.",
      nupWorking: "Mise en place des pages sur les feuilles…",
      nupInfo: "1 PDF, {0} pages sur {1} feuilles",
      nupInfoSheet: "1 PDF, {0} pages sur 1 feuille",
      nupInfoPage: "1 PDF, 1 page sur 1 feuille",
      nupInfoMany: "{0} PDF créés",
      nupFormNote: "Dans {0}, le contenu de certains champs de formulaire n'a pas pu être dessiné sur les feuilles.",
      imgTooBig: "Cette image est trop grande ({0}\u00a0mégapixels). Utilisez une image de {1}\u00a0mégapixels au maximum, ou réduisez-la d'abord.",
      certBroke: "Attention\u00a0: {0} portait une signature numérique avec certificat. Cette signature n'est plus valide dans la nouvelle copie.",
      jpgBigWarn: "Attention\u00a0: ces images demandent environ {0} de mémoire, peut-être trop pour cet appareil. Si la page ne répond plus, choisissez une résolution (DPI) plus basse ou moins de pages (par ex. «\u00a01-20\u00a0»).",
      jpgBigStop: "Ces images demanderaient environ {0} de mémoire, trop pour ce téléphone ou cette tablette. Choisissez une résolution (DPI) plus basse ou moins de pages (par ex. «\u00a01-20\u00a0»)."
    },
    de: {
      remove: 'Entfernen: {0}',
      last: 'Letzter Schritt – Datei wird zum Herunterladen vorbereitet…',
      error: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
      password: "Diese Datei ist passwortgeschützt. Verarbeiten Sie sie einzeln, um ihr Passwort einzugeben, oder entfernen Sie zuerst das Passwort (z. B. mit „PDF entsperren“ auf dieser Website).",
      invalidPdf: 'Diese Datei konnte nicht geöffnet werden. Ist es ein gültiges PDF?',
      pageFailed: 'bei Seite {0} von {1} abgebrochen; für diese Datei wurden keine Bilder gespeichert',
      noneProcessed: 'Keine der Dateien konnte verarbeitet werden.',
      couldNot: 'Nicht verarbeitet: {0}',
      extracting: 'Seiten werden extrahiert…',
      extractNeed: 'Geben Sie mindestens eine gültige Seitenzahl ein (z. B. „1, 3-5“).',
      extractInfoOne: '1 Datei erstellt',
      extractInfoMany: '{0} Dateien erstellt',
      watermarking: 'Wasserzeichen wird eingefügt…',
      wmNeed: 'Geben Sie zuerst den Text des Wasserzeichens ein.',
      wmChars: 'Der Wasserzeichentext enthält Zeichen, die hier nicht gezeichnet werden können (z. B. Emoji oder seltene Symbole). Buchstaben jedes Alphabets, Ziffern und übliche Satzzeichen funktionieren.',
      wmFont: 'Die Schrift für dieses Alphabet konnte nicht geladen werden. Prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
      wmInfoOne: '1 Datei mit Wasserzeichen',
      wmInfoMany: '{0} Dateien mit Wasserzeichen',
      wmImgNeed: 'Wählen Sie zuerst das Bild für das Wasserzeichen (PNG oder JPG).',
      wmColor: "Farbe",
      wmColorOpts: "Grau|Schwarz|Rot|Blau|Grün",
      wmSize: "Textgröße",
      wmSizeOpts: "Klein|Mittel|Groß",
      wmOpacity: "Deckkraft",
      wmOpacityAuto: "Automatisch",
      wmImgType: 'Diese Datei ist kein PNG- oder JPG-Bild. Wählen Sie eine PNG- oder JPG-Datei.',
      wmImgBig: 'Dieses Bild ist zu groß. Verwenden Sie ein Bild mit höchstens {0}\u00a0MB und {1}\u00a0Megapixeln.',
      wmImgBad: 'Dieses Bild kann nicht gelesen werden (die Datei ist vielleicht beschädigt oder unvollständig). Speichern Sie es erneut als PNG oder JPG.',
      pct: '{0}\u00a0%',
      building: 'PDF wird erstellt…',
      imageN: 'Bild {0} von {1}…',
      imgUnsupported: 'Ihr Browser kann dieses Bildformat nicht lesen. Verwenden Sie JPG oder PNG.',
      imgTruncated: 'Dieses Bild ist unvollständig (die Datei wurde abgeschnitten, z. B. durch einen unterbrochenen Download). Speichern oder laden Sie es erneut herunter.',
      noImages: 'Keines der Bilder konnte gelesen werden. Verwenden Sie JPG- oder PNG-Dateien.',
      jpgpdfInfo: '1 PDF, {0} Seiten, {1}',
      jpgpdfInfoOne: '1 PDF, 1 Seite, {0}',
      pjFormat: "Bildformat",
      pjFormatOpts: "JPG (kleinere Dateien)|PNG (scharf, verlustfrei)",
      jpgOrient: "Ausrichtung",
      jpgOrientOpts: "Automatisch|Hochformat|Querformat",
      jpgMargin: "Rand",
      jpgMarginOpts: "Keiner|Klein (1 cm)|Groß (2 cm)",
      jpgEach: "Eine eigene PDF pro Bild",
      jpgEachInfo: "{0} PDFs, eine pro Bild",
      rendering: 'Wird umgewandelt…',
      pageN: 'Datei {0} von {1} – Seite {2} von {3}…',
      pdfjpgInfoOne: '1 Bild erstellt',
      pdfjpgInfoMany: '{0} Bilder erstellt',
      protecting: 'Passwort wird gesetzt…',
      unlocking: 'Passwort wird entfernt…',
      pwNeed: 'Geben Sie zuerst ein Passwort ein.',
      pwMismatch: 'Die beiden Passwörter stimmen nicht überein. Geben Sie zweimal dasselbe Passwort ein.',
      pwAlready: 'Diese Datei hat bereits ein Passwort. Entfernen Sie es zuerst mit dem Tool „PDF entsperren“ und legen Sie dann ein neues fest.',
      protectInfoOne: '1 Datei geschützt (AES-256)',
      protectInfoMany: '{0} Dateien geschützt (AES-256)',
      unlockNeed: 'Diese Datei braucht zum Öffnen ein Passwort. Geben Sie es in das Passwortfeld ein.',
      unlockWrong: 'Dieses Passwort passt nicht zu dieser Datei.',
      unlockNone: 'diese Datei hat kein Passwort',
      unlockInfoOne: '1 Datei entsperrt',
      unlockInfoMany: '{0} Dateien entsperrt',
      noCrypto: 'Ihr Browser unterstützt die dafür nötige Verschlüsselung nicht. Verwenden Sie einen aktuellen Browser.',
      pwTooLong: 'Dieses Passwort ist für ein PDF zu lang. Wählen Sie ein kürzeres: bis zu 127 einfache Buchstaben und Ziffern (Umlaute, Symbole und andere Alphabete zählen doppelt oder dreifach).',
      protectDamaged: 'Dieses PDF enthält beschädigte Teile, die nicht sicher verschlüsselt werden können, daher wurde es nicht geschützt. Speichern Sie es in einem PDF-Reader neu (z. B. als PDF drucken) und versuchen Sie es erneut.',
      excelWorking: "Wird in Excel umgewandelt…",
      excelInfoOne: "1 Excel-Datei",
      excelInfoMany: "{0} Excel-Dateien",
      excelCounts: "Tabellenblätter: {0}, gefundene Tabellen: {1}",
      excelNoTables: "Es wurden keine Tabellen erkannt, daher steht der Text Zeile für Zeile in den Tabellenblättern. Eine Tabelle, die als Bild im PDF steht (ein Scan, ein Screenshot), kann nicht als Text gelesen werden.",
      excelNoText: "Dieses PDF enthält keinen lesbaren Text (wahrscheinlich ein Scan oder Foto), daher gibt es nichts, was in eine Tabellenkalkulation übernommen werden kann.",
      sheetPage: "Seite {0}",
      sheetAll: "Alle Seiten",
      signing: "Wird unterschrieben…",
      signNeed: "Erstellen Sie zuerst Ihre Unterschrift: Zeichnen Sie sie in das Feld oder wählen Sie ein Bild davon.",
      signType: "Tippen",
      signTypeHint: "Ihr Name in Handschrift",
      signTypeName: "Ihr Name",
      signTypeStyle: "Stil",
      signTypeColor: "Farbe",
      signTypeColors: "Schwarz|Blau",
      signTypeFontFail: "Die Handschrift konnte nicht geladen werden. Prüfen Sie Ihre Verbindung oder zeichnen Sie Ihre Unterschrift.",
      signPos: "Unterschrift verschoben: {0} von links, {1} von oben.",
      signImgBad: "Dieses Bild kann nicht gelesen werden. Verwenden Sie eine PNG- oder JPG-Datei.",
      signPage: "Seite {0} von {1}",
      signInfoOne: "1 Datei unterschrieben",
      signInfoMany: "{0} Dateien unterschrieben",
      signImgBig: "Dieses Bild ist zu groß. Verwenden Sie ein kleineres Foto (bis 25 MB).",
      signBrokeCert: "Hinweis: {0} hatte bereits eine digitale Signatur mit Zertifikat. Diese Signatur ist in der unterschriebenen Kopie nicht mehr gültig.",
      excelCellsCut: "Einige Zellen enthielten mehr Text, als Excel zulässt (32.767 Zeichen), und wurden an dieser Grenze abgeschnitten.",
      nupWorking: "Seiten werden auf Blätter verteilt…",
      nupInfo: "1 PDF, {0} Seiten auf {1} Blättern",
      nupInfoSheet: "1 PDF, {0} Seiten auf 1 Blatt",
      nupInfoPage: "1 PDF, 1 Seite auf 1 Blatt",
      nupInfoMany: "{0} PDFs erstellt",
      nupFormNote: "In {0} konnte der Inhalt einiger Formularfelder nicht auf die Blätter übernommen werden.",
      imgTooBig: "Dieses Bild ist zu groß ({0}\u00a0Megapixel). Verwenden Sie ein Bild mit höchstens {1}\u00a0Megapixeln oder verkleinern Sie es zuerst.",
      certBroke: "Hinweis: {0} hatte eine digitale Signatur mit Zertifikat. Diese Signatur ist in der neuen Kopie nicht mehr gültig.",
      jpgBigWarn: "Hinweis: Diese Bilder brauchen etwa {0} Arbeitsspeicher, möglicherweise zu viel für dieses Gerät. Reagiert die Seite nicht mehr, wählen Sie eine niedrigere DPI-Zahl oder weniger Seiten (z.\u00a0B. „1-20“).",
      jpgBigStop: "Diese Bilder würden etwa {0} Arbeitsspeicher brauchen, zu viel für dieses Smartphone oder Tablet. Wählen Sie eine niedrigere DPI-Zahl oder weniger Seiten (z.\u00a0B. „1-20“)."
    },
    es: {
      remove: 'Quitar {0}',
      last: 'Último paso: preparando el archivo para descargar…',
      error: 'Algo salió mal. Inténtalo de nuevo.',
      password: "Este archivo está protegido con contraseña. Procésalo por separado para escribir su contraseña, o quita primero la contraseña (p. ej. con Desbloquear PDF en este sitio).",
      invalidPdf: 'No se pudo abrir este archivo. ¿Es un PDF válido?',
      pageFailed: 'detenido en la página {0} de {1}; no se guardó ninguna imagen de este archivo',
      noneProcessed: 'No se pudo procesar ninguno de los archivos.',
      couldNot: 'No se pudo procesar: {0}',
      extracting: 'Extrayendo páginas…',
      extractNeed: 'Escribe al menos un número de página válido (p. ej. “1, 3-5”).',
      extractInfoOne: '1 archivo creado',
      extractInfoMany: '{0} archivos creados',
      watermarking: 'Añadiendo marca de agua…',
      wmNeed: 'Escribe primero el texto de la marca de agua.',
      wmChars: 'El texto de la marca de agua contiene caracteres que no se pueden dibujar aquí (por ejemplo, emoji o símbolos poco comunes). Funcionan las letras de cualquier alfabeto, los números y los signos de puntuación habituales.',
      wmFont: 'No se pudieron cargar las formas de las letras de este alfabeto. Comprueba tu conexión a internet e inténtalo de nuevo.',
      wmInfoOne: '1 archivo con marca de agua',
      wmInfoMany: '{0} archivos con marca de agua',
      wmImgNeed: 'Elige primero la imagen de la marca de agua (PNG o JPG).',
      wmColor: "Color",
      wmColorOpts: "Gris|Negro|Rojo|Azul|Verde",
      wmSize: "Tamaño del texto",
      wmSizeOpts: "Pequeño|Mediano|Grande",
      wmOpacity: "Opacidad",
      wmOpacityAuto: "Automática",
      wmImgType: 'Este archivo no es una imagen PNG o JPG. Elige un archivo PNG o JPG.',
      wmImgBig: 'Esta imagen es demasiado grande. Usa una imagen de hasta {0} MB y {1} megapíxeles.',
      wmImgBad: 'No se puede leer esta imagen (puede que el archivo esté dañado o incompleto). Vuelve a guardarla como PNG o JPG.',
      pct: '{0}\u00a0%',
      building: 'Creando el PDF…',
      imageN: 'Imagen {0} de {1}…',
      imgUnsupported: 'Tu navegador no puede leer este formato de imagen. Usa JPG o PNG.',
      imgTruncated: 'Esta imagen está incompleta (el archivo se cortó, por ejemplo por una descarga interrumpida). Guárdala o descárgala de nuevo.',
      noImages: 'No se pudo leer ninguna imagen. Usa archivos JPG o PNG.',
      jpgpdfInfo: '1 PDF, {0} páginas, {1}',
      jpgpdfInfoOne: '1 PDF, 1 página, {0}',
      pjFormat: "Formato de imagen",
      pjFormatOpts: "JPG (archivos más pequeños)|PNG (nítido, sin pérdida)",
      jpgOrient: "Orientación",
      jpgOrientOpts: "Automática|Vertical|Horizontal",
      jpgMargin: "Margen",
      jpgMarginOpts: "Ninguno|Pequeño (1 cm)|Grande (2 cm)",
      jpgEach: "Un PDF aparte por imagen",
      jpgEachInfo: "{0} PDF, uno por imagen",
      rendering: 'Convirtiendo…',
      pageN: 'Archivo {0} de {1} – página {2} de {3}…',
      pdfjpgInfoOne: '1 imagen creada',
      pdfjpgInfoMany: '{0} imágenes creadas',
      protecting: 'Añadiendo la contraseña…',
      unlocking: 'Quitando la contraseña…',
      pwNeed: 'Escribe primero una contraseña.',
      pwMismatch: 'Las dos contraseñas no coinciden. Escribe dos veces la misma contraseña.',
      pwAlready: 'Este archivo ya tiene contraseña. Quítala primero con Desbloquear PDF y luego pon una nueva.',
      protectInfoOne: '1 archivo protegido (AES-256)',
      protectInfoMany: '{0} archivos protegidos (AES-256)',
      unlockNeed: 'Este archivo pide una contraseña para abrirse. Escríbela en el campo de contraseña.',
      unlockWrong: 'Esa contraseña no es correcta para este archivo.',
      unlockNone: 'este archivo no tiene contraseña',
      unlockInfoOne: '1 archivo desbloqueado',
      unlockInfoMany: '{0} archivos desbloqueados',
      noCrypto: 'Tu navegador no admite el cifrado necesario. Usa un navegador actualizado.',
      pwTooLong: 'Esta contraseña es demasiado larga para un PDF. Elige una más corta: hasta 127 letras simples y números (las letras con tilde, los símbolos y otros alfabetos cuentan doble o triple).',
      protectDamaged: 'Este PDF tiene partes dañadas que no se pueden cifrar con seguridad, así que no se ha protegido. Vuelve a guardarlo desde un lector de PDF (p. ej. imprimir como PDF) e inténtalo de nuevo.',
      excelWorking: "Convirtiendo a Excel…",
      excelInfoOne: "1 archivo de Excel",
      excelInfoMany: "{0} archivos de Excel",
      excelCounts: "hojas: {0}, tablas encontradas: {1}",
      excelNoTables: "No se ha reconocido ninguna tabla, así que el texto está en las hojas línea por línea. Una tabla que está en el PDF como imagen (un escaneo, una captura de pantalla) no se puede leer como texto.",
      excelNoText: "Este PDF no tiene texto que se pueda leer (probablemente es un escaneo o una foto), así que no hay nada que poner en una hoja de cálculo.",
      sheetPage: "Página {0}",
      sheetAll: "Todas las páginas",
      signing: "Firmando…",
      signNeed: "Crea primero tu firma: dibújala en el recuadro o elige una imagen de ella.",
      signType: "Escribir",
      signTypeHint: "Tu nombre con letra manuscrita",
      signTypeName: "Tu nombre",
      signTypeStyle: "Estilo",
      signTypeColor: "Color",
      signTypeColors: "Negro|Azul",
      signTypeFontFail: "No se pudo cargar el estilo manuscrito. Comprueba tu conexión o dibuja tu firma.",
      signPos: "Firma movida: {0} desde la izquierda, {1} desde arriba.",
      signImgBad: "No se puede leer esta imagen. Usa un archivo PNG o JPG.",
      signPage: "Página {0} de {1}",
      signInfoOne: "1 archivo firmado",
      signInfoMany: "{0} archivos firmados",
      signImgBig: "Esta imagen es demasiado grande. Usa una foto más pequeña (hasta 25 MB).",
      signBrokeCert: "Atención: {0} ya tenía una firma digital con certificado. Esa firma ya no es válida en la copia firmada.",
      excelCellsCut: "Algunas celdas tenían más texto del que Excel admite (32.767 caracteres) y se han cortado en ese límite.",
      nupWorking: "Colocando las páginas en hojas…",
      nupInfo: "1 PDF, {0} páginas en {1} hojas",
      nupInfoSheet: "1 PDF, {0} páginas en 1 hoja",
      nupInfoPage: "1 PDF, 1 página en 1 hoja",
      nupInfoMany: "{0} PDF creados",
      nupFormNote: "En {0} no se pudo dibujar en las hojas el contenido de algunos campos de formulario.",
      imgTooBig: "Esta imagen es demasiado grande ({0} megapíxeles). Usa una imagen de hasta {1} megapíxeles o redúcela primero.",
      certBroke: "Atención: {0} tenía una firma digital con certificado. Esa firma ya no es válida en la nueva copia.",
      jpgBigWarn: "Atención: estas imágenes necesitan unos {0} de memoria, quizá demasiado para este dispositivo. Si la página deja de responder, elige menos DPI o menos páginas (p. ej., \"1-20\").",
      jpgBigStop: "Estas imágenes necesitarían unos {0} de memoria, demasiado para este teléfono o tableta. Elige menos DPI o menos páginas (p. ej., \"1-20\")."
    },
    pt: {
      remove: 'Remover {0}',
      last: 'Última etapa – preparando o arquivo para download…',
      error: 'Algo deu errado. Tente novamente.',
      password: "Este arquivo é protegido por senha. Processe-o separadamente para digitar a senha, ou remova a senha primeiro (por ex. com Desbloquear PDF neste site).",
      invalidPdf: 'Não foi possível abrir este arquivo. Ele é um PDF válido?',
      pageFailed: 'parou na página {0} de {1}; nenhuma imagem deste arquivo foi salva',
      noneProcessed: 'Nenhum dos arquivos pôde ser processado.',
      couldNot: 'Não foi possível processar: {0}',
      extracting: 'Extraindo páginas…',
      extractNeed: 'Digite pelo menos um número de página válido (por ex. “1, 3-5”).',
      extractInfoOne: '1 arquivo criado',
      extractInfoMany: '{0} arquivos criados',
      watermarking: 'Adicionando marca d\'água…',
      wmNeed: 'Digite primeiro o texto da marca d\'água.',
      wmChars: 'O texto da marca d\'água contém caracteres que não podem ser desenhados aqui (por ex. emoji ou símbolos raros). Letras de qualquer alfabeto, números e pontuação comum funcionam.',
      wmFont: 'Não foi possível carregar as formas das letras deste alfabeto. Verifique sua conexão com a internet e tente novamente.',
      wmInfoOne: '1 arquivo com marca d\'água',
      wmInfoMany: '{0} arquivos com marca d\'água',
      wmImgNeed: 'Escolha primeiro a imagem da marca d\'água (PNG ou JPG).',
      wmColor: "Cor",
      wmColorOpts: "Cinza|Preto|Vermelho|Azul|Verde",
      wmSize: "Tamanho do texto",
      wmSizeOpts: "Pequeno|Médio|Grande",
      wmOpacity: "Opacidade",
      wmOpacityAuto: "Automática",
      wmImgType: 'Este arquivo não é uma imagem PNG ou JPG. Escolha um arquivo PNG ou JPG.',
      wmImgBig: 'Esta imagem é grande demais. Use uma imagem de até {0} MB e {1} megapixels.',
      wmImgBad: 'Não é possível ler esta imagem (o arquivo pode estar danificado ou incompleto). Salve-a de novo como PNG ou JPG.',
      pct: '{0}%',
      building: 'Criando o PDF…',
      imageN: 'Imagem {0} de {1}…',
      imgUnsupported: 'Seu navegador não consegue ler este formato de imagem. Use JPG ou PNG.',
      imgTruncated: 'Esta imagem está incompleta (o arquivo foi cortado, por exemplo por um download interrompido). Salve ou baixe a imagem de novo.',
      noImages: 'Nenhuma imagem pôde ser lida. Use arquivos JPG ou PNG.',
      jpgpdfInfo: '1 PDF, {0} páginas, {1}',
      jpgpdfInfoOne: '1 PDF, 1 página, {0}',
      pjFormat: "Formato de imagem",
      pjFormatOpts: "JPG (arquivos menores)|PNG (nítido, sem perda)",
      jpgOrient: "Orientação",
      jpgOrientOpts: "Automática|Retrato|Paisagem",
      jpgMargin: "Margem",
      jpgMarginOpts: "Nenhuma|Pequena (1 cm)|Grande (2 cm)",
      jpgEach: "Um PDF separado para cada imagem",
      jpgEachInfo: "{0} PDFs, um por imagem",
      rendering: 'Convertendo…',
      pageN: 'Arquivo {0} de {1} – página {2} de {3}…',
      pdfjpgInfoOne: '1 imagem criada',
      pdfjpgInfoMany: '{0} imagens criadas',
      protecting: 'Adicionando a senha…',
      unlocking: 'Removendo a senha…',
      pwNeed: 'Digite uma senha primeiro.',
      pwMismatch: 'As duas senhas não são iguais. Digite a mesma senha duas vezes.',
      pwAlready: 'Este arquivo já tem senha. Remova-a primeiro com Desbloquear PDF e depois defina uma nova.',
      protectInfoOne: '1 arquivo protegido (AES-256)',
      protectInfoMany: '{0} arquivos protegidos (AES-256)',
      unlockNeed: 'Este arquivo pede uma senha para abrir. Digite-a no campo de senha.',
      unlockWrong: 'Essa senha não está correta para este arquivo.',
      unlockNone: 'este arquivo não tem senha',
      unlockInfoOne: '1 arquivo desbloqueado',
      unlockInfoMany: '{0} arquivos desbloqueados',
      noCrypto: 'Seu navegador não suporta a criptografia necessária. Use um navegador atualizado.',
      pwTooLong: 'Esta senha é longa demais para um PDF. Escolha uma mais curta: até 127 letras simples e números (letras acentuadas, símbolos e outros alfabetos contam em dobro ou triplo).',
      protectDamaged: 'Este PDF tem partes danificadas que não podem ser criptografadas com segurança, por isso não foi protegido. Salve-o de novo em um leitor de PDF (por ex. imprimir como PDF) e tente novamente.',
      excelWorking: "Convertendo para Excel…",
      excelInfoOne: "1 arquivo do Excel",
      excelInfoMany: "{0} arquivos do Excel",
      excelCounts: "planilhas: {0}, tabelas encontradas: {1}",
      excelNoTables: "Nenhuma tabela foi reconhecida, então o texto está nas planilhas linha por linha. Uma tabela que está no PDF como imagem (uma digitalização, uma captura de tela) não pode ser lida como texto.",
      excelNoText: "Este PDF não tem texto que possa ser lido (provavelmente é uma digitalização ou foto), então não há nada para colocar em uma planilha.",
      sheetPage: "Página {0}",
      sheetAll: "Todas as páginas",
      signing: "Assinando…",
      signNeed: "Crie primeiro sua assinatura: desenhe-a no quadro ou escolha uma imagem dela.",
      signType: "Digitar",
      signTypeHint: "Seu nome em letra cursiva",
      signTypeName: "Seu nome",
      signTypeStyle: "Estilo",
      signTypeColor: "Cor",
      signTypeColors: "Preto|Azul",
      signTypeFontFail: "Não foi possível carregar o estilo cursivo. Verifique sua conexão ou desenhe sua assinatura.",
      signPos: "Assinatura movida: {0} da esquerda, {1} do topo.",
      signImgBad: "Não é possível ler esta imagem. Use um arquivo PNG ou JPG.",
      signPage: "Página {0} de {1}",
      signInfoOne: "1 arquivo assinado",
      signInfoMany: "{0} arquivos assinados",
      signImgBig: "Esta imagem é grande demais. Use uma foto menor (até 25 MB).",
      signBrokeCert: "Atenção: {0} já tinha uma assinatura digital com certificado. Essa assinatura não é mais válida na cópia assinada.",
      excelCellsCut: "Algumas células tinham mais texto do que o Excel permite (32.767 caracteres) e foram cortadas nesse limite.",
      nupWorking: "Colocando as páginas nas folhas…",
      nupInfo: "1 PDF, {0} páginas em {1} folhas",
      nupInfoSheet: "1 PDF, {0} páginas em 1 folha",
      nupInfoPage: "1 PDF, 1 página em 1 folha",
      nupInfoMany: "{0} PDFs criados",
      nupFormNote: "Em {0}, não foi possível desenhar nas folhas o conteúdo de alguns campos de formulário.",
      imgTooBig: "Esta imagem é grande demais ({0} megapixels). Use uma imagem de até {1} megapixels ou reduza-a antes.",
      certBroke: "Atenção: {0} tinha uma assinatura digital com certificado. Essa assinatura não é mais válida na nova cópia.",
      jpgBigWarn: "Atenção: estas imagens precisam de cerca de {0} de memória, talvez demais para este aparelho. Se a página parar de responder, escolha um DPI menor ou menos páginas (ex.: \"1-20\").",
      jpgBigStop: "Estas imagens precisariam de cerca de {0} de memória, demais para este celular ou tablet. Escolha um DPI menor ou menos páginas (ex.: \"1-20\")."
    }, it: {
      remove: "Rimuovi {0}",
      last: "Ultimo passaggio — preparazione del file per il download…",
      error: "Qualcosa è andato storto. Riprova.",
      password: "Questo file è protetto da password. Elaboralo da solo per digitare la password, oppure rimuovi prima la password (per es. con Sbloccare PDF su questo sito).",
      invalidPdf: "Impossibile aprire questo file. È un PDF valido?",
      pageFailed: "interrotto alla pagina {0} di {1}; nessuna immagine salvata per questo file",
      noneProcessed: "Non è stato possibile elaborare nessuno dei file.",
      couldNot: "Impossibile elaborare: {0}",
      extracting: "Estrazione delle pagine…",
      extractNeed: "Inserisci almeno un numero di pagina valido (per es. “1, 3-5”).",
      extractInfoOne: "1 file creato",
      extractInfoMany: "{0} file creati",
      watermarking: "Aggiunta della filigrana…",
      wmNeed: "Scrivi prima il testo della filigrana.",
      wmChars: "Il testo della filigrana contiene caratteri che qui non si possono disegnare (per esempio emoji o simboli rari). Funzionano le lettere di qualsiasi alfabeto, le cifre e la punteggiatura comune.",
      wmFont: "Non è stato possibile caricare il font per questo alfabeto. Controlla la connessione a internet e riprova.",
      wmInfoOne: "1 file con filigrana",
      wmInfoMany: "{0} file con filigrana",
      wmImgNeed: "Scegli prima l'immagine per la filigrana (PNG o JPG).",
      wmColor: "Colore",
      wmColorOpts: "Grigio|Nero|Rosso|Blu|Verde",
      wmSize: "Dimensione del testo",
      wmSizeOpts: "Piccola|Media|Grande",
      wmOpacity: "Opacità",
      wmOpacityAuto: "Automatica",
      wmImgType: "Questo file non è un'immagine PNG o JPG. Scegli un file PNG o JPG.",
      wmImgBig: "Questa immagine è troppo grande. Usa un'immagine fino a {0} MB e {1} megapixel.",
      wmImgBad: "Impossibile leggere questa immagine (il file potrebbe essere danneggiato o incompleto). Salvala di nuovo come PNG o JPG.",
      pct: "{0}%",
      building: "Creazione del PDF…",
      imageN: "Immagine {0} di {1}…",
      imgUnsupported: "Il tuo browser non riesce a leggere questo formato di immagine. Usa JPG o PNG.",
      imgTruncated: "Questa immagine è incompleta (il file è stato troncato, per esempio da un download interrotto). Salvala o scaricala di nuovo.",
      noImages: "Non è stato possibile leggere nessuna immagine. Usa file JPG o PNG.",
      jpgpdfInfo: "1 PDF, {0} pagine, {1}",
      jpgpdfInfoOne: "1 PDF, 1 pagina, {0}",
      pjFormat: "Formato immagine",
      pjFormatOpts: "JPG (file più piccoli)|PNG (nitido, senza perdita)",
      jpgOrient: "Orientamento",
      jpgOrientOpts: "Automatico|Verticale|Orizzontale",
      jpgMargin: "Margine",
      jpgMarginOpts: "Nessuno|Piccolo (1 cm)|Grande (2 cm)",
      jpgEach: "Un PDF separato per ogni immagine",
      jpgEachInfo: "{0} PDF, uno per immagine",
      rendering: "Conversione in corso…",
      pageN: "File {0} di {1} — pagina {2} di {3}…",
      pdfjpgInfoOne: "1 immagine creata",
      pdfjpgInfoMany: "{0} immagini create",
      protecting: "Aggiunta della password…",
      unlocking: "Rimozione della password…",
      pwNeed: "Scrivi prima una password.",
      pwMismatch: "Le due password non coincidono. Scrivi la stessa password due volte.",
      pwAlready: "Questo file ha già una password. Rimuovila prima con Sbloccare PDF, poi impostane una nuova.",
      protectInfoOne: "1 file protetto (AES-256)",
      protectInfoMany: "{0} file protetti (AES-256)",
      unlockNeed: "Questo file richiede una password per essere aperto. Scrivila nel campo della password.",
      unlockWrong: "Questa password non è corretta per questo file.",
      unlockNone: "questo file non ha password",
      unlockInfoOne: "1 file sbloccato",
      unlockInfoMany: "{0} file sbloccati",
      noCrypto: "Il tuo browser non supporta la crittografia necessaria. Usa un browser aggiornato.",
      pwTooLong: "Questa password è troppo lunga per un PDF. Usane una più corta: fino a 127 lettere semplici e cifre (lettere accentate, simboli e altri alfabeti contano doppio o triplo).",
      protectDamaged: "Questo PDF ha parti danneggiate che non si possono cifrare in modo sicuro, quindi non è stato protetto. Salvalo di nuovo da un lettore PDF (per es. stampa in PDF) e riprova.",
      excelWorking: "Conversione in Excel…",
      excelInfoOne: "1 file Excel",
      excelInfoMany: "{0} file Excel",
      excelCounts: "fogli: {0}, tabelle trovate: {1}",
      excelNoTables: "Non è stata riconosciuta nessuna tabella, quindi il testo è nei fogli riga per riga. Una tabella che nel PDF è un'immagine (una scansione, uno screenshot) non si può leggere come testo.",
      excelNoText: "Questo PDF non ha testo leggibile (probabilmente è una scansione o una foto), quindi non c'è niente da inserire in un foglio di calcolo.",
      sheetPage: "Pagina {0}",
      sheetAll: "Tutte le pagine",
      signing: "Firma in corso…",
      signNeed: "Crea prima la tua firma: disegnala nel riquadro o scegli un'immagine della firma.",
      signType: "Digitare",
      signTypeHint: "Il tuo nome in stile calligrafico",
      signTypeName: "Il tuo nome",
      signTypeStyle: "Stile",
      signTypeColor: "Colore",
      signTypeColors: "Nero|Blu",
      signTypeFontFail: "Non è stato possibile caricare lo stile calligrafico. Controlla la connessione oppure disegna la firma.",
      signPos: "Firma spostata: {0} da sinistra, {1} dall'alto.",
      signImgBad: "Impossibile leggere questa immagine. Usa un file PNG o JPG.",
      signPage: "Pagina {0} di {1}",
      signInfoOne: "1 file firmato",
      signInfoMany: "{0} file firmati",
      signImgBig: "Questa immagine è troppo grande. Usa una foto più piccola (fino a 25 MB).",
      signBrokeCert: "Nota: {0} aveva già una firma digitale basata su certificato. Quella firma non è più valida nella copia firmata.",
      excelCellsCut: "Alcune celle contenevano più testo di quanto Excel consenta (32.767 caratteri) e sono state troncate a quel limite.",
      nupWorking: "Disposizione delle pagine sui fogli…",
      nupInfo: "1 PDF, {0} pagine su {1} fogli",
      nupInfoSheet: "1 PDF, {0} pagine su 1 foglio",
      nupInfoPage: "1 PDF, 1 pagina su 1 foglio",
      nupInfoMany: "{0} PDF creati",
      nupFormNote: "In {0} non è stato possibile disegnare sui fogli il contenuto di alcuni campi del modulo.",
      imgTooBig: "Questa immagine è troppo grande ({0} megapixel). Usa un'immagine fino a {1} megapixel, oppure riducila prima.",
      certBroke: "Nota: {0} aveva una firma digitale basata su certificato. Quella firma non è più valida nella nuova copia.",
      jpgBigWarn: "Nota: queste immagini richiedono circa {0} di memoria, forse troppa per questo dispositivo. Se la pagina smette di rispondere, scegli un valore DPI più basso o meno pagine (per es. “1-20”).",
      jpgBigStop: "Queste immagini richiederebbero circa {0} di memoria, troppa per questo smartphone o tablet. Scegli un valore DPI più basso o meno pagine (per es. “1-20”)."
    }, pl: {
      remove: "Usuń {0}",
      last: "Ostatni krok — przygotowanie pliku do pobrania…",
      error: "Coś poszło nie tak. Spróbuj ponownie.",
      password: "Ten plik jest chroniony hasłem. Przetwórz go osobno, aby wpisać hasło, albo najpierw usuń hasło (np. narzędziem Odblokuj PDF w tym serwisie).",
      invalidPdf: "Nie udało się otworzyć tego pliku. Czy to prawidłowy PDF?",
      pageFailed: "przerwano na stronie {0} z {1}; dla tego pliku nie zapisano żadnego obrazu",
      noneProcessed: "Nie udało się przetworzyć żadnego z plików.",
      couldNot: "Nie udało się przetworzyć: {0}",
      extracting: "Wyodrębnianie stron…",
      extractNeed: "Wpisz co najmniej jeden prawidłowy numer strony (np. „1, 3-5”).",
      extractInfoOne: "Utworzono 1 plik",
      extractInfoMany: "Utworzono {0} {0#plik|pliki|plików}",
      watermarking: "Dodawanie znaku wodnego…",
      wmNeed: "Najpierw wpisz tekst znaku wodnego.",
      wmChars: "Tekst znaku wodnego zawiera znaki, których nie da się tu narysować (np. emoji lub rzadkie symbole). Działają litery dowolnego alfabetu, cyfry i popularne znaki interpunkcyjne.",
      wmFont: "Nie udało się wczytać czcionki dla tego alfabetu. Sprawdź połączenie z internetem i spróbuj ponownie.",
      wmInfoOne: "1 plik ze znakiem wodnym",
      wmInfoMany: "{0} {0#plik|pliki|plików} ze znakiem wodnym",
      wmImgNeed: "Najpierw wybierz obraz znaku wodnego (PNG lub JPG).",
      wmColor: "Kolor",
      wmColorOpts: "Szary|Czarny|Czerwony|Niebieski|Zielony",
      wmSize: "Rozmiar tekstu",
      wmSizeOpts: "Mały|Średni|Duży",
      wmOpacity: "Krycie",
      wmOpacityAuto: "Automatyczne",
      wmImgType: "Ten plik nie jest obrazem PNG ani JPG. Wybierz plik PNG lub JPG.",
      wmImgBig: "Ten obraz jest za duży. Użyj obrazu do {0} MB i {1} megapikseli.",
      wmImgBad: "Nie udało się odczytać tego obrazu (plik może być uszkodzony lub niekompletny). Zapisz go ponownie jako PNG lub JPG.",
      pct: "{0}%",
      building: "Tworzenie PDF…",
      imageN: "Obraz {0} z {1}…",
      imgUnsupported: "Twoja przeglądarka nie potrafi odczytać tego formatu obrazu. Użyj JPG lub PNG.",
      imgTruncated: "Ten obraz jest niekompletny (plik został ucięty, np. przez przerwane pobieranie). Zapisz go lub pobierz ponownie.",
      noImages: "Nie udało się odczytać żadnego obrazu. Użyj plików JPG lub PNG.",
      jpgpdfInfo: "1 PDF, {0} {0#strona|strony|stron}, {1}",
      jpgpdfInfoOne: "1 PDF, 1 strona, {0}",
      pjFormat: "Format obrazu",
      pjFormatOpts: "JPG (mniejsze pliki)|PNG (ostre, bezstratne)",
      jpgOrient: "Orientacja",
      jpgOrientOpts: "Automatyczna|Pionowa|Pozioma",
      jpgMargin: "Margines",
      jpgMarginOpts: "Brak|Mały (1 cm)|Duży (2 cm)",
      jpgEach: "Osobny PDF dla każdego obrazu",
      jpgEachInfo: "{0} PDF, po jednym na obraz",
      rendering: "Konwersja…",
      pageN: "Plik {0} z {1} — strona {2} z {3}…",
      pdfjpgInfoOne: "Utworzono 1 obraz",
      pdfjpgInfoMany: "Utworzono {0} {0#obraz|obrazy|obrazów}",
      protecting: "Dodawanie hasła…",
      unlocking: "Usuwanie hasła…",
      pwNeed: "Najpierw wpisz hasło.",
      pwMismatch: "Hasła nie są takie same. Wpisz dwa razy to samo hasło.",
      pwAlready: "Ten plik ma już hasło. Najpierw usuń je narzędziem Odblokuj PDF, a potem ustaw nowe.",
      protectInfoOne: "Zabezpieczono 1 plik (AES-256)",
      protectInfoMany: "Zabezpieczono {0} {0#plik|pliki|plików} (AES-256)",
      unlockNeed: "Ten plik wymaga hasła do otwarcia. Wpisz je w polu hasła.",
      unlockWrong: "To hasło nie pasuje do tego pliku.",
      unlockNone: "ten plik nie ma hasła",
      unlockInfoOne: "Odblokowano 1 plik",
      unlockInfoMany: "Odblokowano {0} {0#plik|pliki|plików}",
      noCrypto: "Twoja przeglądarka nie obsługuje potrzebnego szyfrowania. Użyj aktualnej przeglądarki.",
      pwTooLong: "To hasło jest za długie dla PDF. Użyj krótszego: do 127 zwykłych liter i cyfr (litery ze znakami diakrytycznymi, symbole i inne alfabety liczą się podwójnie lub potrójnie).",
      protectDamaged: "Ten PDF ma uszkodzone części, których nie da się bezpiecznie zaszyfrować, więc nie został zabezpieczony. Zapisz go ponownie w czytniku PDF (np. drukując do PDF) i spróbuj jeszcze raz.",
      excelWorking: "Konwersja na Excel…",
      excelInfoOne: "1 plik Excel",
      excelInfoMany: "{0} {0#plik|pliki|plików} Excel",
      excelCounts: "arkusze: {0}, znalezione tabele: {1}",
      excelNoTables: "Nie rozpoznano żadnej tabeli, więc tekst trafił do arkuszy wiersz po wierszu. Tabeli, która w PDF jest obrazem (skan, zrzut ekranu), nie da się odczytać jako tekstu.",
      excelNoText: "Ten PDF nie ma tekstu do odczytania (prawdopodobnie to skan lub zdjęcie), więc nie ma czego umieścić w arkuszu kalkulacyjnym.",
      sheetPage: "Strona {0}",
      sheetAll: "Wszystkie strony",
      signing: "Podpisywanie…",
      signNeed: "Najpierw utwórz podpis: narysuj go w polu albo wybierz obraz podpisu.",
      signType: "Wpisz",
      signTypeHint: "Twoje imię i nazwisko odręcznym pismem",
      signTypeName: "Imię i nazwisko",
      signTypeStyle: "Styl",
      signTypeColor: "Kolor",
      signTypeColors: "Czarny|Niebieski",
      signTypeFontFail: "Nie udało się wczytać stylu pisma. Sprawdź połączenie albo narysuj podpis.",
      signPos: "Podpis przesunięty: {0} od lewej, {1} od góry.",
      signImgBad: "Nie udało się odczytać tego obrazu. Użyj pliku PNG lub JPG.",
      signPage: "Strona {0} z {1}",
      signInfoOne: "Podpisano 1 plik",
      signInfoMany: "Podpisano {0} {0#plik|pliki|plików}",
      signImgBig: "Ten obraz jest za duży. Użyj mniejszego zdjęcia (do 25 MB).",
      signBrokeCert: "Uwaga: {0} miał już podpis cyfrowy oparty na certyfikacie. W podpisanej kopii ten podpis nie jest już ważny.",
      excelCellsCut: "Niektóre komórki zawierały więcej tekstu, niż pozwala Excel (32 767 znaków), i zostały do tego limitu skrócone.",
      nupWorking: "Rozmieszczanie stron na arkuszach…",
      nupInfo: "1 PDF, {0} {0#strona|strony|stron} na {1} {1#arkuszu|arkuszach|arkuszach}",
      nupInfoSheet: "1 PDF, {0} {0#strona|strony|stron} na 1 arkuszu",
      nupInfoPage: "1 PDF, 1 strona na 1 arkuszu",
      nupInfoMany: "Utworzono {0} {0#plik|pliki|plików} PDF",
      nupFormNote: "W {0} nie udało się narysować na arkuszach zawartości niektórych pól formularza.",
      imgTooBig: "Ten obraz jest za duży ({0} megapikseli). Użyj obrazu do {1} megapikseli albo najpierw go zmniejsz.",
      certBroke: "Uwaga: {0} miał podpis cyfrowy oparty na certyfikacie. W nowej kopii ten podpis nie jest już ważny.",
      jpgBigWarn: "Uwaga: te obrazy wymagają ok. {0} pamięci, może za dużo dla tego urządzenia. Jeśli strona przestanie reagować, wybierz niższe DPI lub mniej stron (np. „1-20”).",
      jpgBigStop: "Te obrazy wymagałyby ok. {0} pamięci, za dużo dla tego smartfona lub tabletu. Wybierz niższe DPI lub mniej stron (np. „1-20”)."
    }
  };
  var M = MSG[LANG] || MSG.en;
  function t(key){
    var s = M[key] != null ? M[key] : MSG.en[key];
    return pcFill.apply(null, [s].concat(Array.prototype.slice.call(arguments, 1))); // (v98) one pass, see app.js
  }
  /* (v73) What the visitor reads when a step fails: the message meant for
     them, else a full memory (not a broken file), else the tool's own text. */
  function reasonOf(err, key){
    pcNotePassword(err); // (v119) the status box then asks for the password
    if(err && err.userFacing) return err.message;
    var readFail = pcReadFailureMessage(err); // (v89) also a file that is gone
    if(readFail) return readFail;
    return t(key);
  }
  function userError(key){
    var e = new Error(t.apply(null, arguments));
    e.userFacing = true;
    if(key === 'password') e.pw = true; // (v119) see pcNotePassword
    return e;
  }
  /* (v90) A full memory (or a file that is gone) as itself, anything else as the tool's own message. */
  function memoryOr(err, key){
    var readFail = pcReadFailureMessage(err);
    return readFail ? pcUserError(readFail) : userError(key);
  }
  /* (v55) an error in what the visitor typed (see pcMarkField, app.js) */
  function fieldError(){
    var e = userError.apply(null, arguments);
    e.field = true;
    return e;
  }
  var $ = function(id){ return document.getElementById(id); };

  /* Shared wiring for one tool panel: pcSetupTool (app.js, v140), with
     this file's working message and its own text for a failed run. */
  function setupTool(name, opts){
    return pcSetupTool(name, Object.assign({}, opts, {
      working: opts.working || function(){ return t(opts.workingKey); }, // (v147) a tool in its own file brings its own text
      reason: function(err){ return reasonOf(err, 'error'); },
      // (v143) a password typed at the preview is used for this run, then forgotten
      run: async function(list, opt, ctx){
        var pw = pcHostPassword() ? '' : runPreviewPassword(list);
        if(pw) pcSetTypedPassword(pw);
        var out;
        try{ out = await opts.run(list, opt, ctx); }
        catch(e){
          // a check before the work (no signature yet, a page field) keeps it; a wrong password or Cancel doesn't
          if(pcIsCancel(e) || isPasswordError(e)) list.forEach(forgetPreviewPassword);
          throw e;
        }
        list.forEach(forgetPreviewPassword);
        return out;
      }
    }));
  }

  var isPdf = function(f){ return f.type === 'application/pdf' || /\.pdf$/i.test(f.name); };

  /* (v143) A preview of a password-protected PDF (Sign, Crop, Organize,
     Metadata) asks for the password itself, under its message, instead of
     "remove the password first". The password stays in this page's memory
     for that file (previewPw) until a run with that file ends: then it is
     forgotten, as the run's own password is (v119). A preview that is open
     stays open. */
  var previewPw = new WeakMap();
  function previewPassword(file){ return (file && previewPw.get(file)) || ''; }
  function forgetPreviewPassword(file){
    // (v147) only a password given here: one typed at a page picker (pc-thumbs.js) stays with its previews
    if(!previewPw.delete(file)) return;
    if(window.PCThumbs) window.PCThumbs.setPassword(file, '');
  }
  /* Only when every file of the run had the same password given at a preview:
     a protected file nobody typed a password for is asked for in the status box,
     never tried with another file's password (v119). */
  function runPreviewPassword(list){
    var pws = list.map(previewPassword);
    return pws.length && pws.every(function(p){ return p && p === pws[0]; }) ? pws[0] : '';
  }
  function isPasswordError(e){ return !!(e && (e.name === 'PasswordException' || e.pw)); }
  function clearPreviewPassword(name){ var b = $('pc-pvw-' + name); if(b) b.remove(); }
  /* The message in msgEl, the field right after it. wrong: the password
     given for this file did not open it. reopen(file) runs on submit. */
  function askPreviewPassword(name, msgEl, file, wrong, reopen, focusEl){
    clearPreviewPassword(name);
    if(wrong) forgetPreviewPassword(file);
    showPreviewMsg(msgEl, pcT(wrong ? 'pwWrong' : 'pwAsk'));
    var box = document.createElement('div');
    box.className = 'pc-pw'; box.id = 'pc-pvw-' + name;
    var label = document.createElement('label');
    label.htmlFor = 'pc-pvw-in-' + name;
    label.textContent = pcT('pwLabel');
    var input = document.createElement('input');
    Object.assign(input, { type: 'password', id: 'pc-pvw-in-' + name, autocomplete: 'off', spellcheck: false, className: 'text-input' });
    if(msgEl.id) input.setAttribute('aria-describedby', msgEl.id);
    if(wrong) input.setAttribute('aria-invalid', 'true');
    var go = document.createElement('button');
    go.type = 'button'; go.className = 'btn'; go.textContent = pcT('pwRetry');
    var submit = function(){
      if(!input.value){ pcAnnounce(pcT('pwAsk'), true); input.focus(); return; }
      previewPw.set(file, input.value);
      if(window.PCThumbs) window.PCThumbs.setPassword(file, input.value);
      // the field goes: the focus moves to the preview's title instead of falling to the page
      if(focusEl){ if(!focusEl.hasAttribute('tabindex')) focusEl.setAttribute('tabindex', '-1'); focusEl.focus(); }
      box.remove();
      reopen(file);
    };
    go.addEventListener('click', submit);
    input.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); submit(); } });
    box.append(label, input, go);
    msgEl.insertAdjacentElement('afterend', box);
    if(wrong) input.focus();
  }

  /* Runs `fn` for every file; a file that fails is skipped (with its
     reason) instead of stopping the whole batch - same behavior as the
     existing Split/Rotate/Delete tools. */
  async function eachFile(files, ctx, fn){
    var results = [], skipped = [], fieldHit = false;
    for(var i = 0; i < files.length; i++){
      pcCheckCancel();
      // (v143) a file whose preview was given a password opens with that one, also in a list with other files
      var own = previewPassword(files[i]), before = pcHostPassword();
      if(own) pcSetTypedPassword(own);
      try{
        var r = await fn(files[i], i);
        results.push.apply(results, Array.isArray(r) ? r : [r]);
      }catch(err){
        if(pcIsCancel(err)) throw err;
        pcLogUnexpected(err); // (v89) only real faults: not a password, a cancel or a file that is gone
        if(err && err.field) fieldHit = true;
        var why = reasonOf(err, 'invalidPdf');
        skipped.push(files[i].name + ' (' + why + ')');
      }finally{
        if(own) pcSetTypedPassword(before);
      }
      ctx.setProgress((i + 1) / files.length);
    }
    if(!results.length){
      var e = files.length === 1 && skipped.length ? userError('couldNot', skipped[0]) : userError('couldNot', skipped.join(', ') || t('noneProcessed'));
      e.field = fieldHit;
      throw e;
    }
    return { results: results, skipped: skipped };
  }

  /* v47: openPdfForEdit (app.part5.js) decrypts files that only have an
     owner password; they used to come out blank or unreadable. The names of
     such files are collected for a note under the result. */
  var decryptedNames = [];
  async function loadPdfLib(file){
    var bytes = new Uint8Array(await file.arrayBuffer());
    var r;
    try{
      r = await openPdfForEdit(bytes);
    }catch(e){
      if(pcIsCancel(e)) throw e;
      if(e && e.userFacing) throw e; // (v55) e.g. an incomplete (cut-off) PDF: its own message
      pcThrowIfOutOfMemory(e); // (v73) a full memory is not a broken file
      pcLogUnexpected(e); throw (e && e.userFacing) ? e : userError(e && e.name === 'PasswordException' ? 'password' : 'invalidPdf');
    }
    noteOpened(file, r);
    return r.doc;
  }
  /* (v90) Every tool here writes the whole PDF again, which makes a
     certificate-based digital signature invalid: those files are named in a
     note too (hasCertificateSignature, pc-pdfcore.js). */
  var certSigned = [];
  var xfaDropped = []; // (v94) hybrid XFA forms whose XFA part an assembled result leaves out
  function noteName(list, file){ if(list.indexOf(file.name) < 0) list.push(file.name); }
  function noteCertificate(file, doc){ if(hasCertificateSignature(doc)) noteName(certSigned, file); }
  function noteOpened(file, r){
    if(r.decrypted) noteName(decryptedNames, file);
    noteCertificate(file, r.doc);
  }
  function resetNotes(){ decryptedNames = []; certSigned = []; xfaDropped = []; }
  /* (perf) The notes a job in the worker reports (pc-pdfcore.js: pcMoreFlags), as noteOpened would. */
  function noteJob(file, r){
    if(r.decrypted) noteName(decryptedNames, file);
    if(r.certSigned) noteName(certSigned, file);
    if(r.xfaHybrid) noteName(xfaDropped, file);
  }
  /* The texts a job uses for a file it can't open (as loadPdfLib), plus extra ones. */
  function jobMsgs(extra){ return Object.assign({ password: t('password'), invalid: t('invalidPdf') }, extra); }
  /* The notes collected since resetNotes(); certKey: the tool's own wording. */
  function takeNotes(certKey){
    var n = [decryptedNames.length ? pcT('ownerNote', decryptedNames.join(', ')) : '',
      certSigned.length ? t(certKey || 'certBroke', certSigned.join(', ')) : '',
      xfaDropped.length ? pcT('xfaHybridNote', xfaDropped.join(', ')) : ''].filter(Boolean).join(' ');
    resetNotes();
    return n;
  }
  function pdfBlob(bytes){ return new Blob([bytes], { type: 'application/pdf' }); }

  /* "3, 1, 5-7" -> unique page numbers, IN THE ORDER TYPED (v47; before,
     they were always sorted, so "3,1,2" couldn't reorder). "5-" means page 5
     to the end, "-3" pages 1 to 3, "7-5" counts down. Stray commas are fine;
     a typo or a missing page is a translated error (v55).
     (v56) One parser for all tools, in app.js (pcParsePageSpec,
     pcResolvePageSpec), with its messages in PC_MSG. */
  function resolvePages(spec, total){ return pcResolvePageSpec(spec, total, true); }
  function parsePages(str, total){ return resolvePages(pcParsePageSpec(str), total); }

  /* ---------- EXTRACT PAGES ---------- */
  pcOnPanel('extract', function(){ setupTool('extract', {
    accept: isPdf, optionsId: 'extract-mode-options', workingKey: 'extracting', zipName: 'extracted-pages', fieldId: 'extract-pages',
    run: async function(files, mode, ctx){
      var spec = pcParsePageSpec(($('extract-pages') || {}).value || '');
      if(!spec.length) throw fieldError('extractNeed');
      resetNotes();
      var opt = { spec: spec, mode: mode, msgs: jobMsgs() };
      var out = await eachFile(files, ctx, async function(file){
        var r = await ctx.worker.run('extractPdf', file, opt); // (perf) in the worker (pcExtractPdfFile, pc-pdfcore.js)
        noteJob(file, r);
        return r.results;
      });
      out.info = out.results.length === 1 ? t('extractInfoOne') : t('extractInfoMany', out.results.length);
      out.note = takeNotes();
      return out;
    }
  }); });

  /* ---------- WATERMARK ---------- */
  /* Existing page content is wrapped in q ... Q first (pcWrapContent,
     pc-pdfcore.js), so a PDF whose own content stream leaves a
     transformation or color changed at the end can't shift, scale or
     recolor the watermark drawn after it. */
  /* v47: text the standard PDF font can't write (Greek, Cyrillic, Polish,
     Czech, Vietnamese, Hebrew, Arabic, Chinese, Japanese, Korean ...) is
     drawn as the letter SHAPES of a Noto Sans font, loaded only when needed.
     (v55) fontkit and the fonts are hosted on this site under /vendor/, so no
     outside server learns which alphabet someone types; the service worker
     keeps them for offline use. fontkit shapes Arabic and puts Hebrew/Arabic
     right to left. No font is embedded, so the file hardly grows.
     Painter = { widthAt1, glyphOps(fontName), fontRef? } (see wmGlyphForm).
     Each entry: [path under WM_FONT_DIR, sha384 of that exact file]. The files
     are byte-identical to @expo-google-fonts/<name>@<version> on npm. */
  var WM_FONT_DIR = '/vendor/fonts/';
  var WM_FONTS = {
    latin: ['noto-sans-0.4.2/NotoSans_700Bold.ttf', 'sha384-DIObf0+zbFhmQJdO1thMYSdf42enWQcfXw1TzQF/HQwQJV8eD5lw54VgeI6l6qxk'],
    hebrew: ['noto-sans-hebrew-0.4.1/NotoSansHebrew_700Bold.ttf', 'sha384-t0Mn5d8Ks03R36ewp9Fq+XGrh0le3wR3OZ4zISs9GSjWHymQS0MagmX11qurf2Ke'],
    arabic: ['noto-sans-arabic-0.4.3/NotoSansArabic_700Bold.ttf', 'sha384-ATsgwNNrARMqloKg8T/7A+SMS9bIsNW1yEum/B4EwY/cC0aDUyuVcXQ347sfZ7H1'],
    jp: ['noto-sans-jp-0.4.3/NotoSansJP_700Bold.ttf', 'sha384-4S65zAFbR4Kt7/9mi1Yidq4vIFzk5wXmcSlYLpIDpZUdgI59Ze5nnasLv8lcoD8o'],
    kr: ['noto-sans-kr-0.4.3/NotoSansKR_700Bold.ttf', 'sha384-9PCFPnYsspXo1pAu88kOjI8ofvrmbqWf+ffdRV+HLmRnCAy2FZ3GMJlu5CaABpKv'],
    sc: ['noto-sans-sc-0.4.3/NotoSansSC_700Bold.ttf', 'sha384-Wx/p7sGJ1x2WU7vsrYt4Wv1gMg3myUZzQ9SU+S6x32OF2DY+3P/Nru35AzaT7CUN'],
    // (v51) fallbacks for what the letter fonts lack: math symbols and
    // arrows (Σ, ≤, √, ∫, →), check marks, stars and other dingbats
    math: ['noto-sans-math-0.4.2/NotoSansMath_400Regular.ttf', 'sha384-PUejd/mZ2B8/uouW7QMlokt1CnIdekMiPy8rp486iUEviucioBs05o7Z2LTlk0zy'],
    sym2: ['noto-sans-symbols-2-0.4.1/NotoSansSymbols2_400Regular.ttf', 'sha384-pw/3UZ4pUDnGRZQ0FUlgZ9A6ggg+5nP53LEJtF9xg6V5IKXS8n5fOupia1RLaEYc']
  };
  var WM_FALLBACK_KEYS = ['math', 'sym2'];
  var FONTKIT_URL = '/vendor/fontkit-1.1.1/fontkit.umd.min.js'; // = @pdf-lib/fontkit@1.1.1/dist/fontkit.umd.min.js
  var FONTKIT_SRI = 'sha384-2p6U+1mmqF10USehFeRiyG2ESG9FwIqN+jxULn5w9jjQIihSn9Pt13dVCn/Hawjn';
  var wmFontCache = {};
  function loadFontkit(){
    return new Promise(function(res, rej){
      if(window.fontkit) return res();
      var sc = document.createElement('script');
      sc.src = FONTKIT_URL;
      // (v48) Subresource Integrity: the browser refuses anything but this
      // exact, pinned file (also against a damaged or stale cached copy).
      sc.integrity = FONTKIT_SRI;
      sc.crossOrigin = 'anonymous';
      sc.onload = function(){ res(); };
      sc.onerror = function(){ sc.remove(); rej(new Error('fontkit could not be loaded')); };
      document.head.appendChild(sc);
    });
  }
  /* (v98) The first time any of these fonts is needed, ALL of them are
     fetched (±25 MB, once: the service worker and the browser cache keep
     them). Fetching only the one the text needs told our server's log the
     watermark's alphabet ("NotoSansJP" = Japanese text). Now the server
     only learns "a watermark the standard font can't write" -- as fontkit's
     own request already did. Only the fonts the text needs are parsed. */
  var WM_FONT_SET_KEEP_MS = 60000; // the files of one round stay at hand for the next watermark
  var wmFontSet = null; // {key: Promise<Blob>} of the current round
  function wmFetchFont(key){
    var entry = WM_FONTS[key];
    // integrity: fetch() rejects a file that isn't byte-for-byte this font
    return fetch(WM_FONT_DIR + entry[0], { integrity: entry[1] }).then(function(resp){
      if(!resp.ok) throw new Error('font ' + key + ': HTTP ' + resp.status);
      return resp.blob();
    });
  }
  /* (v98) One round = all fonts requested at once. Each has its own promise:
     the watermark waits only for the fonts its text needs, and a font it
     doesn't need can fail without failing the job. A minute after the round
     the files are let go (memory on phones); a later round asks for all of
     them again, normally from the cache, so the request pattern stays the same. */
  function wmStartFontSet(){
    var set = {};
    Object.keys(WM_FONTS).forEach(function(k){
      set[k] = wmFetchFont(k);
    });
    wmFontSet = set;
    // only to know when the round is over: a font the text needs is awaited, and its error reported, in wmFont
    Promise.all(Object.keys(set).map(function(k){ return set[k].catch(function(){ return null; }); })).then(function(){
      setTimeout(function(){ if(wmFontSet === set) wmFontSet = null; }, WM_FONT_SET_KEEP_MS);
    });
    return set;
  }
  /* (v147) The file (Blob) of one font of the round; Fill embeds it. */
  async function wmFontFile(key){
    await loadFontkit();
    var set = wmFontSet || wmStartFontSet();
    try{ return await set[key]; }
    catch(err){ if(wmFontSet === set) wmFontSet = null; throw err; } // the next watermark starts a new round
  }
  async function wmFont(key){
    if(wmFontCache[key]) return wmFontCache[key];
    var file = await wmFontFile(key);
    var font = window.fontkit.create(new Uint8Array(await file.arrayBuffer()));
    wmFontCache[key] = font;
    return font;
  }
  function scriptKey(ch, textHasKana, textHasHangul){
    var c = ch.codePointAt(0);
    if(c >= 0x0590 && c <= 0x05FF || c >= 0xFB1D && c <= 0xFB4F) return 'hebrew';
    if(c >= 0x0600 && c <= 0x08FF || c >= 0xFB50 && c <= 0xFDFF || c >= 0xFE70 && c <= 0xFEFF) return 'arabic';
    if(c >= 0xAC00 && c <= 0xD7AF || c >= 0x1100 && c <= 0x11FF || c >= 0x3130 && c <= 0x318F) return 'kr';
    if(c >= 0x3040 && c <= 0x30FF) return 'jp';
    if(c >= 0x3000 && c <= 0x303F || c >= 0x3400 && c <= 0x9FFF || c >= 0xF900 && c <= 0xFAFF || c >= 0xFF00 && c <= 0xFFEF) return textHasKana ? 'jp' : textHasHangul ? 'kr' : 'sc';
    if(/[\s0-9.,:;!?'"()\-–—\/&%+*#@]/.test(ch)) return null; // neutral: joins its neighbours
    return 'latin';
  }
  /* (v90) Numbers inside Hebrew or Arabic text stay left to right ("סודי 2024",
     not "4202"): fontkit turns a whole right-to-left run around, digits
     included, so each number is laid out on its own and only the order of
     the pieces is reversed. */
  var WM_DIGIT = '[0-9\u0660-\u0669\u06F0-\u06F9]';
  // (v90) separators and signs that stay inside a number (2023-2024, 1/2, 10+5, 50%, $3)
  var WM_NUMBER_RE = new RegExp('[$#]?' + WM_DIGIT + '+(?:[.,:+\\-/\u00a0]' + WM_DIGIT + '+)*[%\u2030\u00b0]?', 'g');
  function isRtlKey(key){ return key === 'hebrew' || key === 'arabic'; }
  function firstStrongIsRtl(text){
    var chars = Array.from(text.replace(WM_NUMBER_RE, ''));
    for(var i = 0; i < chars.length; i++){
      var k = scriptKey(chars[i], false, false);
      if(k) return isRtlKey(k);
    }
    return false;
  }
  function layoutRtlRun(font, text){
    var pieces = [], at = 0, m;
    WM_NUMBER_RE.lastIndex = 0;
    while((m = WM_NUMBER_RE.exec(text))){
      if(m.index > at) pieces.push(font.layout(text.slice(at, m.index)));
      pieces.push(font.layout(m[0], [], undefined, undefined, 'ltr'));
      at = m.index + m[0].length;
    }
    if(at < text.length) pieces.push(font.layout(text.slice(at)));
    pieces.reverse(); // the run is shown right to left: its last piece comes first
    return {
      glyphs: [].concat.apply([], pieces.map(function(p){ return p.glyphs; })),
      positions: [].concat.apply([], pieces.map(function(p){ return p.positions; }))
    };
  }
  async function makePathPainter(text, color){
    color = color || WM_COLORS.grey; // (v157) the chosen colour, per run
    var shape = await wmTextPath(text), path = shape.path;
    return {
      widthAt1: shape.widthAt1,
      // the letter shapes at size WM_TEXT.UNIT, lower left at (0, 0)
      glyphOps: function(){
        return PDFLib.drawSvgPath(path, { x: 0, y: 0, scale: WM_TEXT.UNIT / 1000, color: PDFLib.rgb(color[0], color[1], color[2]), borderWidth: 0 });
      }
    };
  }
  /* (v147) The letter shapes of `text` as one SVG path (1 unit = 1/1000 of
     the font size, y down, baseline at 0) and its width at size 1. Also used
     by Fill for text no single embedded font can write. */
  async function wmTextPath(text){
    var hasKana = /[\u3040-\u30FF]/.test(text), hasHangul = /[\uAC00-\uD7AF]/.test(text);
    // split into runs per font; neutral characters stay with the run before
    var runs = [];
    Array.from(text).forEach(function(ch){
      var k = scriptKey(ch, hasKana, hasHangul);
      var last = runs[runs.length - 1];
      if(!last || (k && last.key && k !== last.key)) runs.push({ key: k, text: ch });
      else { last.text += ch; if(!last.key) last.key = k; }
    });
    runs.forEach(function(r){ if(!r.key) r.key = 'latin'; });
    // (v51) A character the run's font doesn't have goes to the first
    // fallback font that does (math symbols, dingbats), as its own run.
    var split = [];
    for(var r0 = 0; r0 < runs.length; r0++){
      var base = await wmFont(runs[r0].key);
      var chars = Array.from(runs[r0].text);
      for(var c0 = 0; c0 < chars.length; c0++){
        var ch0 = chars[c0], key0 = runs[r0].key;
        if(!/\s/.test(ch0) && !base.hasGlyphForCodePoint(ch0.codePointAt(0))){
          key0 = null;
          for(var f0 = 0; f0 < WM_FALLBACK_KEYS.length && !key0; f0++){
            var fb = await wmFont(WM_FALLBACK_KEYS[f0]);
            if(fb.hasGlyphForCodePoint(ch0.codePointAt(0))) key0 = WM_FALLBACK_KEYS[f0];
          }
          if(!key0) throw Object.assign(userError('wmChars'), { chars: true }); // (v147) chars: Fill says it in its own words
        }
        var lastS = split[split.length - 1];
        if(lastS && lastS.key === key0) lastS.text += ch0; else split.push({ key: key0, text: ch0 });
      }
    }
    // (v97) the spaces between two runs are a run of their own: kept at the
    // end of a right-to-left run inside left-to-right text (or the other way
    // round) they stood on the wrong side of it ("Draft  ידוסcopy")
    runs = [];
    split.forEach(function(r, k){
      var m = k < split.length - 1 ? /\s+$/.exec(r.text) : null;
      if(!m || m.index === 0){ runs.push(r); return; }
      runs.push({ key: r.key, text: r.text.slice(0, m.index) }, { key: r.key, text: m[0] });
    });
    var laid = [];
    for(var i = 0; i < runs.length; i++){
      var font = await wmFont(runs[i].key);
      Array.from(runs[i].text).forEach(function(ch){
        if(/\s/.test(ch)) return;
        if(!font.hasGlyphForCodePoint(ch.codePointAt(0))) throw Object.assign(userError('wmChars'), { chars: true }); // (v147) chars: Fill says it in its own words
      });
      var rtl = isRtlKey(runs[i].key);
      var gr = rtl ? layoutRtlRun(font, runs[i].text) : font.layout(runs[i].text);
      laid.push({ font: font, glyphs: gr.glyphs, positions: gr.positions, rtl: rtl });
    }
    // right-to-left text: the order of the runs is reversed as a whole.
    // (v90) The text's direction is that of its first letter (Unicode bidi),
    // not "more right-to-left runs than left-to-right ones".
    if(firstStrongIsRtl(text)){
      laid.reverse();
    }
    // one path in "1 unit = 1/1000 of the font size", y pointing down (SVG)
    var d = [], x = 0;
    laid.forEach(function(l){
      var s = 1000 / l.font.unitsPerEm;
      l.glyphs.forEach(function(g, gi){
        var pos = l.positions[gi];
        var ox = x + pos.xOffset * s, oy = pos.yOffset * s;
        g.path.commands.forEach(function(c){
          var a = c.args, P = function(j){ return (ox + a[j] * s).toFixed(1) + ' ' + (-(oy + a[j + 1] * s)).toFixed(1); };
          if(c.command === 'moveTo') d.push('M' + P(0));
          else if(c.command === 'lineTo') d.push('L' + P(0));
          else if(c.command === 'quadraticCurveTo') d.push('Q' + P(0) + ' ' + P(2));
          else if(c.command === 'bezierCurveTo') d.push('C' + P(0) + ' ' + P(2) + ' ' + P(4));
          else if(c.command === 'closePath') d.push('Z');
        });
        x += pos.xAdvance * s;
      });
    });
    return { path: d.join(' '), widthAt1: x / 1000 };
  }
  function helveticaPainter(font, text, color){
    color = color || WM_COLORS.grey;
    return {
      widthAt1: font.widthOfTextAtSize(text, 1),
      glyphOps: function(fontName){
        return PDFLib.drawText(font.encodeText(text), { x: 0, y: 0, size: WM_TEXT.UNIT, font: fontName, color: PDFLib.rgb(color[0], color[1], color[2]), rotate: PDFLib.degrees(0), xSkew: PDFLib.degrees(0), ySkew: PDFLib.degrees(0) });
      },
      fontRef: font.ref
    };
  }
  /* (v65) The watermark used to be drawn tile by tile straight onto every
     page, each tile with its own transparency object (and, for letter
     shapes, its own copy of the whole outline): 250 pages with repeated
     text grew from 123 KB to 18.7 MB. Now the text is written ONCE per PDF
     as a small drawing (the "glyph" form), every page layout (page size,
     crop box, rotation) is drawn ONCE as a second form that places that
     glyph where the tiles go, and every page of that layout only refers to
     it. Same look, same positions, same transparency as before. */
  // (v157) chosen colour, size factor and opacity of the text watermark (set at the start of a run)
  var WM_COLORS = { grey: [0.55, 0.55, 0.55], black: [0, 0, 0], red: [0.8, 0.1, 0.1], blue: [0.1, 0.25, 0.7], green: [0.1, 0.5, 0.2] };
  var WM_SIZE = { small: 0.6, medium: 1, large: 1.4 };
  var WM_TEXT = {
    UNIT: 100,                              // the glyph form is drawn at this size
    FIT: 0.8,                               // (v157) a larger chosen size still stays within this share of the width/diagonal
    GRAY: 0.55,                             // fill colour of the text (PDFLib.rgb at draw time: the library loads lazily)
    MATRIX_DECIMALS: 100000,                // tile scale factors are small (size / UNIT)
    TILE_ANGLE: 30,                         // degrees, as the reader sees it
    OPACITY: { horizontal: 0.25, tiled: 0.18, diagonal: 0.22 },
    // room around the letters, in text sizes: the fonts' own bounding boxes
    // reach far (Noto Sans Math -2.55..3.1 em, CJK -1.05..1.81 em), and a
    // form draws nothing outside its box, so this is generous on purpose
    PAD_X: 1, PAD_BELOW: 3, PAD_ABOVE: 3.5,
    // text size per style, in pt: [min, max], the share of the page width the
    // text may fill and the share of the (shortest) page side as a cap
    HORIZONTAL: { MIN: 8, MAX: 160, WIDTH_SHARE: 0.8, SIDE_SHARE: 0.25 },
    DIAGONAL: { MIN: 8, MAX: 200, DIAG_SHARE: 0.7, SIDE_SHARE: 0.3 },
    TILED: { MIN: 10, MAX: 48, WIDTH_SHARE: 0.4, SIDE_SHARE: 0.07,
      GAP_EMS: 3,     // gap between two tiles along the text, in text sizes
      ROW_EMS: 4 }    // distance between rows, in text sizes
  };
  function wmGlyphForm(doc, painter){
    var U = WM_TEXT.UNIT, resources = {};
    if(painter.fontRef) resources.Font = { F0: painter.fontRef };
    var ops = painter.glyphOps('F0');
    var bbox = [-WM_TEXT.PAD_X * U, -WM_TEXT.PAD_BELOW * U, painter.widthAt1 * U + WM_TEXT.PAD_X * U, WM_TEXT.PAD_ABOVE * U];
    return doc.context.register(doc.context.formXObject(ops, { BBox: doc.context.obj(bbox), Resources: doc.context.obj(resources) }));
  }
  /* Centre, size and angle (as the reader sees it) of every tile of one layout. */
  function textSpots(f, style, fontSizeAt1, k){
    k = k || 1; // (v157) the chosen text size
    var box = f.box, cx = box.x + box.width / 2, cy = box.y + box.height / 2, vw = f.vw, vh = f.vh;
    if(style === 'horizontal'){
      var H = WM_TEXT.HORIZONTAL;
      return [{ x: cx, y: cy, size: Math.min(k * Math.max(H.MIN, Math.min((vw * H.WIDTH_SHARE) / fontSizeAt1, vh * H.SIDE_SHARE, H.MAX)), vw * WM_TEXT.FIT / fontSizeAt1), deg: 0 }];
    }
    if(style !== 'tiled'){
      var D = WM_TEXT.DIAGONAL, d = Math.sqrt(vw * vw + vh * vh);
      return [{ x: cx, y: cy, size: Math.min(k * Math.max(D.MIN, Math.min((d * D.DIAG_SHARE) / fontSizeAt1, Math.min(vw, vh) * D.SIDE_SHARE, D.MAX)), d * WM_TEXT.FIT / fontSizeAt1), deg: Math.atan2(vh, vw) * 180 / Math.PI }];
    }
    var T = WM_TEXT.TILED;
    var sizeT = k * Math.max(T.MIN, Math.min(Math.min(vw, vh) * T.SIDE_SHARE, (vw * T.WIDTH_SHARE) / fontSizeAt1, T.MAX));
    // Tiles are laid out on a grid that is itself turned by the text
    // angle: along the text direction one text length plus a gap apart,
    // and rows a fixed distance apart across it, so no two tiles can
    // ever touch (every other row shifted by half a step).
    var ang = (WM_TEXT.TILE_ANGLE + f.rot) * Math.PI / 180;
    var ux = Math.cos(ang), uy = Math.sin(ang), wx = -uy, wy = ux;
    var along = fontSizeAt1 * sizeT + sizeT * T.GAP_EMS, across = sizeT * T.ROW_EMS;
    var diag = Math.sqrt(box.width * box.width + box.height * box.height);
    var ni = Math.ceil(diag / along) + 1, nj = Math.ceil(diag / across) + 1, spots = [];
    for(var j = -nj; j <= nj; j++){
      for(var i = -ni; i <= ni; i++){
        var o = i + (j % 2 ? 0.5 : 0);
        var px = cx + o * along * ux + j * across * wx, py = cy + o * along * uy + j * across * wy;
        if(px < box.x - along || px > box.x + box.width + along || py < box.y - along || py > box.y + box.height + along) continue;
        spots.push({ x: px, y: py, size: sizeT, deg: WM_TEXT.TILE_ANGLE });
      }
    }
    return spots;
  }
  /* One tile: the glyph form scaled to `size`, turned by `deg` (page
     coordinates) and centred on (x, y); the height of capital letters
     (0.7 of the size) is what is centred vertically. */
  function textTileOps(name, spot, fontSizeAt1, deg){
    var rad = deg * Math.PI / 180, cos = Math.cos(rad), sin = Math.sin(rad);
    var w = fontSizeAt1 * spot.size, h = spot.size * 0.7, k = spot.size / WM_TEXT.UNIT;
    var x = spot.x - (w / 2) * cos + (h / 2) * sin;
    var y = spot.y - (w / 2) * sin - (h / 2) * cos;
    var r = function(v){ return Math.round(v * WM_TEXT.MATRIX_DECIMALS) / WM_TEXT.MATRIX_DECIMALS; };
    return [PDFLib.pushGraphicsState(),
      PDFLib.concatTransformationMatrix(r(k * cos), r(k * sin), r(-k * sin), r(k * cos), r(x), r(y)),
      PDFLib.drawObject(name), PDFLib.popGraphicsState()];
  }
  /* The form with all tiles of one page layout, made once and reused by
     every page with the same crop box and rotation. `tiles(f)` returns the
     operators of the tiles; `resources` names what they use. */
  function wmLayoutForm(doc, cache, page, key, gsRef, resources, tiles){
    var f = pcVisualFrame(page), b = f.box;
    var k = [key, b.x, b.y, b.width, b.height, f.rot].join('|');
    if(cache.has(k)) return cache.get(k);
    var ops = [PDFLib.setGraphicsState('G0')].concat(tiles(f));
    var dict = Object.assign({ ExtGState: { G0: gsRef } }, resources);
    var ref = doc.context.register(doc.context.formXObject(ops, {
      BBox: doc.context.obj([b.x, b.y, b.x + b.width, b.y + b.height]), Resources: doc.context.obj(dict)
    }));
    cache.set(k, ref);
    return ref;
  }
  /* Puts a layout form on one page, after its own (wrapped) content. */
  function wmPlaceForm(doc, page, formRef){
    pcWrapContent(doc, page);
    var name = page.node.newXObject('Wm', formRef);
    page.pushOperators(PDFLib.pushGraphicsState(), PDFLib.drawObject(name), PDFLib.popGraphicsState());
  }
  function wmOpacityState(doc, opacity){
    return doc.context.register(doc.context.obj({ Type: 'ExtGState', ca: opacity, CA: opacity }));
  }
  /* (v157) the pages of the optional page list (null = every page) */
  function wmPages(doc, spec){
    var pages = doc.getPages();
    if(!spec || !spec.length) return pages;
    var only = new Set(pcResolvePageSpec(spec, pages.length));
    return pages.filter(function(p, i){ return only.has(i + 1); });
  }
  async function watermarkOnePdf(file, text, style, pathPainter, opt){
    opt = opt || {};
    var doc = await loadPdfLib(file);
    var painter = pathPainter || helveticaPainter(await doc.embedFont(PDFLib.StandardFonts.HelveticaBold), text, opt.color);
    var fontSizeAt1 = painter.widthAt1;
    var glyph = wmGlyphForm(doc, painter);
    var gs = wmOpacityState(doc, opt.opacity || WM_TEXT.OPACITY[style] || WM_TEXT.OPACITY.diagonal);
    var cache = new Map(), k = opt.size || 1;
    function tiles(f){
      var ops = [];
      // the page is shown turned by /Rotate, so the text is drawn turned by it too
      textSpots(f, style, fontSizeAt1, k).forEach(function(s){ ops.push.apply(ops, textTileOps('T0', s, fontSizeAt1, s.deg + f.rot)); });
      return ops;
    }
    // (perf) gives the page back every PC_SLICE_MS (1,600 pages held it ~0.25 s)
    await pcEachSliced(wmPages(doc, opt.pages), function(page){
      wmPlaceForm(doc, page, wmLayoutForm(doc, cache, page, 'text', gs, { XObject: { T0: glyph } }, tiles));
    });
    doc.setModificationDate(new Date());
    return { blob: pdfBlob(await pcSavePdf(doc)), filename: baseFileName(file.name) + '-watermarked.pdf' };
  }
  /* ---------- (v62) IMAGE WATERMARK ---------- */
  /* A logo or stamp (PNG or JPG) instead of a text. The picture is untrusted
     input: its type is checked by its first bytes, its size and pixel count
     before it is decoded; the browser then decodes it (which also turns a
     phone photo upright and reads CMYK or progressive JPEGs), scales it down
     and writes it as a plain PNG (transparency kept) or JPEG. In each PDF it
     is embedded ONCE and every page shows that one copy with one shared
     transparency setting, so the file grows by about the picture's size,
     not by the picture once per page. Same centre, angles and /Rotate +
     crop box handling as the text watermark (pcVisualFrame, app.js). */
  // (v90) every picture the page decodes itself: checked in the file header first.
  // (v97) Lower on a phone or tablet: pdf-lib decodes a PNG in full (4 bytes a
  // pixel, plus copies), 50 MP closed a phone tab; 24 MP still takes every
  // standard phone photo.
  var IMG_MAX_MEGAPIXELS = pcIsPhone() ? 24 : 50;
  var WM_IMG = {
    MAX_MB: 10,                 // a larger picture is refused (phone memory)
    MAX_MEGAPIXELS: IMG_MAX_MEGAPIXELS, // checked in the file header, before decoding
    MAX_SIDE: 2400,             // px; plenty for a watermark, keeps the PDF small
    JPEG_QUALITY: 0.92,
    TILE_ANGLE: 30,             // degrees, as the text tiles
    TILE_GAP: 0.5,              // space between tiles, in the tile's larger side
    PERCENT: 100,
    BLANK_IMG: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
  };
  var PNG_SIGNATURE = [0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A];
  var wmImg = { kind: 'text', img: null, error: null, loading: null, ticket: 0, previewUrl: null };

  function wmImgEl(id){ return $('watermark-image-' + id); }
  function startsWith(bytes, sig){
    if(bytes.length < sig.length) return false;
    for(var i = 0; i < sig.length; i++) if(bytes[i] !== sig[i]) return false;
    return true;
  }
  /* 'png', 'jpeg' or null, by the file's first bytes (never by its name) */
  function sniffImage(bytes){
    if(startsWith(bytes, PNG_SIGNATURE)) return 'png';
    if(startsWith(bytes, [0xFF, 0xD8, 0xFF])) return 'jpeg';
    return null;
  }
  /* Width and height from the header, or null when there is none. */
  var PNG_IHDR = [0x49, 0x48, 0x44, 0x52];
  function pngSize(b){
    if(b.length < 24 || !startsWith(b.subarray(12), PNG_IHDR)) return null; // the first chunk must be IHDR
    var dv = new DataView(b.buffer, b.byteOffset, b.byteLength);
    return { w: dv.getUint32(16), h: dv.getUint32(20) };
  }
  function isJpegFrameMarker(m){ return m >= 0xC0 && m <= 0xCF && m !== 0xC4 && m !== 0xC8 && m !== 0xCC; }
  function jpegSize(b){
    var i = 2;
    while(i + 9 < b.length){
      if(b[i] !== 0xFF) return null;
      var m = b[i + 1];
      if(m === 0xFF){ i++; continue; }       // fill byte
      if(m === 0xD8 || (m >= 0xD0 && m <= 0xD7)){ i += 2; continue; } // markers without a length
      if(isJpegFrameMarker(m)) return { w: (b[i + 7] << 8) | b[i + 8], h: (b[i + 5] << 8) | b[i + 6] };
      if(m === 0xDA || m === 0xD9) return null; // image data before any frame header
      i += 2 + ((b[i + 2] << 8) | b[i + 3]);
    }
    return null;
  }
  /* (v90) Width and height of a GIF, BMP or WebP from its header (null: unknown, e.g. HEIC). */
  function le16(b, i){ return b[i] | (b[i + 1] << 8); }
  function le24(b, i){ return b[i] | (b[i + 1] << 8) | (b[i + 2] << 16); }
  function gifSize(b){ return b.length >= 10 && b[0] === 0x47 && b[1] === 0x49 && b[2] === 0x46 ? { w: le16(b, 6), h: le16(b, 8) } : null; }
  function bmpSize(b){
    if(b.length < 26 || b[0] !== 0x42 || b[1] !== 0x4D) return null;
    var dv = new DataView(b.buffer, b.byteOffset, b.byteLength);
    if(dv.getUint32(14, true) === BMP_CORE_HEADER) return { w: le16(b, 18), h: le16(b, 20) };
    return { w: Math.abs(dv.getInt32(18, true)), h: Math.abs(dv.getInt32(22, true)) }; // negative height: stored top-down
  }
  function webpSize(b){
    var tag = function(i){ return String.fromCharCode(b[i], b[i + 1], b[i + 2], b[i + 3]); };
    if(b.length < 30 || tag(0) !== 'RIFF' || tag(8) !== 'WEBP') return null;
    var chunk = tag(12);
    if(chunk === 'VP8X') return { w: 1 + le24(b, 24), h: 1 + le24(b, 27) };
    if(chunk === 'VP8 ') return { w: le16(b, 26) & 0x3FFF, h: le16(b, 28) & 0x3FFF };
    if(chunk === 'VP8L') return { w: 1 + (((b[22] & 0x3F) << 8) | b[21]), h: 1 + (((b[24] & 0x0F) << 10) | (b[23] << 2) | (b[22] >> 6)) };
    return null;
  }
  var BMP_CORE_HEADER = 12; // the old OS/2 header has 16-bit sizes
  function imageHeaderSize(b){
    var kind = sniffImage(b);
    if(kind) return kind === 'png' ? pngSize(b) : jpegSize(b);
    return gifSize(b) || bmpSize(b) || webpSize(b);
  }
  /* A picture whose header says it has more pixels than a phone can decode
     is refused before decoding (a 600 KB PNG can hold 144 megapixels). */
  function checkDecodeLimit(bytes){
    var dim = imageHeaderSize(bytes);
    if(dim && dim.w * dim.h > IMG_MAX_MEGAPIXELS * 1e6) throw userError('imgTooBig', Math.round(dim.w * dim.h / 1e6), IMG_MAX_MEGAPIXELS);
  }
  /* Throws a translated error for anything that is not a usable PNG/JPEG. */
  function checkImageBytes(bytes){
    var kind = sniffImage(bytes);
    if(!kind) throw userError('wmImgType');
    var dim = kind === 'png' ? pngSize(bytes) : jpegSize(bytes);
    if(!dim || !dim.w || !dim.h) throw userError('wmImgBad');
    if(dim.w * dim.h > WM_IMG.MAX_MEGAPIXELS * 1e6) throw userError('wmImgBig', WM_IMG.MAX_MB, WM_IMG.MAX_MEGAPIXELS);
    // a cut-off file often still "loads", with a grey or empty part (jpegComplete: JPG to PDF)
    if(!(kind === 'png' ? pngComplete(bytes) : jpegComplete(bytes))) throw userError('imgTruncated');
    return kind;
  }
  /* A complete PNG is a chain of chunks that ends with IEND. */
  function pngComplete(b){
    var dv = new DataView(b.buffer, b.byteOffset, b.byteLength), i = PNG_SIGNATURE.length;
    while(i + 8 <= b.length){
      var len = dv.getUint32(i);
      if(b[i + 4] === 0x49 && b[i + 5] === 0x45 && b[i + 6] === 0x4E && b[i + 7] === 0x44) return true; // IEND
      i += 12 + len; // length, type, data, CRC
    }
    return false;
  }
  function decodeImage(blob){
    return new Promise(function(res, rej){
      var url = URL.createObjectURL(blob), img = new Image();
      img.onload = function(){ URL.revokeObjectURL(url); res(img); };
      img.onerror = function(){ URL.revokeObjectURL(url); rej(userError('wmImgBad')); };
      img.src = url;
    });
  }
  function canvasBlob(canvas, type){
    return new Promise(function(res, rej){
      canvas.toBlob(function(b){ if(b) res(b); else rej(userError('wmImgBad')); }, type, WM_IMG.JPEG_QUALITY);
    });
  }
  /* The checked picture, upright and scaled down, as { blob, bytes, png, aspect }. */
  async function prepareWatermarkImage(file){
    if(file.size > WM_IMG.MAX_MB * 1024 * 1024) throw userError('wmImgBig', WM_IMG.MAX_MB, WM_IMG.MAX_MEGAPIXELS);
    var kind = checkImageBytes(new Uint8Array(await file.arrayBuffer()));
    var img = await decodeImage(file);
    if(!img.naturalWidth || !img.naturalHeight) throw userError('wmImgBad');
    var k = Math.min(1, WM_IMG.MAX_SIDE / Math.max(img.naturalWidth, img.naturalHeight));
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(img.naturalWidth * k));
    c.height = Math.max(1, Math.round(img.naturalHeight * k));
    var png = kind === 'png';
    try{
      pcCanvas2d(c).drawImage(img, 0, 0, c.width, c.height); // (v94) inside try: released also when drawing fails
      var blob = await canvasBlob(c, png ? 'image/png' : 'image/jpeg');
      return { blob: blob, bytes: new Uint8Array(await blob.arrayBuffer()), png: png, aspect: c.height / c.width };
    }finally{
      c.width = c.height = 0; // let the browser free the pixels at once
    }
  }
  function showWatermarkImage(prepared, msg){
    var box = wmImgEl('preview'), thumb = wmImgEl('thumb'), input = wmImgEl('input'), err = wmImgEl('error');
    if(wmImg.previewUrl){ URL.revokeObjectURL(wmImg.previewUrl); wmImg.previewUrl = null; }
    if(prepared) wmImg.previewUrl = URL.createObjectURL(prepared.blob);
    if(thumb) thumb.src = wmImg.previewUrl || WM_IMG.BLANK_IMG;
    if(box) box.hidden = !prepared;
    if(err){ err.textContent = msg || ''; err.hidden = !msg; }
    if(input){ if(msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid'); }
  }
  function loadWatermarkImage(file){
    var ticket = ++wmImg.ticket; // a slower, older picture never replaces a newer choice
    wmImg.img = null; wmImg.error = null;
    showWatermarkImage(null, '');
    if(!file){ wmImg.loading = null; return; }
    wmImg.loading = prepareWatermarkImage(file).then(function(prepared){
      if(ticket !== wmImg.ticket) return;
      wmImg.img = prepared;
      showWatermarkImage(prepared, '');
    }, function(e){
      if(ticket !== wmImg.ticket) return;
      if(!(e && e.userFacing)) pcLogUnexpected(e);
      wmImg.error = (e && e.userFacing) ? e : userError('wmImgBad');
      showWatermarkImage(null, wmImg.error.message);
    });
  }
  function rangeValue(id){
    var el = wmImgEl(id);
    var v = el ? Number(el.value) : NaN;
    if(!el || !isFinite(v)) return 0;
    return clamp(v, Number(el.min), Number(el.max)) / WM_IMG.PERCENT;
  }
  function showRange(id){
    var el = wmImgEl(id), out = wmImgEl(id + '-out');
    if(!el) return;
    var text = t('pct', el.value);
    el.setAttribute('aria-valuetext', text);
    if(out) out.textContent = text;
  }
  function setupWatermarkImage(){
    if(!$('watermark-kind-options')) return;
    document.querySelectorAll('#watermark-kind-options .quality-opt').forEach(function(o){
      o.addEventListener('click', function(){
        wmImg.kind = o.dataset.value === 'image' ? 'image' : 'text';
        $('watermark-text-box').hidden = wmImg.kind !== 'text';
        wmImgEl('box').hidden = wmImg.kind !== 'image';
      });
    });
    var input = wmImgEl('input');
    if(input) input.addEventListener('change', function(){ loadWatermarkImage(input.files[0] || null); });
    ['size', 'opacity'].forEach(function(id){
      var el = wmImgEl(id);
      if(!el) return;
      el.addEventListener('input', function(){ showRange(id); });
      showRange(id);
    });
  }

  /* Centres (page coordinates) and angles (as the reader sees them) of the
     pictures on one page: one in the middle, or a grid of tiles. */
  function imageSpots(f, style, w, h){
    var box = f.box, cx = box.x + box.width / 2, cy = box.y + box.height / 2;
    if(style === 'horizontal') return [{ x: cx, y: cy, deg: 0 }];
    if(style !== 'tiled') return [{ x: cx, y: cy, deg: Math.atan2(f.vh, f.vw) * 180 / Math.PI }];
    // the same turned grid as the text tiles (see watermarkOnePdf)
    var ang = (WM_IMG.TILE_ANGLE + f.rot) * Math.PI / 180;
    var ux = Math.cos(ang), uy = Math.sin(ang), wx = -uy, wy = ux;
    var gap = WM_IMG.TILE_GAP * Math.max(w, h);
    var along = w + gap, across = h + gap, reach = Math.max(w, h);
    var diag = Math.sqrt(box.width * box.width + box.height * box.height);
    var ni = Math.ceil(diag / along) + 1, nj = Math.ceil(diag / across) + 1, spots = [];
    for(var j = -nj; j <= nj; j++){
      for(var i = -ni; i <= ni; i++){
        var o = i + (j % 2 ? 0.5 : 0);
        var px = cx + o * along * ux + j * across * wx, py = cy + o * along * uy + j * across * wy;
        if(px < box.x - reach || px > box.x + box.width + reach || py < box.y - reach || py > box.y + box.height + reach) continue;
        spots.push({ x: px, y: py, deg: WM_IMG.TILE_ANGLE });
      }
    }
    return spots;
  }
  /* Draws the picture centred on (x, y), turned by `deg`, w x h points: one
     matrix (translate, rotate, scale) per picture keeps many tiles small. */
  var WM_DECIMALS = 1000;
  function round3(v){ return Math.round(v * WM_DECIMALS) / WM_DECIMALS; }
  function imageOps(name, x, y, w, h, deg){
    var r = deg * Math.PI / 180, cos = Math.cos(r), sin = Math.sin(r);
    var e = x - (w / 2) * cos + (h / 2) * sin, f = y - (w / 2) * sin - (h / 2) * cos;
    return [PDFLib.pushGraphicsState(),
      PDFLib.concatTransformationMatrix(round3(w * cos), round3(w * sin), round3(-h * sin), round3(h * cos), round3(e), round3(f)),
      PDFLib.drawObject(name), PDFLib.popGraphicsState()];
  }
  async function imageWatermarkOnePdf(file, style, size, opacity, spec){
    var doc = await loadPdfLib(file);
    var img = wmImg.img;
    var embedded = img.png ? await doc.embedPng(img.bytes) : await doc.embedJpg(img.bytes);
    var aspect = embedded.height / embedded.width;
    var gs = wmOpacityState(doc, opacity), cache = new Map();
    function tiles(f){
      // width as a share of the page width as it is read; never taller than the page
      var w = Math.min(f.vw * size, f.vh / aspect), h = w * aspect, ops = [];
      imageSpots(f, style, w, h).forEach(function(s){
        // the page is shown turned by /Rotate, so the picture is drawn turned by it too
        ops.push.apply(ops, imageOps('I0', s.x, s.y, w, h, s.deg + f.rot));
      });
      return ops;
    }
    // (v65) one layout form per page layout, like the text watermark
    await pcEachSliced(wmPages(doc, spec), function(page){ // (perf) as the text watermark
      wmPlaceForm(doc, page, wmLayoutForm(doc, cache, page, 'image', gs, { XObject: { I0: embedded.ref } }, tiles));
    });
    doc.setModificationDate(new Date());
    return { blob: pdfBlob(await pcSavePdf(doc)), filename: baseFileName(file.name) + '-watermarked.pdf' };
  }
  async function runImageWatermark(files, style, ctx, spec){
    if(wmImg.loading) await wmImg.loading;
    if(!wmImg.img) throw wmImg.error || userError('wmImgNeed');
    var size = rangeValue('size'), opacity = rangeValue('opacity');
    resetNotes();
    var out = await eachFile(files, ctx, function(file){ return imageWatermarkOnePdf(file, style, size, opacity, spec); });
    out.info = out.results.length === 1 ? t('wmInfoOne') : t('wmInfoMany', out.results.length);
    out.note = takeNotes();
    return out;
  }
  pcOnPanel('watermark', function(){ setupWatermarkImage(); });

  /* (v157) colour, size and opacity of the text (under the text field) and
     a page list for both kinds (under the styles), as at iLovePDF */
  function wmTextOptions(){
    var hint = $('watermark-text-hint');
    if(!hint) return null;
    var row = document.createElement('div'); row.className = 'nup-opts';
    hint.insertAdjacentElement('afterend', row);
    return {
      color: scriptSelect(row, 'watermark-color', t('wmColor'), ['grey', 'black', 'red', 'blue', 'green'], t('wmColorOpts'), 'grey'),
      size: scriptSelect(row, 'watermark-size', t('wmSize'), ['small', 'medium', 'large'], t('wmSizeOpts'), 'medium'),
      opacity: scriptSelect(row, 'watermark-opacity', t('wmOpacity'), ['', '0.1', '0.25', '0.5', '0.75', '1'], t('wmOpacityAuto') + '|10%|25%|50%|75%|100%', '')
    };
  }
  function wmPagesField(){
    var row = scriptOptsRow('watermark-style-options');
    if(!row) return null;
    var f = document.createElement('div'); f.className = 'nup-field';
    var l = document.createElement('label'); l.htmlFor = 'watermark-pages'; l.textContent = pcT('rotatePages');
    var inp = document.createElement('input'); inp.type = 'text'; inp.id = 'watermark-pages'; inp.className = 'text-input'; inp.autocomplete = 'off'; inp.placeholder = '1, 3-5';
    f.appendChild(l); f.appendChild(inp); row.appendChild(f);
    return inp;
  }
  pcOnPanel('watermark', function(){
  var wmOpts = wmTextOptions(), wmPagesInput = wmPagesField();
  setupTool('watermark', {
    accept: isPdf, optionsId: 'watermark-style-options', workingKey: 'watermarking', zipName: 'watermarked-pdf-files', fieldId: 'watermark-pages',
    run: async function(files, style, ctx){
      var spec;
      try{ spec = pcParsePageSpec(wmPagesInput ? wmPagesInput.value : ''); }catch(e){ if(e && e.field) e.fieldId = 'watermark-pages'; throw e; }
      if(wmImg.kind === 'image') return runImageWatermark(files, style || 'diagonal', ctx, spec);
      var text = (($('watermark-text') || {}).value || '').replace(/\s+/g, ' ').trim();
      if(!text) throw userError('wmNeed');
      var color = WM_COLORS[wmOpts ? wmOpts.color.value : 'grey'] || WM_COLORS.grey;
      var opt = { color: color, pages: spec, size: WM_SIZE[wmOpts ? wmOpts.size.value : 'medium'] || 1, opacity: wmOpts && wmOpts.opacity.value ? parseFloat(wmOpts.opacity.value) : 0 };
      resetNotes();
      // The standard PDF font covers Latin letters with accents (WinAnsi);
      // anything else is drawn as letter shapes (makePathPainter). Decided
      // once up front instead of per file.
      var pathPainter = null;
      try{
        var probe = await PDFLib.PDFDocument.create();
        var f = await probe.embedFont(PDFLib.StandardFonts.HelveticaBold);
        f.encodeText(text);
        f.widthOfTextAtSize(text, 10);
      }catch(e){
        try{ pathPainter = await makePathPainter(text, color); }
        catch(e2){
          if(e2 && e2.userFacing) throw e2;
          pcLogUnexpected(e2); // the cause (network, integrity, fontkit) for whoever debugs it
          throw userError('wmFont');
        }
      }
      var out = await eachFile(files, ctx, function(file){ return watermarkOnePdf(file, text, style || 'diagonal', pathPainter, opt); });
      out.info = out.results.length === 1 ? t('wmInfoOne') : t('wmInfoMany', out.results.length);
      out.note = takeNotes();
      return out;
    }
  }); });

  /* ---------- JPG / PNG TO PDF ---------- */
  var IMG_RE = /\.(jpe?g|jfif|png|webp|gif|bmp|heic|heif|avif)$/i;
  var isImage = function(f){ return /^image\/(jpeg|png|webp|gif|bmp|heic|heif|avif)$/.test(f.type) || IMG_RE.test(f.name); };
  /* v47: iPhone photos (HEIC) used to be dropped silently. The browser
     decodes them where it can (Safari); elsewhere the file is listed as
     skipped with the "use JPG or PNG" message. */
  pcOnPanel('jpgpdf', function(){ (function(){
    var inp = $('input-jpgpdf');
    if(inp && inp.accept && inp.accept.indexOf('.heic') < 0) inp.accept += ',.heic,.heif,image/heic,image/heif';
  })(); });

  /* Phone photos store "which way is up" as an EXIF tag instead of turning
     the pixels. A PDF shows the raw pixels, so without this a portrait
     phone photo would come out lying on its side. Returns 1-8. */
  function jpegOrientation(bytes){
    try{
      if(bytes[0] !== 0xFF || bytes[1] !== 0xD8) return 1;
      var i = 2;
      while(i + 4 < bytes.length){
        if(bytes[i] !== 0xFF) return 1;
        var marker = bytes[i + 1];
        var len = (bytes[i + 2] << 8) | bytes[i + 3];
        if(marker === 0xE1 && bytes[i + 4] === 0x45 && bytes[i + 5] === 0x78 && bytes[i + 6] === 0x69 && bytes[i + 7] === 0x66){
          var tiff = i + 10;
          var le = bytes[tiff] === 0x49;
          var r16 = function(o){ return le ? (bytes[o] | (bytes[o + 1] << 8)) : ((bytes[o] << 8) | bytes[o + 1]); };
          var r32 = function(o){ return le ? (bytes[o] | (bytes[o+1] << 8) | (bytes[o+2] << 16) | (bytes[o+3] << 24)) >>> 0 : ((bytes[o] << 24) | (bytes[o+1] << 16) | (bytes[o+2] << 8) | bytes[o+3]) >>> 0; };
          var ifd = tiff + r32(tiff + 4);
          var count = r16(ifd);
          for(var k = 0; k < count; k++){
            var e = ifd + 2 + k * 12;
            if(r16(e) === 0x0112){
              var v = r16(e + 8);
              return v >= 1 && v <= 8 ? v : 1;
            }
          }
          return 1;
        }
        if(marker === 0xDA) return 1;
        i += 2 + len;
      }
    }catch(e){ /* unreadable EXIF: treat as upright (orientation 1) */ }
    return 1;
  }
  /* Where stored pixel (x,y) (0..1, y down) ends up when displayed (X,Y). */
  function orientMap(o, x, y){
    switch(o){
      case 2: return [1 - x, y];
      case 3: return [1 - x, 1 - y];
      case 4: return [x, 1 - y];
      case 5: return [y, x];
      case 6: return [1 - y, x];
      case 7: return [1 - y, 1 - x];
      case 8: return [y, 1 - x];
      default: return [x, y];
    }
  }
  var CANVAS_MAX_PX = 16e6;
  function toJpegViaCanvas(file){
    return new Promise(function(resolve, reject){
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function(){
        var c = null;
        try{
          c = document.createElement('canvas');
          // (v89) within every browser's canvas limit (iPhone: ~16.7 MP); a 24 MP photo used to fail as "format can't be read"
          var k = Math.min(1, Math.sqrt(CANVAS_MAX_PX / (img.naturalWidth * img.naturalHeight)));
          c.width = Math.max(1, Math.round(img.naturalWidth * k)); c.height = Math.max(1, Math.round(img.naturalHeight * k));
          var g = c.getContext('2d');
          if(!g){ URL.revokeObjectURL(url); return reject(pcUserError(pcT('outOfMemory'))); } // (v90) no 2D context for a canvas within the limit: memory
          g.fillStyle = '#ffffff'; g.fillRect(0, 0, c.width, c.height);
          g.drawImage(img, 0, 0, c.width, c.height);
          c.toBlob(function(b){
            URL.revokeObjectURL(url);
            c.width = 0; c.height = 0;
            if(!b) return reject(pcUserError(pcT('outOfMemory'))); // (v90) the picture decoded fine: no JPEG means no memory left
            b.arrayBuffer().then(function(ab){ resolve(new Uint8Array(ab)); }, reject);
          }, 'image/jpeg', 0.92);
        }catch(e){ URL.revokeObjectURL(url); pcReleaseCanvas(c); reject(memoryOr(e, 'imgUnsupported')); } // (v94) canvas released too
      };
      img.onerror = function(){ URL.revokeObjectURL(url); reject(userError('imgUnsupported')); };
      img.src = url;
    });
  }
  /* (v59) A JPEG cut off halfway (an interrupted download) still "decodes":
     the missing part came out as a grey block and the tool said Done. A
     complete JPEG has its end-of-image marker (FF D9) somewhere after the
     start of the image data (SOS). Searched from there on, not only at the
     very end: phones append data after it ("motion photos" add a video). */
  function jpegComplete(bytes){
    var i = 2, sos = -1;
    while(i + 3 < bytes.length && bytes[i] === 0xFF){
      var marker = bytes[i + 1];
      if(marker === 0xDA){ sos = i; break; }
      if(marker === 0xFF){ i++; continue; } // fill byte
      i += 2 + ((bytes[i + 2] << 8) | bytes[i + 3]);
    }
    if(sos < 0) return true; // unusual layout: leave it to the decoder
    for(var k = sos + 2; k < bytes.length - 1; k++){
      if(bytes[k] === 0xFF && bytes[k + 1] === 0xD9) return true;
    }
    return false;
  }
  /* (v67) A grey or colour 8-bit PNG without transparency (not interlaced)
     is put in the PDF exactly as it is stored: its compressed pixel data is
     already what a PDF reader can show (Flate with the PNG predictors).
     pdf-lib would decode it, store a grey picture as colour and compress it
     again (larger). 16-bit PNGs are left to pdf-lib on purpose: kept at 16
     bits they made the PDF up to twice as big for no visible difference.
     The data is unpacked once as a check; anything unexpected returns null
     and pdf-lib embeds it as before. */
  var PNG_GREY = 0, PNG_RGB = 2, PNG_MAX_FILTER = 4, PNG_GREY_DEPTHS = [1, 2, 4, 8];
  function pngChunks(b){
    var chunks = [], dv = new DataView(b.buffer, b.byteOffset, b.byteLength), o = PNG_SIGNATURE.length;
    while(o + 12 <= b.length){
      var len = dv.getUint32(o), type = String.fromCharCode(b[o + 4], b[o + 5], b[o + 6], b[o + 7]);
      if(o + 12 + len > b.length) return null;
      chunks.push({ type: type, data: b.subarray(o + 8, o + 8 + len) });
      if(type === 'IEND') return chunks;
      o += 12 + len;
    }
    return null; // no end chunk: cut off
  }
  async function embedPngAsStored(doc, bytes){
    var chunks = pngChunks(bytes);
    if(!chunks || !chunks.length || chunks[0].type !== 'IHDR' || chunks[0].data.length < 13) return null;
    var h = chunks[0].data, hv = new DataView(h.buffer, h.byteOffset, h.byteLength);
    var w = hv.getUint32(0), ht = hv.getUint32(4), depth = h[8], type = h[9], interlace = h[12];
    // (v90) grey also at 1, 2 or 4 bits (black-and-white scans): kept at that depth instead of 8-bit RGB
    var depthOk = type === PNG_GREY ? PNG_GREY_DEPTHS.indexOf(depth) >= 0 : type === PNG_RGB && depth === 8;
    if(!depthOk || interlace !== 0 || !w || !ht) return null;
    if(h[10] !== 0 || h[11] !== 0) return null; // compression and filter method: only 0 exists
    if(chunks.some(function(c){ return c.type === 'tRNS'; })) return null; // a transparent colour: pdf-lib makes the mask
    var parts = chunks.filter(function(c){ return c.type === 'IDAT'; }).map(function(c){ return c.data; });
    if(!parts.length) return null;
    var idat = new Uint8Array(parts.reduce(function(n, p){ return n + p.length; }, 0));
    parts.reduce(function(at, p){ idat.set(p, at); return at + p.length; }, 0);
    var colors = type === PNG_GREY ? 1 : 3, rowBytes = Math.ceil(w * colors * depth / 8);
    var raw;
    try{ raw = await pcInflate(idat); }
    catch(e){
      pcThrowIfOutOfMemory(e); // (v90) a full memory is not damaged data
      return null; // damaged data: pdf-lib decides (and reports) below
    }
    if(raw.length !== ht * (rowBytes + 1)) return null;
    for(var r = 0; r < ht; r++) if(raw[r * (rowBytes + 1)] > PNG_MAX_FILTER) return null;
    var N = PDFLib.PDFName, num = PDFLib.PDFNumber;
    var parms = doc.context.obj({ Predictor: 15, Colors: colors, BitsPerComponent: depth, Columns: w });
    var dict = doc.context.obj({
      Type: 'XObject', Subtype: 'Image', Width: w, Height: ht, BitsPerComponent: depth,
      ColorSpace: type === PNG_GREY ? 'DeviceGray' : 'DeviceRGB', Filter: 'FlateDecode', DecodeParms: parms
    });
    dict.set(N.of('Length'), num.of(idat.length));
    var ref = doc.context.register(PDFLib.PDFRawStream.of(dict, idat));
    return { ref: ref, width: w, height: ht };
  }
  async function embedAnyImage(doc, file){
    var bytes = new Uint8Array(await file.arrayBuffer());
    var isJpg = bytes[0] === 0xFF && bytes[1] === 0xD8;
    var isPng = bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4E && bytes[3] === 0x47;
    // (v67) a cut-off PNG also "decodes" (the missing part came out black)
    if((isJpg && !jpegComplete(bytes)) || (isPng && !pngComplete(bytes))) throw userError('imgTruncated');
    if(isPng) checkDecodeLimit(bytes); // (v90) pdf-lib decodes a PNG in full; a JPEG is copied as it is
    try{
      if(isJpg) return { image: await doc.embedJpg(bytes), orientation: jpegOrientation(bytes) };
      if(isPng) return { image: (await embedPngAsStored(doc, bytes)) || await doc.embedPng(bytes), orientation: 1 };
    }catch(e){
      // unusual encoding: fall back to a browser re-encode below; (v89) but a
      // cancel or a full memory is not an encoding problem
      if(pcIsCancel(e)) throw e;
      pcThrowIfOutOfMemory(e);
      pcLogUnexpected(e); // (v111) a JPEG/PNG that should have fitted as it is: our fault or pdf-lib's
    }
    checkDecodeLimit(bytes); // the browser decodes it in full
    var jpg = await toJpegViaCanvas(file);
    // The browser already applied any EXIF rotation while decoding.
    // (v111) a JPEG or PNG that had to be re-encoded is named under the result
    return { image: await doc.embedJpg(jpg), orientation: 1, reencoded: isJpg || isPng };
  }
  /* (v157) Options added by script under a tool's option buttons (no page
     markup changes in 8 languages), in the look of Pages per sheet. */
  function scriptOptsRow(afterId){
    var after = $(afterId);
    if(!after) return null;
    var row = document.createElement('div');
    row.className = 'nup-opts';
    after.insertAdjacentElement('afterend', row);
    return row;
  }
  function scriptSelect(row, id, label, values, labels, def){
    var f = document.createElement('div'); f.className = 'nup-field';
    var l = document.createElement('label'); l.htmlFor = id; l.textContent = label;
    var s = document.createElement('select'); s.id = id; s.className = 'sign-select';
    labels.split('|').forEach(function(txt, i){ var o = document.createElement('option'); o.value = values[i]; o.textContent = txt; s.appendChild(o); });
    s.value = def;
    f.appendChild(l); f.appendChild(s); row.appendChild(f);
    return s;
  }
  function scriptCheck(row, id, label){
    var l = document.createElement('label'); l.className = 'sign-check';
    var c = document.createElement('input'); c.type = 'checkbox'; c.id = id;
    l.appendChild(c); l.appendChild(document.createTextNode(' ' + label)); row.appendChild(l);
    return c;
  }
  var PAGE_SIZES = { a4: [595.28, 841.89], letter: [612, 792] };
  var JPG_MARGIN = { none: 0, small: 28.35, large: 56.69 }; // 0, 1 cm, 2 cm
  /* (v153) US Letter is the everyday paper in the US, Canada and Mexico: there it is
     picked first (read from the browser's own language setting; nothing is sent).
     The visitor can still choose A4. */
  var LETTER_REGIONS = ['US', 'CA', 'MX'];
  function prefersLetter(){
    var tag = (navigator.languages && navigator.languages[0]) || navigator.language || '';
    return LETTER_REGIONS.indexOf((tag.split('-')[1] || '').toUpperCase()) >= 0;
  }
  function preselectLetter(groupId){
    if(!prefersLetter()) return;
    document.querySelectorAll('#' + groupId + ' .quality-opt').forEach(function(o){
      var on = o.dataset.value === 'letter';
      o.classList.toggle('selected', on);
      o.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  pcOnPanel('jpgpdf', function(){ preselectLetter('jpgpdf-size-options');
  // (v157) orientation, margin and one PDF per image, as at iLovePDF
  var jRow = scriptOptsRow('jpgpdf-size-options');
  var jOrient = jRow && scriptSelect(jRow, 'jpgpdf-orient', t('jpgOrient'), ['auto', 'portrait', 'landscape'], t('jpgOrientOpts'), 'auto');
  var jMargin = jRow && scriptSelect(jRow, 'jpgpdf-margin', t('jpgMargin'), ['none', 'small', 'large'], t('jpgMarginOpts'), 'small');
  var jEach = jRow && scriptCheck(jRow, 'jpgpdf-each', t('jpgEach'));
  setupTool('jpgpdf', {
    accept: isImage, reorder: true, optionsId: 'jpgpdf-size-options', workingKey: 'building', zipName: 'images-to-pdf',
    run: async function(files, size, ctx){
      var orient = jOrient ? jOrient.value : 'auto', margin = JPG_MARGIN[jMargin ? jMargin.value : 'small'], each = !!(jEach && jEach.checked);
      var doc = await PDFLib.PDFDocument.create();
      var skipped = [], added = 0, firstAdded = null, reencoded = [], singles = [];
      for(var i = 0; i < files.length; i++){
        pcCheckCancel();
        ctx.setStatus(t('imageN', i + 1, files.length));
        try{
          if(each) doc = await PDFLib.PDFDocument.create();
          var emb = await embedAnyImage(doc, files[i]);
          var img = emb.image, o = emb.orientation;
          if(emb.reencoded) reencoded.push(files[i].name);
          var sw = img.width, sh = img.height;
          var swap = o >= 5;
          var dw = swap ? sh : sw, dh = swap ? sw : sh; // displayed pixel size
          var pageW, pageH, drawW, drawH, offX, offY;
          if(size === 'fit'){
            pageW = dw * 0.75; pageH = dh * 0.75; // 96 dpi, the size a browser shows it at
            // v47: never larger than 200 inches (14,400 pt), the page size limit of PDF 1.x readers
            var lim = Math.min(1, 14400 / Math.max(pageW, pageH));
            pageW *= lim; pageH *= lim;
            drawW = pageW; drawH = pageH; offX = 0; offY = 0;
          }else{
            var ps = PAGE_SIZES[size] || PAGE_SIZES.a4;
            var landscape = orient === 'auto' ? dw > dh : orient === 'landscape';
            pageW = landscape ? ps[1] : ps[0]; pageH = landscape ? ps[0] : ps[1];
            var s = Math.min((pageW - 2 * margin) / dw, (pageH - 2 * margin) / dh);
            drawW = dw * s; drawH = dh * s;
            offX = (pageW - drawW) / 2; offY = (pageH - drawH) / 2;
          }
          var page = doc.addPage([pageW, pageH]);
          // Image space (u,v), v up, mapped onto the page through the EXIF
          // orientation: built from where three corners land.
          var P = function(u, v){
            var d = orientMap(o, u, 1 - v);
            return [offX + d[0] * drawW, offY + (1 - d[1]) * drawH];
          };
          var p00 = P(0, 0), p10 = P(1, 0), p01 = P(0, 1);
          var name = page.node.newXObject('Image', img.ref);
          page.pushOperators(
            PDFLib.pushGraphicsState(),
            PDFLib.concatTransformationMatrix(p10[0] - p00[0], p10[1] - p00[1], p01[0] - p00[0], p01[1] - p00[1], p00[0], p00[1]),
            PDFLib.drawObject(name),
            PDFLib.popGraphicsState()
          );
          added++;
          if(!firstAdded) firstAdded = files[i];
          if(each) singles.push({ blob: pdfBlob(await pcSavePdf(doc)), filename: files[i].name.replace(/\.[^.]+$/, '') + '.pdf' });
        }catch(err){
          if(pcIsCancel(err)) throw err;
          pcLogUnexpected(err); // (v89) was console.warn: only real faults
          skipped.push(files[i].name + ' (' + reasonOf(err, 'imgUnsupported') + ')');
        }
        ctx.setProgress((i + 1) / files.length);
      }
      if(!added) throw userError('couldNot', skipped.join(', ') || t('noImages'));
      var note = reencoded.length ? t('jpgReencodedNote', reencoded.join(', ')) : '';
      if(each) return { results: singles, skipped: skipped, info: singles.length === 1 ? t('jpgpdfInfoOne', fmtSize(singles[0].blob.size)) : t('jpgEachInfo', singles.length), note: note };
      var bytes = await pcSavePdf(doc);
      // (v55) named after the first image that was really added, not after
      // a skipped one
      var fname = firstAdded.name.replace(/\.[^.]+$/, '') + (added === 1 ? '' : '-merged') + '.pdf'; // (v95) was "images.pdf" for several
      return {
        results: [{ blob: pdfBlob(bytes), filename: fname }],
        skipped: skipped,
        info: added === 1 ? t('jpgpdfInfoOne', fmtSize(bytes.length)) : t('jpgpdfInfo', added, fmtSize(bytes.length)),
        note: reencoded.length ? t('jpgReencodedNote', reencoded.join(', ')) : ''
      };
    }
  }); });

  /* ---------- PDF TO JPG ---------- */
  var MAX_PIXELS = 16e6, MAX_SIDE = 8000; // stays within every browser's canvas limits (incl. iPhone)
  var JPG_QUALITY = 0.9;
  var PT_PER_INCH = 72;
  /* The scale for a page canvas: `wanted`, or less to stay within those limits. */
  function canvasScale(vp1, wanted){
    return Math.min(wanted, MAX_SIDE / vp1.width, MAX_SIDE / vp1.height, Math.sqrt(MAX_PIXELS / (vp1.width * vp1.height)));
  }
  /* One page as a JPEG at (at most) `dpi`. The canvas is always released,
     also when rendering fails (v55), so a failing page can't hold on to
     up to 64 MB of pixels. Returns { blob, realDpi }. */
  async function renderPageJpeg(pdfDoc, p, dpi, png){
    var page = await pdfDoc.getPage(p);
    var canvas = document.createElement('canvas');
    try{
      var vp1 = page.getViewport({ scale: 1 });
      var vp = page.getViewport({ scale: canvasScale(vp1, dpi / PT_PER_INCH) });
      canvas.width = Math.max(1, Math.floor(vp.width));
      canvas.height = Math.max(1, Math.floor(vp.height));
      var g = pcCanvas2d(canvas); // (v94) null context (too large for memory) is a memory error, not a TypeError
      g.fillStyle = '#ffffff';
      g.fillRect(0, 0, canvas.width, canvas.height);
      await page.render({ canvasContext: g, viewport: vp }).promise;
      var blob = await new Promise(function(res){ canvas.toBlob(res, png ? 'image/png' : 'image/jpeg', JPG_QUALITY); }); // (v157) or PNG
      if(!blob) throw pcUserError(pcT('outOfMemory')); // (v90) the page rendered: no JPEG means no memory left
      // v47: the real resolution goes into the file (JFIF)
      var realDpi = Math.round(canvas.width / (vp1.width / 72));
      return { blob: blob, realDpi: realDpi };
    }finally{
      canvas.width = 0; canvas.height = 0;
      page.cleanup();
    }
  }
  /* pdf.js loading task: destroyed in every case (v55) - also when opening
     fails (password, corrupt file), which used to leave it running. */
  async function destroyTask(task){
    if(!task) return;
    try{ await task.destroy(); }
    catch(e){ pcLogUnexpected(e); } // cleanup only: the file's result is already decided
  }
  /* (v90) What the images will take in memory: they all stay in memory until
     the zip is made, and the zip holds them a second time. Rendering takes
     the page count times the DPI squared, so a 7 MB vector PDF at 300 DPI
     made a 677 MB zip and crashed a phone tab without any warning (the
     warnings before only look at the file size). */
  var MB = 1024 * 1024;
  var JPG_EST = {
    BYTES_PER_PX: 0.25,   // a JPEG at quality 0.9 of an average document page
    ZIP_COPIES: 2,        // the images plus the zip made from them
    PHONE_MAX: 300 * MB,  // a phone or tablet: refused above this (the tab would be closed)
    DESKTOP_WARN: 1536 * MB // a computer: a warning, the work goes on
  };
  async function estimateJpgBytes(pdfDoc, pages, dpi){
    var px = 0;
    for(var i = 0; i < pages.length; i++){
      pcCheckCancel();
      var page = await pdfDoc.getPage(pages[i]);
      var vp1 = page.getViewport({ scale: 1 });
      page.cleanup(); // (v94) only its size is needed: don't keep its parsed resources around
      var k = canvasScale(vp1, dpi / PT_PER_INCH);
      px += vp1.width * vp1.height * k * k;
    }
    return px * JPG_EST.BYTES_PER_PX;
  }
  /* Checked per file, on the total so far: on a phone over budget the file
     is refused with advice; on a computer a warning is shown once. */
  function checkJpgBudget(total, imageCount, state, ctx){
    var need = total * (imageCount > 1 ? JPG_EST.ZIP_COPIES : 1);
    if(pcIsPhone()){
      if(need > JPG_EST.PHONE_MAX) throw userError('jpgBigStop', fmtSize(need));
      return;
    }
    if(need > JPG_EST.DESKTOP_WARN && !state.warned){
      state.warned = true;
      ctx.warn(t('jpgBigWarn', fmtSize(need)));
    }
  }
  /* (v62) Only the pages typed in the field ("1, 3-5"), with the same
     parser and messages as Extract/Split; empty = every page (as before).
     A page a file doesn't have skips that file with the reason. */
  function pagesToRender(spec, n){
    if(!spec.length) return Array.from({ length: n }, function(_, i){ return i + 1; });
    return pcResolvePageSpec(spec, n);
  }
  var PNG_SIZE_FACTOR = 3; // (v157) a PNG page is roughly this much larger than the JPEG the budget estimates
  pcOnPanel('pdfjpg', function(){
  var pjRow = scriptOptsRow('pdfjpg-quality-options');
  var pjFormat = pjRow && scriptSelect(pjRow, 'pdfjpg-format', t('pjFormat'), ['jpg', 'png'], t('pjFormatOpts'), 'jpg');
  setupTool('pdfjpg', {
    accept: isPdf, optionsId: 'pdfjpg-quality-options', workingKey: 'rendering', zipName: 'pdf-images', fieldId: 'pdfjpg-pages',
    run: async function(files, dpiOpt, ctx){
      pcRequirePdfJs(); // (v60) a browser too old for pdf.js 4: one clear message
      var dpi = parseInt(dpiOpt, 10) || 150;
      var png = !!(pjFormat && pjFormat.value === 'png'), ext = png ? '.png' : '.jpg';
      var spec = pcParsePageSpec(($('pdfjpg-pages') || {}).value || ''); // a typo: a field error before any work
      var results = [], skipped = [], capped = [], cappedDpi = 1e9, fieldHit = false;
      var planned = 0, plannedImages = 0, budget = { warned: false };
      for(var f = 0; f < files.length; f++){
        var file = files[f];
        var task = null;
        // (v49) a file that fails halfway gives no images at all (instead of
        // pages 1..p-1 in the zip while the file is listed as skipped)
        var firstResult = results.length, firstCapped = capped.length, atPage = 0, pageCount = 0;
        try{
          var bytes = new Uint8Array(await file.arrayBuffer());
          var pdfDoc;
          try{
            task = pcGetDocument(pcPdfSource(bytes));
            pdfDoc = await task.promise;
            if(!pdfDoc.numPages) throw new Error('no pages'); // (v97) said only "none of the files could be processed"
          }catch(e){
            pcThrowIfOutOfMemory(e); // (v73)
            pcLogUnexpected(e); throw (e && e.userFacing) ? e : userError(e && e.name === 'PasswordException' ? 'password' : 'invalidPdf');
          }
          if(await pcIsPureXfaJs(pdfDoc)) throw Object.assign(new Error(pcT('xfa')), { userFacing: true });
          var n = pdfDoc.numPages;
          var base = baseFileName(file.name);
          var pages = pagesToRender(spec, n);
          pageCount = n;
          var fileBytes = (await estimateJpgBytes(pdfDoc, pages, dpi)) * (png ? PNG_SIZE_FACTOR : 1);
          checkJpgBudget(planned + fileBytes, plannedImages + pages.length, budget, ctx);
          planned += fileBytes; plannedImages += pages.length;
          for(var k = 0; k < pages.length; k++){
            var p = pages[k];
            pcCheckCancel();
            atPage = p;
            ctx.setStatus(t('pageN', f + 1, files.length, p, n));
            var img = await renderPageJpeg(pdfDoc, p, dpi, png);
            // a page that had to be made smaller than the chosen DPI is reported
            if(img.realDpi < dpi - 1){ capped.push(n === 1 ? file.name : file.name + ' p.' + p); cappedDpi = Math.min(cappedDpi, img.realDpi); }
            var blob = png ? img.blob : new Blob([pcJpegSetDpi(new Uint8Array(await img.blob.arrayBuffer()), img.realDpi)], { type: 'image/jpeg' });
            // (v157) zero-padded: page-02 sorts before page-10 everywhere
            results.push({ blob: blob, filename: n === 1 ? base + ext : base + '-page-' + String(p).padStart(String(n).length, '0') + ext });
            ctx.setProgress((f + (k + 1) / pages.length) / files.length);
          }
        }catch(err){
          if(pcIsCancel(err)) throw err;
          pcLogUnexpected(err); // (v89) only real faults: not a password, a cancel or a file that is gone
          if(err && err.field) fieldHit = true;
          var why = reasonOf(err, 'invalidPdf');
          if(results.length > firstResult){
            results.length = firstResult;
            capped.length = firstCapped;
            why = t('pageFailed', atPage, pageCount) + ((err && err.userFacing) ? ' – ' + err.message : '');
          }
          skipped.push(file.name + ' (' + why + ')');
        }finally{
          await destroyTask(task);
        }
        ctx.setProgress((f + 1) / files.length);
      }
      if(!results.length) throw Object.assign(userError('couldNot', skipped.join(', ') || t('noneProcessed')), { field: fieldHit });
      return {
        results: results, skipped: skipped,
        info: results.length === 1 ? t('pdfjpgInfoOne') : t('pdfjpgInfoMany', results.length),
        note: capped.length ? pcT('dpiCapped', capped.slice(0, 5).join(', ') + (capped.length > 5 ? ' …' : ''), cappedDpi) : ''
      };
    }
  }); });

  /* ---------- PROTECT / UNLOCK (v60) ---------- */
  /* Protect: the file gets an open password with the strongest standard PDF
     encryption, AES-256 (ISO 32000-2, security handler revision 6), the same
     as qpdf and current PDF readers write. All permissions stay allowed: the
     password guards opening, it is not a copy/print lock (those are only
     advisory in PDF). The owner password is the same as the open password.
     Unlock: the file is opened with the typed password (as user or owner
     password, see pcDeriveKey in app.js) and saved without encryption.
     The password and the file never leave the browser; nothing is stored. */
  var AES_BLOCK = 16, SALT_LEN = 8, FILE_KEY_LEN = 32, ID_LEN = 16;
  var PERMS_ALL = -4; // every permission bit set (ISO 32000-2, table 22)
  var R6_EXTENSION_LEVEL = 8; // Adobe extension level for AES-256 R6 in PDF 1.7
  var PROGRESS_EVERY = 200;   // objects between two progress updates
  var OBJECTS_PER_TICK = 50;  // pdf-lib's writer yields to the page every N objects
  function randomBytes(n){ return crypto.getRandomValues(new Uint8Array(n)); }
  function hexOf(bytes){ var h = ''; for(var i = 0; i < bytes.length; i++) h += (bytes[i] < 16 ? '0' : '') + bytes[i].toString(16); return h; }
  function hasWebCrypto(){ return !!(pcSubtle && window.crypto && crypto.getRandomValues); }

  /* The /Perms value: P, 0xFFFFFFFF, 'T' (metadata encrypted), 'adb', 4 random
     bytes; one AES block with the file key (a zero IV = ECB for one block). */
  async function permsEntry(fileKey){
    var b = new Uint8Array(AES_BLOCK);
    for(var i = 0; i < 4; i++) b[i] = (PERMS_ALL >> (8 * i)) & 0xff;
    b.fill(0xff, 4, 8);
    b.set([0x54, 0x61, 0x64, 0x62], 8); // 'T' 'a' 'd' 'b'
    b.set(randomBytes(4), 12);
    return pcAesEncryptNoPad(fileKey, new Uint8Array(AES_BLOCK), b);
  }
  /* ISO 32000-2 algorithms 8, 9 and 10 (U/UE, O/OE, Perms). */
  async function r6Entries(password, fileKey){
    var pw = pcPasswordBytes(password, 6), none = new Uint8Array(0), zeroIv = new Uint8Array(AES_BLOCK);
    var uVal = randomBytes(SALT_LEN), uKey = randomBytes(SALT_LEN);
    var U = pcConcat(await pcHashR6(pw, uVal, none), uVal, uKey);
    var UE = await pcAesEncryptNoPad(await pcHashR6(pw, uKey, none), zeroIv, fileKey);
    var oVal = randomBytes(SALT_LEN), oKey = randomBytes(SALT_LEN);
    var O = pcConcat(await pcHashR6(pw, oVal, U), oVal, oKey);
    var OE = await pcAesEncryptNoPad(await pcHashR6(pw, oKey, U), zeroIv, fileKey);
    return { U: U, UE: UE, O: O, OE: OE, Perms: await permsEntry(fileKey) };
  }
  /* AES-256-CBC with a fresh random IV in front and PKCS#7 padding (the
     WebCrypto default), as the standard asks for every string and stream. */
  function aesEncryptor(cryptoKey){
    return async function(bytes){
      var iv = randomBytes(AES_BLOCK);
      return pcConcat(iv, new Uint8Array(await pcSubtle.encrypt({ name: 'AES-CBC', iv: iv }, cryptoKey, bytes)));
    };
  }
  /* Encrypts every string inside `o` (dicts and arrays are walked in place);
     returns the replacement for `o` itself when `o` is a string. The /Contents
     of a signature dictionary is never encrypted (as in pcDecryptDoc). */
  async function encryptStrings(o, encrypt){
    var L = PDFLib;
    if(o instanceof L.PDFString || o instanceof L.PDFHexString) return L.PDFHexString.of(hexOf(await encrypt(o.asBytes())));
    if(o instanceof L.PDFArray){
      for(var i = 0; i < o.size(); i++){ var v = o.get(i), nv = await encryptStrings(v, encrypt); if(nv !== v) o.set(i, nv); }
      return o;
    }
    if(!(o instanceof L.PDFDict)) return o;
    // /Type is optional in a signature dictionary: /ByteRange marks one too
    var isSig = o.get(L.PDFName.of('Type')) === L.PDFName.of('Sig') || !!o.get(L.PDFName.of('ByteRange'));
    var entries = o.entries();
    for(var k = 0; k < entries.length; k++){
      if(isSig && entries[k][0] === L.PDFName.of('Contents')) continue;
      var nv2 = await encryptStrings(entries[k][1], encrypt);
      if(nv2 !== entries[k][1]) o.set(entries[k][0], nv2);
    }
    return o;
  }
  /* One indirect object: a stream gets its (already filtered) data encrypted,
     anything else its strings. Old cross-reference streams are dropped: the
     file is written with a classic cross-reference table. */
  async function encryptObject(context, ref, obj, encrypt){
    var L = PDFLib;
    // an object pdf-lib could not read is kept as raw bytes: it can't be
    // encrypted, and writing it as is would leave its content readable
    if(obj instanceof L.PDFInvalidObject) throw userError('protectDamaged');
    if(obj instanceof L.PDFStream){
      if(obj.dict.get(L.PDFName.of('Type')) === L.PDFName.of('XRef')){ context.delete(ref); return; }
      await encryptStrings(obj.dict, encrypt);
      context.assign(ref, L.PDFRawStream.of(obj.dict, await encrypt(obj.getContents())));
      return;
    }
    var nv = await encryptStrings(obj, encrypt);
    if(nv !== obj) context.assign(ref, nv);
  }
  /* AES-256 needs PDF 1.7 with Adobe extension level 8 (or PDF 2.0): an older
     header is raised to 1.7, a 2.0 file keeps its version. */
  function markR6Version(doc){
    var L = PDFLib, context = doc.context;
    var m = /(\d+)\.(\d+)/.exec(String(context.header));
    var ver = m ? Number(m[1]) + Number(m[2]) / 10 : 0;
    if(ver >= 2) return;
    if(ver < 1.7) context.header = L.PDFHeader.forVersion(1, 7);
    // other developers' extensions in an existing /Extensions stay
    var ext = doc.catalog.lookup(L.PDFName.of('Extensions'));
    if(!(ext instanceof L.PDFDict)){ ext = context.obj({}); doc.catalog.set(L.PDFName.of('Extensions'), ext); }
    ext.set(L.PDFName.of('ADBE'), context.obj({ BaseVersion: L.PDFName.of('1.7'), ExtensionLevel: R6_EXTENSION_LEVEL }));
  }
  async function encryptedBytes(doc, password, ctx){
    var L = PDFLib, context = doc.context;
    var fileKey = randomBytes(FILE_KEY_LEN);
    var encrypt = aesEncryptor(await pcAesKey(fileKey, 'encrypt'));
    markR6Version(doc);
    // (v94) an /Info written straight into the trailer (not as an object) was
    // skipped by the loop below: title and author stayed readable next to
    // the encrypted content. As an indirect object it is encrypted too.
    var info = context.trailerInfo.Info;
    if(info instanceof L.PDFDict) context.trailerInfo.Info = context.register(info);
    pcCollectGarbage(doc); // (v157) earlier revisions are not written along, not even encrypted
    var objects = context.enumerateIndirectObjects();
    for(var i = 0; i < objects.length; i++){
      pcCheckCancel();
      await encryptObject(context, objects[i][0], objects[i][1], encrypt);
      if(i % PROGRESS_EVERY === 0) ctx.setFraction(i / objects.length);
    }
    var e = await r6Entries(password, fileKey);
    var hex = function(b){ return L.PDFHexString.of(hexOf(b)); };
    var encDict = context.obj({
      Filter: 'Standard', V: 5, R: 6, Length: 256, P: PERMS_ALL, EncryptMetadata: true,
      CF: { StdCF: { AuthEvent: 'DocOpen', CFM: 'AESV3', Length: FILE_KEY_LEN } },
      StmF: 'StdCF', StrF: 'StdCF'
    });
    ['U', 'UE', 'O', 'OE', 'Perms'].forEach(function(k){ encDict.set(L.PDFName.of(k), hex(e[k])); });
    context.trailerInfo.Encrypt = context.register(encDict);
    var id = hexOf(randomBytes(ID_LEN));
    context.trailerInfo.ID = context.obj([L.PDFHexString.of(id), L.PDFHexString.of(id)]);
    // written straight from the context: doc.save() would first add new,
    // unencrypted objects (form appearances), which would break the file
    return L.PDFWriter.forContext(context, OBJECTS_PER_TICK).serializeToBuffer();
  }
  /* Reads the password field(s); a missing or mistyped password is an error
     marked on the field it concerns. */
  function protectPassword(){
    var a = ($('protect-password') || {}).value || '', b = ($('protect-password2') || {}).value || '';
    if(!a) throw Object.assign(fieldError('pwNeed'), { fieldId: 'protect-password' });
    if(a !== b) throw Object.assign(fieldError('pwMismatch'), { fieldId: 'protect-password2' });
    // the standard cuts a password at 127 bytes, but Chrome's PDF viewer does
    // not: a longer one would not open there, so it is refused up front
    if(new TextEncoder().encode(a.normalize('NFKC')).length > PC_PW_MAX_R6) throw Object.assign(fieldError('pwTooLong'), { fieldId: 'protect-password' });
    return a;
  }
  async function openForProtect(file){
    var bytes = new Uint8Array(await file.arrayBuffer());
    try{ return await openPdfForEdit(bytes, null, { keepXfa: true }); } // (v119) null: not with a password typed in another tool
    catch(e){
      if(pcIsCancel(e) || (e && e.userFacing)) throw e;
      pcThrowIfOutOfMemory(e); // (v73)
      pcLogUnexpected(e); throw userError(e && e.name === 'PasswordException' ? 'pwAlready' : 'invalidPdf');
    }
  }
  pcOnPanel('protect', function(){ setupTool('protect', {
    accept: isPdf, workingKey: 'protecting', zipName: 'protected-pdfs', fieldId: ['protect-password', 'protect-password2'],
    run: async function(files, _opt, ctx){
      if(!hasWebCrypto()) throw userError('noCrypto');
      var password = protectPassword();
      resetNotes();
      var out = await eachFile(files, ctx, async function(file, index){
        var r = await openForProtect(file);
        noteOpened(file, r);
        var sub = { setFraction: function(f){ ctx.setProgress((index + f) / files.length); } };
        var bytes = await encryptedBytes(r.doc, password, sub);
        return { blob: pdfBlob(bytes), filename: baseFileName(file.name) + '-protected.pdf' };
      });
      out.info = out.results.length === 1 ? t('protectInfoOne') : t('protectInfoMany', out.results.length);
      out.note = takeNotes();
      return out;
    }
  }); });

  /* Unlock: a file that opens without a password but has restrictions (an
     owner password) is unlocked with an empty field too. */
  async function openWithoutPassword(bytes){
    try{ return await openPdfForEdit(bytes, null, { keepXfa: true }); } // (v119) null: not with a password typed in another tool
    catch(e){
      if(e && e.name === 'PasswordException') return null; // it does need its password
      throw e;
    }
  }
  async function openForUnlock(file, password){
    var bytes = new Uint8Array(await file.arrayBuffer());
    var r;
    try{ r = await openPdfForEdit(bytes, password, { keepXfa: true }); }
    catch(e){
      if(pcIsCancel(e) || (e && e.userFacing)) throw e;
      pcThrowIfOutOfMemory(e); // (v73)
      if(!(e && e.name === 'PasswordException')) throw userError('invalidPdf');
      // a mistyped password on a file that opens without one (it only has
      // restrictions): unlocking it doesn't need the password at all
      if(e.wrongPassword) r = await openWithoutPassword(bytes);
      if(!r) throw Object.assign(fieldError(e.wrongPassword ? 'unlockWrong' : 'unlockNeed'), { fieldId: 'unlock-password' });
    }
    if(!r.decrypted) throw userError('unlockNone');
    noteCertificate(file, r.doc);
    return r.doc;
  }
  pcOnPanel('unlock', function(){ setupTool('unlock', {
    accept: isPdf, workingKey: 'unlocking', zipName: 'unlocked-pdfs', fieldId: 'unlock-password',
    run: async function(files, _opt, ctx){
      if(!hasWebCrypto()) throw userError('noCrypto');
      var password = ($('unlock-password') || {}).value || '';
      resetNotes();
      var out = await eachFile(files, ctx, async function(file){
        var doc = await openForUnlock(file, password);
        return { blob: pdfBlob(await pcSavePdf(doc)), filename: baseFileName(file.name) + '-unlocked.pdf' };
      });
      out.info = out.results.length === 1 ? t('unlockInfoOne') : t('unlockInfoMany', out.results.length);
      out.note = takeNotes();
      return out;
    }
  }); });

  /* ---------- PDF TO EXCEL (v61) ---------- */
  /* The conversion itself is in app-convert.js (convertOneFileToExcel),
     loaded on demand like PDF to Word and PowerPoint. */
  async function excelOneFile(file, index, total, oneSheet, ctx){
    var r;
    try{
      r = await convertOneFileToExcel(file, {
        oneSheet: oneSheet,
        sheetName: function(n){ return n ? t('sheetPage', n) : t('sheetAll'); }
      }, function(i, n, phase){
        pcCheckCancel();
        if(phase === PC_PHASE_FINISHING) return ctx.setStatus(t('last'));
        ctx.setStatus(t('pageN', index + 1, total, i, n));
        ctx.setProgress((index + i / Math.max(1, n)) / total);
      });
    }catch(e){
      if(pcIsCancel(e) || (e && e.userFacing)) throw e;
      pcLogUnexpected(e);
      pcThrowIfOutOfMemory(e); // (v73)
      throw (e && e.userFacing) ? e : userError(e && e.name === 'PasswordException' ? 'password' : 'invalidPdf');
    }
    if(r.noText) throw userError('excelNoText');
    return r;
  }
  pcOnPanel('excel', function(){ setupTool('excel', {
    accept: isPdf, optionsId: 'excel-mode-options', workingKey: 'excelWorking', zipName: 'converted-excel-files',
    run: async function(files, mode, ctx){
      pcRequirePdfJs(); // (v60) a browser too old for pdf.js gets a clear message
      await pcLoadLib('convert');
      var sheets = 0, tables = 0, done = [];
      var out = await eachFile(files, ctx, async function(file, index){
        var r = await excelOneFile(file, index, files.length, mode === 'one', ctx);
        sheets += r.sheets; tables += r.tables; done.push(r);
        return { blob: r.blob, filename: r.filename };
      });
      out.info = (out.results.length === 1 ? t('excelInfoOne') : t('excelInfoMany', out.results.length)) + ' – ' + t('excelCounts', sheets, tables);
      // what could not be carried over is said, never left silent (app.js pcConversionNote)
      out.note = [pcConversionNote(done), done.some(function(r){ return r.cellsCut; }) ? t('excelCellsCut') : '', tables ? '' : t('excelNoTables')].filter(Boolean).join(' ');
      return out;
    }
  }); });

  /* ---------- SIGN PDF (v61) ---------- */
  /* A signature is drawn on a pad or taken from a picture (a white
     background becomes transparent), placed by dragging it on a preview of
     the page, and stamped on the page as a picture with pdf-lib: a plain
     electronic signature, not a certificate-based digital signature. */
  var SIGN = {
    PAD_LINE: 2.6,          // pen width on the pad, CSS px
    TRIM_PAD: 6,            // px of air kept around the trimmed signature
    MAX_IMG_SIDE: 1600,     // a signature photo is scaled down to this
    WHITE_FROM: 235,        // brightness from which a pixel of a photo is background
    WHITE_SOFT: 55,         // ...fading in over this many steps (smooth edges)
    DEFAULT_W: 0.28,        // signature width as a fraction of the page width
    MIN_W: 0.06, MAX_W: 0.8,
    KEY_STEP: 0.01, KEY_STEP_BIG: 0.05,
    MAX_IMG_BYTES: 25 * 1024 * 1024, // a signature photo larger than this is refused (phone memory)
    PREVIEW_MAX_W: 720,     // CSS px
    PREVIEW_MAX_SCALE: 4,   // a tiny page is not blown up past this
    BLANK_IMG: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7' // (an <img> needs a src)
  };
  var sign = { mode: 'draw', png: null, aspect: 0, page: 1, pages: 0, fx: 0.62, fy: 0.78, fw: SIGN.DEFAULT_W,
    pageAspect: 1.414, pageWpt: 595, pageHpt: 842, previewFor: null, pdf: null, rendering: 0, strokes: 0, imgTicket: 0 };

  function signEl(id){ return $('sign-' + id); }
  function clamp(v, lo, hi){ return Math.max(lo, Math.min(hi, v)); }

  /* The signature pad: strokes with pointer events, smoothed. */
  function setupSignPad(){
    var pad = signEl('pad');
    if(!pad) return;
    var ctx = pad.getContext('2d'), drawing = false, last = null;
    function fit(){
      var r = pad.getBoundingClientRect(), dpr = window.devicePixelRatio || 1;
      if(!r.width) return;
      var w = Math.round(r.width * dpr), h = Math.round(r.height * dpr);
      if(w === pad.width && h === pad.height) return; // (v111) iOS fires resize while scrolling
      var keep = sign.strokes ? pad.toDataURL() : null, ow = pad.width, oh = pad.height;
      pad.width = w; pad.height = h;
      if(!keep) return;
      // (v111) the old drawing keeps its proportions (a rotated phone used to stretch it)
      var im = new Image();
      im.onload = function(){
        var k = Math.min(w / ow, h / oh);
        ctx.drawImage(im, 0, 0, ow * k, oh * k);
        signatureFromCanvas(pad);
      };
      im.src = keep;
    }
    function pos(e){ var r = pad.getBoundingClientRect(); return { x: (e.clientX - r.left) * pad.width / r.width, y: (e.clientY - r.top) * pad.height / r.height }; }
    pad.addEventListener('pointerdown', function(e){
      e.preventDefault();
      if(!pad.width || pad.width !== Math.round(pad.getBoundingClientRect().width * (window.devicePixelRatio || 1))) fit();
      drawing = true; last = pos(e);
      try{ pad.setPointerCapture(e.pointerId); }catch(err){ /* capture is a nicety: drawing works without it */ }
      ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      ctx.strokeStyle = (signEl('color') || {}).value || '#111111';
      ctx.lineWidth = SIGN.PAD_LINE * (window.devicePixelRatio || 1);
      ctx.beginPath(); ctx.arc(last.x, last.y, ctx.lineWidth / 2, 0, Math.PI * 2); ctx.fillStyle = ctx.strokeStyle; ctx.fill();
    });
    pad.addEventListener('pointermove', function(e){
      if(!drawing) return;
      var p = pos(e), mid = { x: (last.x + p.x) / 2, y: (last.y + p.y) / 2 };
      ctx.beginPath(); ctx.moveTo(last.x, last.y); ctx.quadraticCurveTo(last.x, last.y, mid.x, mid.y); ctx.lineTo(p.x, p.y); ctx.stroke();
      last = p;
    });
    function end(){ if(!drawing) return; drawing = false; sign.strokes++; signatureFromCanvas(pad); }
    pad.addEventListener('pointerup', end);
    pad.addEventListener('pointercancel', end);
    var clear = signEl('clear');
    if(clear) clear.addEventListener('click', function(){
      ctx.clearRect(0, 0, pad.width, pad.height); sign.strokes = 0; setSignature(null, 0);
    });
    var color = signEl('color');
    if(color) color.addEventListener('change', function(){ recolorPad(pad, color.value); });
    window.addEventListener('resize', function(){ if(!drawing) fit(); });
  }
  /* A new pen colour also turns what is already drawn into that colour. */
  function recolorPad(pad, hex){
    if(!sign.strokes) return;
    var ctx = pad.getContext('2d');
    ctx.save(); ctx.globalCompositeOperation = 'source-in'; ctx.fillStyle = hex; ctx.fillRect(0, 0, pad.width, pad.height); ctx.restore();
    signatureFromCanvas(pad);
  }
  /* The part of a canvas that has ink, as a new canvas (null: no ink). */
  function trimmed(canvas){
    var w = canvas.width, h = canvas.height;
    if(!w || !h) return null;
    var data = canvas.getContext('2d').getImageData(0, 0, w, h).data;
    var l = w, r = -1, t = h, b = -1;
    for(var y = 0; y < h; y++) for(var x = 0; x < w; x++){
      if(data[(y * w + x) * 4 + 3] > 8){ if(x < l) l = x; if(x > r) r = x; if(y < t) t = y; if(y > b) b = y; }
    }
    if(r < 0) return null;
    var P = SIGN.TRIM_PAD;
    l = Math.max(0, l - P); t = Math.max(0, t - P); r = Math.min(w - 1, r + P); b = Math.min(h - 1, b + P);
    var out = document.createElement('canvas');
    out.width = r - l + 1; out.height = b - t + 1;
    out.getContext('2d').drawImage(canvas, l, t, out.width, out.height, 0, 0, out.width, out.height);
    return out;
  }
  function signatureFromCanvas(canvas){
    var c = trimmed(canvas);
    if(!c){ setSignature(null, 0); return; }
    setSignature(c.toDataURL('image/png'), c.height / c.width);
  }
  function setSignature(dataUrl, aspect){
    sign.png = dataUrl; sign.aspect = aspect;
    var img = signEl('overlay-img');
    if(img) img.src = dataUrl || SIGN.BLANK_IMG;
    placeOverlay();
  }
  /* A photo or scan of a signature: white paper becomes transparent. */
  function loadSignatureImage(file){
    var ticket = ++sign.imgTicket; // a slower, older picture never replaces a newer choice
    if(file.size > SIGN.MAX_IMG_BYTES){ setSignature(null, 0); signImageStatus(t('signImgBig')); return; }
    // (v67) a cut-off PNG or JPG still loads, with a black or grey part
    file.arrayBuffer().then(function(buf){
      if(ticket !== sign.imgTicket || sign.mode !== 'image') return;
      var b = new Uint8Array(buf);
      if(imageCutOff(b)){ setSignature(null, 0); signImageStatus(t('imgTruncated')); return; }
      try{ checkDecodeLimit(b); } // (v90) too many pixels: refused before the browser decodes it
      catch(e){ setSignature(null, 0); signImageStatus(e.message); return; }
      decodeSignatureImage(file, ticket);
    }, function(e){
      if(ticket !== sign.imgTicket || sign.mode !== 'image') return;
      setSignature(null, 0); signImageStatus(memoryOr(e, 'signImgBad').message);
    });
  }
  function imageCutOff(b){
    var kind = sniffImage(b);
    if(kind === 'png') return !pngComplete(b);
    if(kind === 'jpeg') return !jpegComplete(b);
    return false; // other formats: the browser's decoder decides
  }
  function decodeSignatureImage(file, ticket){
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function(){
      URL.revokeObjectURL(url);
      if(ticket !== sign.imgTicket || sign.mode !== 'image') return;
      // (v90) a canvas or memory fault here used to leave the old status standing
      try{ whiteToTransparent(img); }
      catch(e){ pcLogUnexpected(e); setSignature(null, 0); signImageStatus(memoryOr(e, 'signImgBad').message); }
    };
    img.onerror = function(){
      URL.revokeObjectURL(url);
      if(ticket !== sign.imgTicket || sign.mode !== 'image') return;
      setSignature(null, 0); signImageStatus(t('signImgBad'));
    };
    img.src = url;
  }
  /* The picture scaled down, with its white paper made transparent. */
  function whiteToTransparent(img){
    var k = Math.min(1, SIGN.MAX_IMG_SIDE / Math.max(img.naturalWidth, img.naturalHeight));
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(img.naturalWidth * k)); c.height = Math.max(1, Math.round(img.naturalHeight * k));
    var ctx = pcCanvas2d(c);
    ctx.drawImage(img, 0, 0, c.width, c.height);
    var id = ctx.getImageData(0, 0, c.width, c.height), d = id.data;
    for(var i = 0; i < d.length; i += 4){
      var lum = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
      var fade = clamp((SIGN.WHITE_FROM - lum) / SIGN.WHITE_SOFT, 0, 1);
      d[i + 3] = Math.round(d[i + 3] * fade);
    }
    ctx.putImageData(id, 0, 0);
    signImageStatus('');
    signatureFromCanvas(c);
  }
  function signImageStatus(msg){
    var el = signEl('image-error'), input = signEl('image-input');
    if(el){ el.textContent = msg; el.hidden = !msg; }
    if(input){ if(msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid'); }
  }
  /* ---- (v157) a typed signature: the name in one of three handwriting
     fonts (SIL OFL, /vendor/fonts/signature-5.3.0/, loaded on first use) ---- */
  var SIGN_FONTS = [['caveat', 'Caveat'], ['dancing-script', 'Dancing Script'], ['great-vibes', 'Great Vibes']];
  var SIGN_FONT_DIR = '/vendor/fonts/signature-5.3.0/';
  var SIGN_RANGES = { latin: 'U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+20AC,U+2122,U+FEFF,U+FFFD',
    'latin-ext': 'U+0100-02BA,U+02BD-02C5,U+02C7-02CC,U+02CE-02D7,U+02DD-02FF,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF' };
  var SIGN_TYPE = { PX: 120, PAD: 24, MAX_CHARS: 60, COLORS: ['#111111', '#1a3d8f'] };
  var signFontsLoaded = {};
  function signFontFamily(key){ return 'pcsig-' + key; }
  function loadSignFont(key){
    if(signFontsLoaded[key]) return signFontsLoaded[key];
    var faces = Object.keys(SIGN_RANGES).map(function(r){
      return new FontFace(signFontFamily(key), 'url(' + SIGN_FONT_DIR + key + '-' + r + '-400-normal.woff2)', { unicodeRange: SIGN_RANGES[r] });
    });
    signFontsLoaded[key] = Promise.all(faces.map(function(f){ return f.load().then(function(l){ document.fonts.add(l); }); }))
      .catch(function(e){ delete signFontsLoaded[key]; throw e; });
    return signFontsLoaded[key];
  }
  function setupSignType(){
    var group = $('sign-mode-options'), image = signEl('image');
    if(!group || !image) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'quality-opt'; b.dataset.value = 'type'; b.setAttribute('aria-pressed', 'false');
    var st = document.createElement('strong'); st.textContent = t('signType');
    var sp = document.createElement('span'); sp.textContent = t('signTypeHint');
    b.appendChild(st); b.appendChild(sp); group.appendChild(b);
    group.classList.add('quality-options--3');
    var box = document.createElement('div'); box.id = 'sign-type'; box.hidden = true;
    var lab = document.createElement('label'); lab.className = 'text-field'; lab.htmlFor = 'sign-type-text'; lab.textContent = t('signTypeName');
    var inp = document.createElement('input'); inp.type = 'text'; inp.id = 'sign-type-text'; inp.className = 'text-input'; inp.maxLength = SIGN_TYPE.MAX_CHARS; inp.autocomplete = 'name';
    box.appendChild(lab); box.appendChild(inp);
    var row = document.createElement('div'); row.className = 'nup-opts'; box.appendChild(row);
    var font = scriptSelect(row, 'sign-type-font', t('signTypeStyle'), SIGN_FONTS.map(function(f){ return f[0]; }), SIGN_FONTS.map(function(f){ return f[1]; }).join('|'), SIGN_FONTS[0][0]);
    var color = scriptSelect(row, 'sign-type-color', t('signTypeColor'), SIGN_TYPE.COLORS, t('signTypeColors'), SIGN_TYPE.COLORS[0]);
    var err = document.createElement('p'); err.className = 'field-error'; err.hidden = true; err.setAttribute('role', 'alert'); box.appendChild(err);
    image.insertAdjacentElement('afterend', box);
    var redraw = function(){ if(sign.mode === 'type') signatureFromTyped(inp.value, font.value, color.value, err).catch(pcLogUnexpected); };
    [inp, font, color].forEach(function(c){ c.addEventListener(c === inp ? 'input' : 'change', redraw); });
    return redraw;
  }
  var signTypeTicket = 0;
  async function signatureFromTyped(name, key, color, err){
    var ticket = ++signTypeTicket;
    name = name.replace(/\s+/g, ' ').trim();
    err.hidden = true;
    if(!name){ setSignature(null, 0); return; }
    try{ await loadSignFont(key); }
    catch(e){ pcLogUnexpected(e); if(ticket === signTypeTicket){ setSignature(null, 0); err.textContent = t('signTypeFontFail'); err.hidden = false; } return; }
    if(ticket !== signTypeTicket || sign.mode !== 'type') return;
    var c = document.createElement('canvas'), fontCss = SIGN_TYPE.PX + 'px "' + signFontFamily(key) + '"';
    var g = pcCanvas2d(c);
    g.font = fontCss;
    c.width = Math.ceil(g.measureText(name).width + 2 * SIGN_TYPE.PAD); c.height = Math.ceil(SIGN_TYPE.PX * 1.6);
    g = pcCanvas2d(c); // the size change reset the context
    g.font = fontCss; g.fillStyle = color; g.textBaseline = 'middle';
    g.fillText(name, SIGN_TYPE.PAD, c.height / 2);
    signatureFromCanvas(c);
    pcReleaseCanvas(c);
  }
  function setupSignSource(){
    var redrawTyped = setupSignType();
    var opts = document.querySelectorAll('#sign-mode-options .quality-opt');
    opts.forEach(function(o){ o.addEventListener('click', function(){
      sign.mode = o.dataset.value;
      signEl('draw').hidden = sign.mode !== 'draw';
      signEl('image').hidden = sign.mode !== 'image';
      if(signEl('type')) signEl('type').hidden = sign.mode !== 'type';
      if(sign.mode === 'draw') signatureFromCanvas(signEl('pad'));
      else if(sign.mode === 'type'){ setSignature(null, 0); if(redrawTyped) redrawTyped(); }
      else{ var f = signEl('image-input').files[0]; if(f) loadSignatureImage(f); else setSignature(null, 0); }
    }); });
    var input = signEl('image-input');
    if(input) input.addEventListener('change', function(){ if(input.files[0]) loadSignatureImage(input.files[0]); else setSignature(null, 0); });
  }

  /* ---- placement on a preview of the page ---- */
  function placeOverlay(){
    var ov = signEl('overlay'), stage = signEl('stage');
    if(!ov || !stage) return;
    var has = !!sign.png && sign.pages > 0;
    ov.hidden = !has;
    signEl('empty').hidden = has || !sign.pages;
    if(!has) return;
    var fh = sign.fw * sign.aspect / sign.pageAspect; // height as a fraction of the page height
    var on = !!(signEl('date') || {}).checked;
    // the date in the size it gets in the PDF (see stampPage), and room for it under the signature
    var datePt = pcSignDateSize(sign.fw * sign.pageWpt * sign.aspect);
    var dateFh = on ? datePt * PC_SIGN.DATE_LINE / sign.pageHpt : 0;
    sign.fx = clamp(sign.fx, 0, 1 - sign.fw);
    sign.fy = clamp(sign.fy, 0, Math.max(0, 1 - fh - dateFh));
    ov.style.left = (sign.fx * 100) + '%';
    ov.style.top = (sign.fy * 100) + '%';
    ov.style.width = (sign.fw * 100) + '%';
    var date = signEl('overlay-date');
    if(date){
      date.hidden = !on;
      if(on){ date.textContent = todayText(); date.style.fontSize = (datePt * stage.clientWidth / sign.pageWpt) + 'px'; }
    }
  }
  function todayText(){
    var s;
    // (English: day first, as in the rest of Europe -- "09/30" reads wrongly to most visitors)
    try{ s = new Intl.DateTimeFormat(LANG === 'en' ? 'en-GB' : LANG, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date()); }
    catch(e){ s = new Date().toISOString().slice(0, 10); }
    return s.replace(/[^0-9./\- ]/g, '').trim(); // the plain PDF font draws digits and these marks only
  }
  /* (v65) where the signature now stands, for screen reader users; said once
     the arrow keys rest, not on every repeat (placeOverlay keeps it on the page) */
  var SIGN_POS_ANNOUNCE_MS = 300, signPosTimer = null;
  function announceSignPos(){
    clearTimeout(signPosTimer);
    signPosTimer = setTimeout(function(){
      pcAnnounce(t('signPos', t('pct', Math.round(sign.fx * 100)), t('pct', Math.round(sign.fy * 100))));
    }, SIGN_POS_ANNOUNCE_MS);
  }
  function setupSignDrag(){
    var ov = signEl('overlay'), stage = signEl('stage');
    if(!ov || !stage) return;
    var start = null;
    ov.addEventListener('pointerdown', function(e){
      e.preventDefault();
      start = { x: e.clientX, y: e.clientY, fx: sign.fx, fy: sign.fy };
      try{ ov.setPointerCapture(e.pointerId); }catch(err){ /* dragging works without capture */ }
      ov.classList.add('dragging');
    });
    ov.addEventListener('pointermove', function(e){
      if(!start) return;
      var r = stage.getBoundingClientRect();
      sign.fx = start.fx + (e.clientX - start.x) / r.width;
      sign.fy = start.fy + (e.clientY - start.y) / r.height;
      placeOverlay();
    });
    function end(){ start = null; ov.classList.remove('dragging'); }
    ov.addEventListener('pointerup', end);
    ov.addEventListener('pointercancel', end);
    ov.addEventListener('keydown', function(e){
      var step = e.shiftKey ? SIGN.KEY_STEP_BIG : SIGN.KEY_STEP;
      var moves = { ArrowLeft: [-step, 0], ArrowRight: [step, 0], ArrowUp: [0, -step], ArrowDown: [0, step] };
      if(!moves[e.key]) return;
      e.preventDefault();
      sign.fx += moves[e.key][0]; sign.fy += moves[e.key][1];
      placeOverlay();
      announceSignPos();
    });
    var size = signEl('size');
    if(size){
      size.value = String(Math.round(sign.fw * 100));
      size.addEventListener('input', function(){ sign.fw = clamp(Number(size.value) / 100, SIGN.MIN_W, SIGN.MAX_W); placeOverlay(); });
    }
    var date = signEl('date');
    if(date) date.addEventListener('change', placeOverlay);
    window.addEventListener('resize', placeOverlay);
  }
  function setupSignPager(){
    var prev = signEl('prev'), next = signEl('next');
    var go = function(step){
      var file = sign.previewFor;
      sign.page += step;
      renderSignPreview().catch(function(e){ if(sign.previewFor === file) showPreviewError(e); });
    };
    if(prev) prev.addEventListener('click', function(){ if(sign.page > 1) go(-1); });
    if(next) next.addEventListener('click', function(){ if(sign.page < sign.pages) go(1); });
  }
  /* (v111) Previous/next: a button that becomes disabled under the keyboard
     focus hands the focus to the other one (it would fall to the page). */
  function pagerButtons(prev, next, page, pages){
    [[prev, page <= 1, next], [next, page >= pages, prev]].forEach(function(b){
      if(b[1] && document.activeElement === b[0] && !b[2].disabled) b[2].focus();
      b[0].disabled = b[1];
      if(b[1] && document.activeElement === b[0]) b[2].focus();
    });
  }
  /* (v111) A preview message that appears is also read out (role=alert on
     an element that was hidden is not announced reliably). */
  function showPreviewMsg(msg, text){
    msg.textContent = text;
    msg.hidden = false;
    pcAnnounce(text, true);
  }
  /* (v111) A preview opens only while its own panel is shown: every tool
     page carries all panels, and a hidden one must not read the file a
     second time (memory on a phone). */
  /* (v157) On a phone a file the tool will refuse anyway (memory) is not
     opened for a preview either: reading it already closed the tab on an iPhone. */
  function previewTooHeavy(name, file){ return !!file && pcIsPhone() && pcMemEstimate(name, [file]) > PC_PHONE_MEM_STOP; }
  function previewGate(name, open, current){
    var panel = $('panel-' + name), pending = null;
    var go = function(){
      if(!panel.classList.contains('active') || pending === current()) return;
      open(previewTooHeavy(name, pending) ? null : pending).catch(pcLogUnexpected);
    };
    new MutationObserver(go).observe(panel, { attributes: true, attributeFilter: ['class'] });
    return function(file){ pending = file; go(); };
  }
  function signPanelActive(){ var p = $('panel-sign'); return !!(p && p.classList.contains('active')); }
  async function closeSignPreview(){
    var pdf = sign.pdf; sign.pdf = null; sign.pages = 0;
    if(pdf){ try{ await pdf.destroy(); }catch(e){ pcLogUnexpected(e); } }
  }
  /* The first PDF of the list is shown; the signature goes on every file at
     the same place (on its last page when a file is shorter). */
  /* (v142) Each opening has its own number: an older one that is still
     loading (the same file opened again after its password) stops quietly
     instead of keeping its copy or showing an error over the new preview. */
  var signOpenSeq = 0;
  async function openSignPreview(file){
    var my = ++signOpenSeq, pw = previewPassword(file); // read now: a run that reopens the preview forgets it right after
    sign.previewFor = file;
    await closeSignPreview();
    var place = signEl('place'), msg = signEl('preview-error'), task = null;
    msg.hidden = true;
    clearPreviewPassword('sign');
    if(!file){ place.hidden = true; placeOverlay(); return; }
    place.hidden = false;
    try{
      await pcLoadPdfLibs();
      pcRequirePdfJs();
      var bytes = new Uint8Array(await file.arrayBuffer());
      task = pcGetDocument(Object.assign(pcPdfSource(bytes), pw ? { password: pw } : {}));
      var pdf = await task.promise;
      if(my !== signOpenSeq){ await destroyTask(task); return; }
      task._pcDoc = pdf; sign.pdf = pdf; sign.pages = pdf.numPages; sign.page = Math.min(sign.page, sign.pages) || 1;
      await renderSignPreview();
    }catch(e){
      if(task && sign.pdf !== task._pcDoc) await destroyTask(task); // a password or broken file: pdf.js still holds it
      if(my !== signOpenSeq) return;
      if(isPasswordError(e)){ signNoPreview(); askPreviewPassword('sign', msg, file, !!pw, openSignPreviewLogged, signEl('place-title')); return; }
      showPreviewError(e);
    }
  }
  function openSignPreviewLogged(file){ openSignPreview(file).catch(pcLogUnexpected); }
  function signNoPreview(){
    sign.pages = 0;
    signEl('stage').hidden = true;
    placeOverlay();
  }
  function showPreviewError(e){
    pcLogUnexpected(e);
    showPreviewMsg(signEl('preview-error'), reasonOf(e, 'invalidPdf'));
    signNoPreview();
  }
  async function renderSignPreview(){
    var pdf = sign.pdf;
    try{ await drawSignPreview(pdf); }
    catch(e){ if(sign.pdf === pdf) throw e; } // (v142) its document was closed meanwhile (a newer preview): nothing to show
  }
  async function drawSignPreview(pdf){
    var canvas = signEl('preview'), stage = signEl('stage');
    if(!pdf || !canvas) return;
    var ticket = ++sign.rendering;
    var page = await pdf.getPage(sign.page);
    if(ticket !== sign.rendering){ page.cleanup(); return; }
    var vp1 = page.getViewport({ scale: 1 });
    stage.hidden = false;
    var cssW = Math.min(SIGN.PREVIEW_MAX_W, stage.parentElement.clientWidth || SIGN.PREVIEW_MAX_W);
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    // (v90) within the canvas limits (iPhone: 16.7 MP), also for a very long page
    var vp = page.getViewport({ scale: canvasScale(vp1, Math.min(cssW * dpr / vp1.width, SIGN.PREVIEW_MAX_SCALE)) });
    var off = document.createElement('canvas');
    try{
      off.width = Math.max(1, Math.floor(vp.width)); off.height = Math.max(1, Math.floor(vp.height));
      await page.render({ canvasContext: pcCanvas2d(off), viewport: vp }).promise;
      if(ticket !== sign.rendering) return;
      canvas.width = off.width; canvas.height = off.height;
      canvas.getContext('2d').drawImage(off, 0, 0);
    }finally{
      off.width = off.height = 0; // (v90) also when rendering fails
      page.cleanup();
    }
    stage.style.width = cssW + 'px';
    sign.pageAspect = vp1.width / vp1.height; sign.pageWpt = vp1.width; sign.pageHpt = vp1.height;
    signEl('pageinfo').textContent = t('signPage', sign.page, sign.pages);
    pagerButtons(signEl('prev'), signEl('next'), sign.page, sign.pages);
    placeOverlay();
  }

  /* ---- stamping: pcSignPdfFile (pc-pdfcore.js), in the worker (perf) ---- */
  var signShort = []; // (v111) files with fewer pages than the chosen page
  async function signOnePdf(file, opt, ctx){
    var r = await ctx.worker.run('signPdf', file, opt);
    noteJob(file, r);
    if(r.short) noteName(signShort, file);
    return { blob: r.blob, filename: r.filename };
  }
  function dataUrlBytes(url){
    var bin = atob(url.slice(url.indexOf(',') + 1)), out = new Uint8Array(bin.length);
    for(var i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
    return out;
  }
  pcOnPanel('sign', function(){
    setupSignPad(); setupSignSource(); setupSignDrag(); setupSignPager();
    var pendingPreview = null;
    var showPreview = function(){
      if(!signPanelActive() || pendingPreview === sign.previewFor) return;
      openSignPreview(previewTooHeavy('sign', pendingPreview) ? null : pendingPreview).catch(pcLogUnexpected);
    };
    new MutationObserver(showPreview).observe($('panel-sign'), { attributes: true, attributeFilter: ['class'] });
    setupTool('sign', {
      accept: isPdf, workingKey: 'signing', zipName: 'signed-pdfs', fieldId: ['sign-image-input', 'sign-type-text'],
      onFiles: function(list){ pendingPreview = list[0] || null; showPreview(); },
      run: async function(files, _opt, ctx){
        if(!sign.png){
          // (v65) focus goes where the signature is made: the picture input is
          // marked as a field to correct (app.js); the drawing box (a canvas,
          // which can't carry aria-invalid) gets the focus itself and keeps it
          if(sign.mode === 'image') throw Object.assign(fieldError('signNeed'), { fieldId: 'sign-image-input' });
          if(sign.mode === 'type') throw Object.assign(fieldError('signNeed'), { fieldId: 'sign-type-text' });
          var pad = signEl('pad');
          if(pad){ pad.tabIndex = -1; pad.focus(); }
          throw userError('signNeed');
        }
        var bytes = dataUrlBytes(sign.png);
        var dateText = (signEl('date') || {}).checked ? todayText() : '';
        resetNotes();
        signShort = [];
        // (v94) the preview's pdf.js copy of the file is closed while signing
        // (a second copy in memory on a phone) and opened again afterwards
        var previewFile = sign.previewFor;
        signOpenSeq++; // (v142) a preview still loading stops too, instead of opening during the job
        await closeSignPreview();
        var out;
        var opt = { png: bytes, dateText: dateText, all: !!(signEl('all') || {}).checked, page: sign.page,
          at: { fx: sign.fx, fy: sign.fy, fw: sign.fw, aspect: sign.aspect }, msgs: jobMsgs() };
        try{ out = await eachFile(files, ctx, function(file){ return signOnePdf(file, opt, ctx); }); }
        finally{ if(previewFile && sign.previewFor === previewFile) openSignPreview(previewFile).catch(pcLogUnexpected); }
        out.info = out.results.length === 1 ? t('signInfoOne') : t('signInfoMany', out.results.length);
        out.note = [takeNotes('signBrokeCert'), signShort.length ? t('signShortNote', signShort.join(', '), sign.page) : ''].filter(Boolean).join(' ');
        return out;
      }
    });
  });

  /* ---------- (v88) PAGES PER SHEET (hand-outs) ----------
     (ww03) The work (nupOnePdf, nupSheet, PC_NUP) is a job in pc-pdfcore.js,
     so it runs in the worker: 1,500 pages used to block this page ~1 s. */
  function nupEl(id){ return $('nup-' + id); }
  function nupSettings(layout){
    var notes = layout === 'notes';
    return {
      notes: notes, n: notes ? PC_NUP.NOTES_ROWS : (PC_NUP.GRID[layout] ? Number(layout) : 4),
      paper: (nupEl('paper') || {}).value === 'letter' ? 'letter' : 'a4',
      orient: notes ? 'portrait' : ((nupEl('orient') || {}).value || 'auto'),
      byColumn: !notes && (nupEl('order') || {}).value === 'col',
      frame: !!(nupEl('frame') || {}).checked
    };
  }
  pcOnPanel('nup', function(){
    if(prefersLetter() && nupEl('paper')) nupEl('paper').value = 'letter'; // (v153) see preselectLetter
    var nupToggle = function(layout){
      var notes = layout === 'notes';
      ['orient-field', 'order-field'].forEach(function(id){ var el = nupEl(id); if(el) el.hidden = notes; });
    };
    document.querySelectorAll('#nup-layout-options .quality-opt').forEach(function(o){
      o.addEventListener('click', function(){ nupToggle(o.dataset.value); });
    });
    setupTool('nup', {
      accept: isPdf, optionsId: 'nup-layout-options', workingKey: 'nupWorking', zipName: 'pages-per-sheet',
      run: async function(files, layout, ctx){
        var s = nupSettings(layout);
        resetNotes();
        var formNames = [], opt = { s: s, msgs: jobMsgs() };
        var out = await eachFile(files, ctx, async function(file, i){
          var r = await ctx.worker.run('nupPdf', file, opt, function(frac){ ctx.setProgress((i + frac) / files.length); }); // (ww03) in the worker
          noteJob(file, r);
          if(r.formMissing) formNames.push(file.name);
          return r;
        });
        var r0 = out.results[0];
        out.info = out.results.length > 1 ? t('nupInfoMany', out.results.length)
          : r0.pages === 1 ? t('nupInfoPage') : r0.sheets === 1 ? t('nupInfoSheet', r0.pages) : t('nupInfo', r0.pages, r0.sheets);
        out.note = [takeNotes(), formNames.length ? t('nupFormNote', formNames.join(', ')) : ''].filter(Boolean).join(' ');
        return out;
      }
    });
  });

  /* ========== (v110) FOUR MORE TOOLS: metadata, PDF to text, crop, extract images ========== */
  var MSG110 = {
    en: {
      imgsReducedNote: 'Saved smaller, because they are too large for this device: {0}.', signShortNote: 'Signed on the last page, because they have no page {1}: {0}.', jpgReencodedNote: 'Saved as JPEG on a white background, because the picture could not be placed as it is: {0}.', metaWorking: 'Cleaning metadata…', metaInfoOne: '1 file cleaned', metaInfoMany: '{0} files cleaned',
      metaShownFor: 'Shown: {0}', metaNone: '—', metaYes: 'yes', metaNo: 'no', metaReadFail: 'Could not read the metadata of {0}: {1}',
      metaCustom: 'Custom fields', metaXmp: 'XMP metadata', metaCertNote: 'Note: {0} had a certificate-based digital signature. That signature is no longer valid in the cleaned copy.', metaPdfaNote: 'Note: {0} was a PDF/A file (for archiving). Without its XMP metadata the cleaned copy no longer counts as PDF/A.',
      metaTitle: 'Title', metaAuthor: 'Author', metaSubject: 'Subject', metaKeywords: 'Keywords', metaCreator: 'Made with', metaProducer: 'Converted with', metaCreated: 'Created', metaModified: 'Last changed',
      txtWorking: 'Reading text…', txtInfoOne: '1 text file, {0} pages', txtInfoMany: '{0} text files', txtNoText: 'This PDF has no text that can be read (it is probably a scan or photo), so there is nothing to save as text.',
      txtUnmapped: "Some characters in {0} could not be read, because the PDF's font does not say which letters they are; they are shown as �. For those pages, try OCR PDF.", // (v157) TXT_UNMAPPED_RE
      txtScanNote: 'No text was found on {0} ({1}): those pages are probably scans or pictures.', txtPage: 'page {0}', txtPagesOf: '{0} of {1} pages',
      cropSmallNote: "These pages are smaller than the margins, so they were left as they are: {0}.", // (v157) cropOnePdf
      cropWorking: 'Cropping pages…', cropInfoOne: '1 file cropped', cropInfoMany: '{0} files cropped', cropTooMuch: 'The margins are larger than the page. Use smaller values.',
      cropBad: 'Type the margins as numbers in millimetres (0 or more).', cropPage: 'Page {0} of {1}', cropAutoInfo: 'Cut off on this page: top {0} mm, right {1} mm, bottom {2} mm, left {3} mm.', cropAutoPageNone: 'No white edge to trim on this page.', cropAutoNone: 'Nothing to trim: {0} has no white margins to remove.',
      cropBlankNote: 'Left unchanged (blank page): {0}.', cropMm: '{0} mm',
      imgsWorking: 'Looking for images…', imgsPageN: 'File {0} of {1} — page {2} of {3}…', imgsInfoOne: '1 image found', imgsInfoMany: '{0} images found',
      imgsNone: 'No images were found in this PDF. Text, lines and shapes are not images; a scanned page is one big picture and comes out as a whole page.',
      imgsSkippedNote: 'Skipped as too small (icons, spacers): {0}.', imgsUnreadable: 'Could not be read (the browser gave up on decoding them): {0}.', txtInfoOnePage: '1 text file, 1 page', imgsMaskNote: 'Some pictures are drawn as masks (black-and-white stencils); those can\'t be saved as separate images.'
    },
    nl: {
      imgsReducedNote: 'Kleiner bewaard, omdat ze te groot zijn voor dit toestel: {0}.', signShortNote: 'Op de laatste pagina ondertekend, omdat ze geen pagina {1} hebben: {0}.', jpgReencodedNote: 'Als JPEG op een witte achtergrond bewaard, omdat de afbeelding niet ongewijzigd geplaatst kon worden: {0}.', metaWorking: 'Metadata wissen…', metaInfoOne: '1 bestand opgeschoond', metaInfoMany: '{0} bestanden opgeschoond',
      metaShownFor: 'Getoond: {0}', metaNone: '—', metaYes: 'ja', metaNo: 'nee', metaReadFail: 'De metadata van {0} kon niet gelezen worden: {1}',
      metaCustom: 'Eigen velden', metaXmp: 'XMP-metadata', metaCertNote: 'Let op: {0} had een digitale handtekening met certificaat. Die handtekening is in de opgeschoonde kopie niet meer geldig.', metaPdfaNote: 'Let op: {0} was een PDF/A-bestand (om te archiveren). Zonder de XMP-metadata telt de opgeschoonde kopie niet meer als PDF/A.',
      metaTitle: 'Titel', metaAuthor: 'Auteur', metaSubject: 'Onderwerp', metaKeywords: 'Trefwoorden', metaCreator: 'Gemaakt met', metaProducer: 'Omgezet met', metaCreated: 'Aangemaakt', metaModified: 'Laatst gewijzigd',
      txtWorking: 'Tekst lezen…', txtInfoOne: "1 tekstbestand, {0} pagina's", txtInfoMany: '{0} tekstbestanden', txtNoText: 'Deze PDF bevat geen leesbare tekst (waarschijnlijk een scan of foto), dus er is niets om als tekst te bewaren.',
      txtUnmapped: "Sommige tekens in {0} konden niet gelezen worden, omdat het lettertype van de PDF niet zegt welke letters het zijn; ze staan er als �. Probeer voor die pagina's OCR PDF.", // (v157) TXT_UNMAPPED_RE
      txtScanNote: "Geen tekst gevonden op {0} ({1}): die pagina's zijn waarschijnlijk scans of afbeeldingen.", txtPage: 'pagina {0}', txtPagesOf: "{0} van {1} pagina's",
      cropSmallNote: "Deze pagina's zijn kleiner dan de marges en zijn daarom gelaten zoals ze waren: {0}.", // (v157) cropOnePdf
      cropWorking: "Pagina's bijsnijden…", cropInfoOne: '1 bestand bijgesneden', cropInfoMany: '{0} bestanden bijgesneden', cropTooMuch: 'De marges zijn groter dan de pagina. Gebruik kleinere waarden.',
      cropBad: 'Typ de marges als getallen in millimeter (0 of meer).', cropPage: 'Pagina {0} van {1}', cropAutoInfo: 'Wat op deze pagina wegvalt: boven {0} mm, rechts {1} mm, onder {2} mm, links {3} mm.', cropAutoPageNone: 'Geen witte rand om weg te snijden op deze pagina.', cropAutoNone: 'Niets bij te snijden: {0} heeft geen witte randen.',
      cropBlankNote: 'Ongewijzigd gelaten (lege pagina): {0}.', cropMm: '{0} mm',
      imgsWorking: 'Afbeeldingen zoeken…', imgsPageN: 'Bestand {0} van {1} – pagina {2} van {3}…', imgsInfoOne: '1 afbeelding gevonden', imgsInfoMany: '{0} afbeeldingen gevonden',
      imgsNone: 'In deze PDF zijn geen afbeeldingen gevonden. Tekst, lijnen en vormen zijn geen afbeeldingen; een gescande pagina is één grote afbeelding en komt er als hele pagina uit.',
      imgsSkippedNote: 'Overgeslagen omdat ze heel klein zijn (icoontjes, opvulling): {0}.', imgsUnreadable: 'Kon niet gelezen worden (de browser kreeg ze niet gedecodeerd): {0}.', txtInfoOnePage: '1 tekstbestand, 1 pagina', imgsMaskNote: 'Sommige afbeeldingen zijn maskers (zwart-witsjablonen); die kunnen niet als losse afbeelding bewaard worden.'
    },
    fr: {
      imgsReducedNote: 'Enregistrées en plus petit, car trop grandes pour cet appareil : {0}.', signShortNote: 'Signés sur la dernière page, car ils n’ont pas de page {1} : {0}.', jpgReencodedNote: 'Enregistrées en JPEG sur fond blanc, car l’image n’a pas pu être placée telle quelle : {0}.', metaWorking: 'Suppression des métadonnées…', metaInfoOne: '1 fichier nettoyé', metaInfoMany: '{0} fichiers nettoyés',
      metaShownFor: 'Affiché : {0}', metaNone: '—', metaYes: 'oui', metaNo: 'non', metaReadFail: 'Impossible de lire les métadonnées de {0} : {1}',
      metaCustom: 'Champs personnalisés', metaXmp: 'Métadonnées XMP', metaCertNote: 'Remarque : {0} comportait une signature numérique avec certificat. Cette signature n’est plus valide dans la copie nettoyée.', metaPdfaNote: 'Remarque : {0} était un fichier PDF/A (archivage). Sans ses métadonnées XMP, la copie nettoyée n’est plus considérée comme PDF/A.',
      metaTitle: 'Titre', metaAuthor: 'Auteur', metaSubject: 'Sujet', metaKeywords: 'Mots-clés', metaCreator: 'Créé avec', metaProducer: 'Converti avec', metaCreated: 'Créé le', metaModified: 'Modifié le',
      txtWorking: 'Lecture du texte…', txtInfoOne: '1 fichier texte, {0} pages', txtInfoMany: '{0} fichiers texte', txtNoText: 'Ce PDF ne contient aucun texte lisible (sans doute un scan ou une photo) : il n’y a donc rien à enregistrer en texte.',
      txtUnmapped: "Certains caractères de {0} n’ont pas pu être lus, car la police du PDF n’indique pas de quelles lettres il s’agit ; ils apparaissent sous la forme �. Pour ces pages, essayez OCR PDF.", // (v157) TXT_UNMAPPED_RE
      txtScanNote: 'Aucun texte trouvé sur {0} ({1}) : ces pages sont probablement des scans ou des images.', txtPage: 'page {0}', txtPagesOf: '{0} pages sur {1}',
      cropSmallNote: "Ces pages sont plus petites que les marges, elles sont donc restées telles quelles : {0}.", // (v157) cropOnePdf
      cropWorking: 'Recadrage des pages…', cropInfoOne: '1 fichier recadré', cropInfoMany: '{0} fichiers recadrés', cropTooMuch: 'Les marges dépassent la page. Utilisez des valeurs plus petites.',
      cropBad: 'Indiquez les marges en millimètres (0 ou plus).', cropPage: 'Page {0} sur {1}', cropAutoInfo: 'Retiré sur cette page : haut {0} mm, droite {1} mm, bas {2} mm, gauche {3} mm.', cropAutoPageNone: 'Aucun bord blanc à retirer sur cette page.', cropAutoNone: 'Rien à rogner : {0} n’a pas de marges blanches.',
      cropBlankNote: 'Laissée telle quelle (page vide) : {0}.', cropMm: '{0} mm',
      imgsWorking: 'Recherche des images…', imgsPageN: 'Fichier {0} sur {1} – page {2} sur {3}…', imgsInfoOne: '1 image trouvée', imgsInfoMany: '{0} images trouvées',
      imgsNone: 'Aucune image trouvée dans ce PDF. Le texte, les lignes et les formes ne sont pas des images ; une page scannée est une seule grande image et ressort en page entière.',
      imgsSkippedNote: 'Ignorées car trop petites (icônes, espaceurs) : {0}.', imgsUnreadable: 'Illisibles (le navigateur n’a pas pu les décoder) : {0}.', txtInfoOnePage: '1 fichier texte, 1 page', imgsMaskNote: 'Certaines images sont des masques (pochoirs noir et blanc) ; elles ne peuvent pas être enregistrées séparément.'
    },
    de: {
      imgsReducedNote: 'Verkleinert gespeichert, weil sie für dieses Gerät zu groß sind: {0}.', signShortNote: 'Auf der letzten Seite unterschrieben, weil sie keine Seite {1} haben: {0}.', jpgReencodedNote: 'Als JPEG auf weißem Hintergrund gespeichert, weil das Bild nicht unverändert eingefügt werden konnte: {0}.', metaWorking: 'Metadaten werden entfernt…', metaInfoOne: '1 Datei bereinigt', metaInfoMany: '{0} Dateien bereinigt',
      metaShownFor: 'Angezeigt: {0}', metaNone: '—', metaYes: 'ja', metaNo: 'nein', metaReadFail: 'Die Metadaten von {0} konnten nicht gelesen werden: {1}',
      metaCustom: 'Eigene Felder', metaXmp: 'XMP-Metadaten', metaCertNote: 'Hinweis: {0} hatte eine zertifikatsbasierte digitale Signatur. Diese Signatur ist in der bereinigten Kopie nicht mehr gültig.', metaPdfaNote: 'Hinweis: {0} war eine PDF/A-Datei (zur Archivierung). Ohne ihre XMP-Metadaten gilt die bereinigte Kopie nicht mehr als PDF/A.',
      metaTitle: 'Titel', metaAuthor: 'Autor', metaSubject: 'Thema', metaKeywords: 'Stichwörter', metaCreator: 'Erstellt mit', metaProducer: 'Umgewandelt mit', metaCreated: 'Erstellt am', metaModified: 'Zuletzt geändert',
      txtWorking: 'Text wird gelesen…', txtInfoOne: '1 Textdatei, {0} Seiten', txtInfoMany: '{0} Textdateien', txtNoText: 'Dieses PDF enthält keinen lesbaren Text (wahrscheinlich ein Scan oder Foto), es gibt also nichts als Text zu speichern.',
      txtUnmapped: "Einige Zeichen in {0} konnten nicht gelesen werden, weil die Schrift des PDFs nicht angibt, welche Buchstaben es sind; sie erscheinen als �. Versuchen Sie für diese Seiten OCR PDF.", // (v157) TXT_UNMAPPED_RE
      txtScanNote: 'Auf {0} ({1}) wurde kein Text gefunden: Diese Seiten sind wahrscheinlich Scans oder Bilder.', txtPage: 'Seite {0}', txtPagesOf: '{0} von {1} Seiten',
      cropSmallNote: "Diese Seiten sind kleiner als die Ränder und bleiben daher unverändert: {0}.", // (v157) cropOnePdf
      cropWorking: 'Seiten werden zugeschnitten…', cropInfoOne: '1 Datei zugeschnitten', cropInfoMany: '{0} Dateien zugeschnitten', cropTooMuch: 'Die Ränder sind größer als die Seite. Verwenden Sie kleinere Werte.',
      cropBad: 'Geben Sie die Ränder als Zahlen in Millimetern an (0 oder mehr).', cropPage: 'Seite {0} von {1}', cropAutoInfo: 'Auf dieser Seite abgeschnitten: oben {0} mm, rechts {1} mm, unten {2} mm, links {3} mm.', cropAutoPageNone: 'Kein weißer Rand zum Abschneiden auf dieser Seite.', cropAutoNone: 'Nichts zu beschneiden: {0} hat keine weißen Ränder.',
      cropBlankNote: 'Unverändert gelassen (leere Seite): {0}.', cropMm: '{0} mm',
      imgsWorking: 'Bilder werden gesucht…', imgsPageN: 'Datei {0} von {1} – Seite {2} von {3}…', imgsInfoOne: '1 Bild gefunden', imgsInfoMany: '{0} Bilder gefunden',
      imgsNone: 'In diesem PDF wurden keine Bilder gefunden. Text, Linien und Formen sind keine Bilder; eine gescannte Seite ist ein einziges großes Bild und kommt als ganze Seite heraus.',
      imgsSkippedNote: 'Übersprungen, weil zu klein (Icons, Platzhalter): {0}.', imgsUnreadable: 'Nicht lesbar (der Browser konnte sie nicht dekodieren): {0}.', txtInfoOnePage: '1 Textdatei, 1 Seite', imgsMaskNote: 'Einige Bilder sind Masken (Schwarz-Weiß-Schablonen); diese können nicht als eigene Bilder gespeichert werden.'
    },
    es: {
      imgsReducedNote: 'Guardadas más pequeñas, porque son demasiado grandes para este dispositivo: {0}.', signShortNote: 'Firmados en la última página, porque no tienen página {1}: {0}.', jpgReencodedNote: 'Guardadas como JPEG sobre fondo blanco, porque la imagen no se pudo colocar tal cual: {0}.', metaWorking: 'Borrando metadatos…', metaInfoOne: '1 archivo limpiado', metaInfoMany: '{0} archivos limpiados',
      metaShownFor: 'Se muestra: {0}', metaNone: '—', metaYes: 'sí', metaNo: 'no', metaReadFail: 'No se pudieron leer los metadatos de {0}: {1}',
      metaCustom: 'Campos personalizados', metaXmp: 'Metadatos XMP', metaCertNote: 'Nota: {0} tenía una firma digital con certificado. Esa firma ya no es válida en la copia limpiada.', metaPdfaNote: 'Nota: {0} era un archivo PDF/A (para archivar). Sin sus metadatos XMP, la copia limpiada ya no cuenta como PDF/A.',
      metaTitle: 'Título', metaAuthor: 'Autor', metaSubject: 'Asunto', metaKeywords: 'Palabras clave', metaCreator: 'Creado con', metaProducer: 'Convertido con', metaCreated: 'Creado', metaModified: 'Última modificación',
      txtWorking: 'Leyendo el texto…', txtInfoOne: '1 archivo de texto, {0} páginas', txtInfoMany: '{0} archivos de texto', txtNoText: 'Este PDF no tiene texto que se pueda leer (probablemente es un escaneo o una foto), así que no hay nada que guardar como texto.',
      txtUnmapped: "Algunos caracteres de {0} no se pudieron leer, porque la fuente del PDF no indica qué letras son; aparecen como �. Para esas páginas, prueba OCR PDF.", // (v157) TXT_UNMAPPED_RE
      txtScanNote: 'No se encontró texto en {0} ({1}): esas páginas probablemente son escaneos o imágenes.', txtPage: 'página {0}', txtPagesOf: '{0} de {1} páginas',
      cropSmallNote: "Estas páginas son más pequeñas que los márgenes, así que se han dejado como estaban: {0}.", // (v157) cropOnePdf
      cropWorking: 'Recortando páginas…', cropInfoOne: '1 archivo recortado', cropInfoMany: '{0} archivos recortados', cropTooMuch: 'Los márgenes son mayores que la página. Usa valores más pequeños.',
      cropBad: 'Escribe los márgenes como números en milímetros (0 o más).', cropPage: 'Página {0} de {1}', cropAutoInfo: 'Se recorta en esta página: arriba {0} mm, derecha {1} mm, abajo {2} mm, izquierda {3} mm.', cropAutoPageNone: 'No hay borde blanco que recortar en esta página.', cropAutoNone: 'Nada que recortar: {0} no tiene márgenes blancos.',
      cropBlankNote: 'Sin cambios (página en blanco): {0}.', cropMm: '{0} mm',
      imgsWorking: 'Buscando imágenes…', imgsPageN: 'Archivo {0} de {1} – página {2} de {3}…', imgsInfoOne: '1 imagen encontrada', imgsInfoMany: '{0} imágenes encontradas',
      imgsNone: 'No se encontraron imágenes en este PDF. El texto, las líneas y las formas no son imágenes; una página escaneada es una sola imagen grande y sale como página entera.',
      imgsSkippedNote: 'Omitidas por ser muy pequeñas (iconos, separadores): {0}.', imgsUnreadable: 'No se pudieron leer (el navegador no logró decodificarlas): {0}.', txtInfoOnePage: '1 archivo de texto, 1 página', imgsMaskNote: 'Algunas imágenes son máscaras (plantillas en blanco y negro); esas no se pueden guardar como imágenes sueltas.'
    },
    pt: {
      imgsReducedNote: 'Salvas menores, porque são grandes demais para este dispositivo: {0}.', signShortNote: 'Assinados na última página, porque não têm página {1}: {0}.', jpgReencodedNote: 'Salvas como JPEG em fundo branco, porque a imagem não pôde ser colocada como está: {0}.', metaWorking: 'Apagando metadados…', metaInfoOne: '1 arquivo limpo', metaInfoMany: '{0} arquivos limpos',
      metaShownFor: 'Exibido: {0}', metaNone: '—', metaYes: 'sim', metaNo: 'não', metaReadFail: 'Não foi possível ler os metadados de {0}: {1}',
      metaCustom: 'Campos personalizados', metaXmp: 'Metadados XMP', metaCertNote: 'Observação: {0} tinha uma assinatura digital com certificado. Essa assinatura não é mais válida na cópia limpa.', metaPdfaNote: 'Observação: {0} era um arquivo PDF/A (para arquivamento). Sem os metadados XMP, a cópia limpa não conta mais como PDF/A.',
      metaTitle: 'Título', metaAuthor: 'Autor', metaSubject: 'Assunto', metaKeywords: 'Palavras-chave', metaCreator: 'Criado com', metaProducer: 'Convertido com', metaCreated: 'Criado em', metaModified: 'Última alteração',
      txtWorking: 'Lendo o texto…', txtInfoOne: '1 arquivo de texto, {0} páginas', txtInfoMany: '{0} arquivos de texto', txtNoText: 'Este PDF não tem texto legível (provavelmente é um escaneamento ou uma foto), então não há nada para salvar como texto.',
      txtUnmapped: "Alguns caracteres de {0} não puderam ser lidos, porque a fonte do PDF não indica quais letras são; eles aparecem como �. Para essas páginas, experimente OCR PDF.", // (v157) TXT_UNMAPPED_RE
      txtScanNote: 'Nenhum texto encontrado em {0} ({1}): essas páginas provavelmente são escaneamentos ou imagens.', txtPage: 'página {0}', txtPagesOf: '{0} de {1} páginas',
      cropSmallNote: "Estas páginas são menores que as margens, então foram mantidas como estavam: {0}.", // (v157) cropOnePdf
      cropWorking: 'Recortando páginas…', cropInfoOne: '1 arquivo recortado', cropInfoMany: '{0} arquivos recortados', cropTooMuch: 'As margens são maiores que a página. Use valores menores.',
      cropBad: 'Digite as margens como números em milímetros (0 ou mais).', cropPage: 'Página {0} de {1}', cropAutoInfo: 'Cortado nesta página: em cima {0} mm, à direita {1} mm, embaixo {2} mm, à esquerda {3} mm.', cropAutoPageNone: 'Nenhuma borda branca para cortar nesta página.', cropAutoNone: 'Nada a recortar: {0} não tem margens brancas.',
      cropBlankNote: 'Mantida sem alteração (página em branco): {0}.', cropMm: '{0} mm',
      imgsWorking: 'Procurando imagens…', imgsPageN: 'Arquivo {0} de {1} – página {2} de {3}…', imgsInfoOne: '1 imagem encontrada', imgsInfoMany: '{0} imagens encontradas',
      imgsNone: 'Nenhuma imagem foi encontrada neste PDF. Texto, linhas e formas não são imagens; uma página escaneada é uma única imagem grande e sai como página inteira.',
      imgsSkippedNote: 'Ignoradas por serem muito pequenas (ícones, espaçadores): {0}.', imgsUnreadable: 'Não puderam ser lidas (o navegador não conseguiu decodificá-las): {0}.', txtInfoOnePage: '1 arquivo de texto, 1 página', imgsMaskNote: 'Algumas imagens são máscaras (estênceis em preto e branco); essas não podem ser salvas como imagens separadas.'
    }, it: {
      imgsReducedNote: "Salvate in formato più piccolo, perché troppo grandi per questo dispositivo: {0}.", signShortNote: "Firmati sull'ultima pagina, perché non hanno una pagina {1}: {0}.", jpgReencodedNote: "Salvate come JPEG su sfondo bianco, perché l'immagine non poteva essere inserita così com'è: {0}.", metaWorking: "Pulizia dei metadati…", metaInfoOne: "1 file ripulito", metaInfoMany: "{0} file ripuliti",
      metaShownFor: "File mostrato: {0}", metaNone: "—", metaYes: "sì", metaNo: "no", metaReadFail: "Impossibile leggere i metadati di {0}: {1}",
      metaCustom: "Campi personalizzati", metaXmp: "Metadati XMP", metaCertNote: "Nota: {0} aveva una firma digitale basata su certificato. Quella firma non è più valida nella copia ripulita.", metaPdfaNote: "Nota: {0} era un file PDF/A (per l'archiviazione). Senza i suoi metadati XMP, la copia ripulita non conta più come PDF/A.",
      metaTitle: "Titolo", metaAuthor: "Autore", metaSubject: "Oggetto", metaKeywords: "Parole chiave", metaCreator: "Creato con", metaProducer: "Convertito con", metaCreated: "Data di creazione", metaModified: "Ultima modifica",
      txtWorking: "Lettura del testo…", txtInfoOne: "1 file di testo, {0} pagine", txtInfoMany: "{0} file di testo", txtNoText: "Questo PDF non ha testo leggibile (probabilmente è una scansione o una foto), quindi non c'è niente da salvare come testo.",
      txtUnmapped: "Alcuni caratteri di {0} non si sono potuti leggere, perché il font del PDF non indica di quali lettere si tratta; compaiono come �. Per quelle pagine prova OCR PDF.", // (v157) TXT_UNMAPPED_RE
      txtScanNote: "Nessun testo trovato in {0} ({1}): quelle pagine sono probabilmente scansioni o immagini.", txtPage: "pagina {0}", txtPagesOf: "{0} di {1} pagine",
      cropSmallNote: "Queste pagine sono più piccole dei margini, quindi sono state lasciate com'erano: {0}.", // (v157) cropOnePdf
      cropWorking: "Ritaglio delle pagine…", cropInfoOne: "1 file ritagliato", cropInfoMany: "{0} file ritagliati", cropTooMuch: "I margini sono più grandi della pagina. Usa valori più piccoli.",
      cropBad: "Inserisci i margini come numeri in millimetri (0 o più).", cropPage: "Pagina {0} di {1}", cropAutoInfo: "Ritagliato su questa pagina: sopra {0} mm, destra {1} mm, sotto {2} mm, sinistra {3} mm.", cropAutoPageNone: "Nessun bordo bianco da rifilare su questa pagina.", cropAutoNone: "Niente da rifilare: {0} non ha margini bianchi da rimuovere.",
      cropBlankNote: "Lasciato invariato (pagina vuota): {0}.", cropMm: "{0} mm",
      imgsWorking: "Ricerca delle immagini…", imgsPageN: "File {0} di {1} — pagina {2} di {3}…", imgsInfoOne: "1 immagine trovata", imgsInfoMany: "{0} immagini trovate",
      imgsNone: "Nessuna immagine trovata in questo PDF. Testo, linee e forme non sono immagini; una pagina scansionata è un'unica grande immagine ed esce come pagina intera.",
      imgsSkippedNote: "Saltate perché troppo piccole (icone, spaziatori): {0}.", imgsUnreadable: "Impossibile leggerle (il browser non è riuscito a decodificarle): {0}.", txtInfoOnePage: "1 file di testo, 1 pagina", imgsMaskNote: "Alcune immagini sono disegnate come maschere (stencil in bianco e nero); queste non si possono salvare come immagini separate."
    }, pl: {
      imgsReducedNote: "Zapisano w mniejszym rozmiarze, bo były za duże dla tego urządzenia: {0}.", signShortNote: "Podpisano na ostatniej stronie, bo nie mają strony {1}: {0}.", jpgReencodedNote: "Zapisano jako JPEG na białym tle, bo obrazu nie dało się wstawić w niezmienionej postaci: {0}.", metaWorking: "Czyszczenie metadanych…", metaInfoOne: "Oczyszczono 1 plik", metaInfoMany: "Oczyszczono {0} {0#plik|pliki|plików}",
      metaShownFor: "Pokazany plik: {0}", metaNone: "—", metaYes: "tak", metaNo: "nie", metaReadFail: "Nie udało się odczytać metadanych pliku {0}: {1}",
      metaCustom: "Pola niestandardowe", metaXmp: "Metadane XMP", metaCertNote: "Uwaga: {0} miał podpis cyfrowy oparty na certyfikacie. W oczyszczonej kopii ten podpis nie jest już ważny.", metaPdfaNote: "Uwaga: {0} był plikiem PDF/A (do archiwizacji). Bez metadanych XMP oczyszczona kopia nie jest już plikiem PDF/A.",
      metaTitle: "Tytuł", metaAuthor: "Autor", metaSubject: "Temat", metaKeywords: "Słowa kluczowe", metaCreator: "Utworzono w", metaProducer: "Przekonwertowano w", metaCreated: "Data utworzenia", metaModified: "Ostatnia zmiana",
      txtWorking: "Odczytywanie tekstu…", txtInfoOne: "1 plik tekstowy, {0} {0#strona|strony|stron}", txtInfoMany: "{0} {0#plik tekstowy|pliki tekstowe|plików tekstowych}", txtNoText: "Ten PDF nie ma tekstu do odczytania (prawdopodobnie to skan lub zdjęcie), więc nie ma czego zapisać jako tekst.",
      txtUnmapped: "Niektórych znaków w {0} nie udało się odczytać, bo czcionka PDF nie podaje, jakie to litery; są pokazane jako �. Dla tych stron spróbuj OCR PDF.", // (v157) TXT_UNMAPPED_RE
      txtScanNote: "Nie znaleziono tekstu w {0} ({1}): te strony to prawdopodobnie skany lub obrazy.", txtPage: "strona {0}", txtPagesOf: "{0} z {1} {1#strony|stron|stron}",
      cropSmallNote: "Te strony są mniejsze niż marginesy, więc pozostawiono je bez zmian: {0}.", // (v157) cropOnePdf
      cropWorking: "Przycinanie stron…", cropInfoOne: "Przycięto 1 plik", cropInfoMany: "Przycięto {0} {0#plik|pliki|plików}", cropTooMuch: "Marginesy są większe niż strona. Użyj mniejszych wartości.",
      cropBad: "Wpisz marginesy jako liczby w milimetrach (0 lub więcej).", cropPage: "Strona {0} z {1}", cropAutoInfo: "Przycięto na tej stronie: góra {0} mm, prawo {1} mm, dół {2} mm, lewo {3} mm.", cropAutoPageNone: "Na tej stronie nie ma białych brzegów do odcięcia.", cropAutoNone: "Nie ma czego przycinać: {0} nie ma białych marginesów do usunięcia.",
      cropBlankNote: "Pozostawiono bez zmian (pusta strona): {0}.", cropMm: "{0} mm",
      imgsWorking: "Szukanie obrazów…", imgsPageN: "Plik {0} z {1} — strona {2} z {3}…", imgsInfoOne: "Znaleziono 1 obraz", imgsInfoMany: "Znaleziono {0} {0#obraz|obrazy|obrazów}",
      imgsNone: "W tym PDF nie znaleziono obrazów. Tekst, linie i kształty nie są obrazami; zeskanowana strona to jeden duży obraz i wychodzi jako cała strona.",
      imgsSkippedNote: "Pominięto, bo są za małe (ikony, odstępy): {0}.", imgsUnreadable: "Nie udało się ich odczytać (przeglądarka nie zdołała ich zdekodować): {0}.", txtInfoOnePage: "1 plik tekstowy, 1 strona", imgsMaskNote: "Niektóre obrazy są narysowane jako maski (czarno-białe szablony); nie da się ich zapisać jako osobnych obrazów."
    }
  };
  Object.keys(MSG110).forEach(function(l){ Object.assign(MSG[l], MSG110[l]); });

  /* ---------- (v110) METADATA: show, wipe or replace ---------- */
  var META_KEYS = ['Title', 'Author', 'Subject', 'Keywords', 'Creator', 'Producer', 'CreationDate', 'ModDate'];
  var META_EDIT_KEYS = ['Title', 'Author', 'Subject', 'Keywords'];
  var META_LABEL = { Title: 'metaTitle', Author: 'metaAuthor', Subject: 'metaSubject', Keywords: 'metaKeywords', Creator: 'metaCreator',
    Producer: 'metaProducer', CreationDate: 'metaCreated', ModDate: 'metaModified' };
  var META_TRAPPED = 'Trapped'; // a flag for printers, kept: it says nothing about a person
  function metaEl(id){ return $('meta-' + id); }
  function metaInfoDict(doc){
    var ref = doc.context.trailerInfo.Info;
    var d = ref ? doc.context.lookup(ref) : null;
    return d instanceof PDFLib.PDFDict ? d : null;
  }
  /* A PDF date ("D:20260101120000+01'00'") as the visitor's date format; anything else as typed. */
  function metaDateText(s){
    var m = /^D:(\d{4})(\d{2})?(\d{2})?(\d{2})?(\d{2})?(\d{2})?/.exec(s);
    if(!m) return s;
    var d = new Date(Date.UTC(+m[1], (+m[2] || 1) - 1, +m[3] || 1, +m[4] || 0, +m[5] || 0, +m[6] || 0));
    if(isNaN(d.getTime())) return s;
    try{ return d.toLocaleString(LANG === 'en' ? 'en-GB' : (document.documentElement.lang || LANG), { dateStyle: 'medium', timeStyle: 'short', timeZone: 'UTC' }); }
    catch(e){ return d.toISOString().slice(0, 16).replace('T', ' '); }
  }
  function metaString(o){
    if(o instanceof PDFLib.PDFString || o instanceof PDFLib.PDFHexString){
      try{ return o.decodeText(); }catch(e){ return ''; }
    }
    return o ? String(o) : '';
  }
  /* What the file says about itself: the standard fields, how many custom ones, and whether an XMP packet is there. */
  function metaRead(doc){
    var info = metaInfoDict(doc), out = { fields: {}, custom: 0, xmp: false };
    if(info){
      info.entries().forEach(function(e){
        var key = e[0].decodeText ? e[0].decodeText() : String(e[0]).slice(1);
        var val = doc.context.lookup(e[1]);
        if(META_KEYS.indexOf(key) >= 0) out.fields[key] = metaString(val).trim();
        else if(key !== META_TRAPPED) out.custom++;
      });
    }
    out.xmp = !!doc.catalog.get(pcN('Metadata'));
    return out;
  }
  function metaRow(label, value){
    var dt = document.createElement('dt'), dd = document.createElement('dd');
    dt.textContent = label; dd.textContent = value || t('metaNone');
    if(!value) dd.className = 'meta-empty';
    return [dt, dd];
  }
  function metaShow(file, read, err){
    var box = metaEl('view'), list = metaEl('list'), who = metaEl('for');
    if(!box) return;
    if(!file){ box.hidden = true; return; }
    box.hidden = false;
    who.textContent = t('metaShownFor', file.name);
    list.replaceChildren();
    if(err){ who.textContent = t('metaReadFail', file.name, reasonOf(err, 'invalidPdf')); return; }
    if(!read) return; // (v143) not read yet: the password is asked under the name
    META_KEYS.forEach(function(k){
      var v = read.fields[k] || '';
      if(k === 'CreationDate' || k === 'ModDate') v = v && metaDateText(v);
      metaRow(t(META_LABEL[k]), v).forEach(function(n){ list.appendChild(n); });
    });
    metaRow(t('metaXmp'), t(read.xmp ? 'metaYes' : 'metaNo')).forEach(function(n){ list.appendChild(n); });
    if(read.custom) metaRow(t('metaCustom'), String(read.custom)).forEach(function(n){ list.appendChild(n); });
    // the edit fields start from what the file has, unless the visitor already typed
    META_EDIT_KEYS.forEach(function(k){
      var inp = metaEl('f-' + k.toLowerCase());
      if(inp && !inp.dataset.typed) inp.value = read.fields[k] || '';
    });
  }
  var metaPreviewFor = null;
  async function metaPreview(file){
    metaPreviewFor = file;
    clearPreviewPassword('meta');
    if(!file){ metaShow(null); return; }
    var pw = previewPassword(file);
    try{
      await pcLoadPdfLibs();
      // (v111) opened directly, not with loadPdfLib: that one collects notes
      // for a run, and a preview finishing during a run must not touch them
      var bytes = new Uint8Array(await file.arrayBuffer());
      var r = await (pw ? openPdfForEdit(bytes, pw) : openPdfForEdit(bytes));
      if(metaPreviewFor !== file) return;
      metaShow(file, metaRead(r.doc));
    }catch(e){
      if(metaPreviewFor !== file) return;
      if(isPasswordError(e)){
        metaShow(file, null, null);
        askPreviewPassword('meta', metaEl('for'), file, !!pw, function(f){ if(metaPreviewFor === f) metaPreview(f).catch(pcLogUnexpected); }, metaEl('for'));
        return;
      }
      pcLogUnexpected(e);
      metaShow(file, null, e);
    }
  }
  /* Every /Metadata (XMP) stream anywhere: the catalog, pages, images from Photoshop… */
  function metaDropXmp(doc){
    var n = 0, key = pcN('Metadata');
    doc.context.enumerateIndirectObjects().forEach(function(pair){
      var o = pair[1], d = o instanceof PDFLib.PDFStream ? o.dict : o;
      if(!(d instanceof PDFLib.PDFDict) || !d.has(key)) return;
      var ref = d.get(key);
      d.delete(key); n++;
      if(ref instanceof PDFLib.PDFRef) doc.context.delete(ref);
    });
    return n;
  }
  /* (v115) A PDF/A file (for archiving) says so in its XMP packet: without
     that packet the cleaned copy is no longer PDF/A, which the visitor
     should know (an archive or a court portal may refuse it). */
  var PDFA_ID_RE = /pdfaid:part/;
  function metaIsPdfA(doc){
    var s = doc.catalog.lookupMaybe(pcN('Metadata'), PDFLib.PDFStream);
    if(!s) return false;
    try{
      var bytes = s instanceof PDFLib.PDFRawStream ? PDFLib.decodePDFRawStream(s).decode() : s.getContents();
      return PDFA_ID_RE.test(new TextDecoder('utf-8', { fatal: false }).decode(bytes));
    }catch(e){ pcLogUnexpected(e); return false; } // an unreadable packet: no PDF/A claim we can see
  }
  function metaWipe(doc, fields){
    var L = PDFLib, ctx = doc.context;
    var old = metaInfoDict(doc);
    var info = ctx.obj({});
    if(old && old.has(pcN(META_TRAPPED))) info.set(pcN(META_TRAPPED), old.get(pcN(META_TRAPPED)));
    Object.keys(fields || {}).forEach(function(k){ if(fields[k]) info.set(pcN(k), L.PDFHexString.fromText(fields[k])); });
    if(ctx.trailerInfo.Info instanceof L.PDFRef) ctx.delete(ctx.trailerInfo.Info);
    ctx.trailerInfo.Info = ctx.register(info);
    metaDropXmp(doc);
    doc.catalog.delete(pcN('PieceInfo')); // private application data (Illustrator, InDesign)
    doc.getPages().forEach(function(p){ p.node.delete(pcN('PieceInfo')); p.node.delete(pcN('LastModified')); }); // (v157) a page's own edit date too
    doc.catalog.delete(pcN('LastModified'));
    // a fresh document ID: the old one can tie this copy to the original
    var id = randomBytes(ID_LEN);
    ctx.trailerInfo.ID = ctx.obj([L.PDFHexString.of(hexOf(id)), L.PDFHexString.of(hexOf(id))]);
  }
  /* (v111) Only what the visitor typed (or cleared); a field left as it was
     pre-filled keeps each file's own value, so with several files the first
     file's title doesn't land on all of them. */
  function metaFieldsTyped(){
    var f = {};
    META_EDIT_KEYS.forEach(function(k){ var inp = metaEl('f-' + k.toLowerCase()); if(inp && inp.dataset.typed) f[k] = inp.value.trim(); });
    return f;
  }
  function metaFieldsFor(doc, typed){
    var own = metaRead(doc).fields, f = {};
    META_EDIT_KEYS.forEach(function(k){ f[k] = typed[k] !== undefined ? typed[k] : (own[k] || ''); });
    return f;
  }
  pcOnPanel('meta', function(){
    META_EDIT_KEYS.forEach(function(k){
      var inp = metaEl('f-' + k.toLowerCase());
      if(inp) inp.addEventListener('input', function(){ inp.dataset.typed = '1'; });
    });
    var metaToggle = function(mode){ var box = metaEl('edit'); if(box) box.hidden = mode !== 'edit'; };
    document.querySelectorAll('#meta-mode-options .quality-opt').forEach(function(o){
      o.addEventListener('click', function(){ metaToggle(o.dataset.value); });
    });
    setupTool('meta', {
      accept: isPdf, optionsId: 'meta-mode-options', workingKey: 'metaWorking', zipName: 'pdf-without-metadata',
      onFiles: (function(gate){ return function(files){ gate(files[0] || null); }; })(previewGate('meta', metaPreview, function(){ return metaPreviewFor; })),
      run: async function(files, mode, ctx){
        var fields = mode === 'edit' ? metaFieldsTyped() : null;
        resetNotes();
        var pdfaNames = [];
        var out = await eachFile(files, ctx, async function(file){
          var doc = await loadPdfLib(file);
          if(metaIsPdfA(doc)) noteName(pdfaNames, file);
          metaWipe(doc, fields && metaFieldsFor(doc, fields));
          pcCheckCancel();
          return { blob: pdfBlob(await pcSavePdf(doc)), filename: baseFileName(file.name) + (mode === 'edit' ? '-metadata.pdf' : '-clean.pdf') };
        });
        out.info = out.results.length === 1 ? t('metaInfoOne') : t('metaInfoMany', out.results.length);
        out.note = [takeNotes('metaCertNote'), pdfaNames.length ? t('metaPdfaNote', pdfaNames.join(', ')) : ''].filter(Boolean).join(' ');
        return out;
      }
    });
  });

  /* ---------- (v110) PDF TO TEXT ---------- */
  var TXT = { LINE_TOL: 0.5, GAP_SPACE: 0.15, PARA_GAP: 1.4, EOL: '\r\n', SKEW: 0.05 };
  /* pdf.js gives the text in the order the PDF draws it (usually reading
     order, column by column). Lines are cut where the baseline moves;
     words get a space where the PDF left a gap. */
  /* (v157) A text item that runs up, down or at an angle (a journal's
     "Protected by copyright" down the margin) broke the lines it crossed into
     fragments; such items are read on their own, after the page's text. */
  function txtHorizontal(it){ var m = it.transform; return Math.abs(m[1]) < TXT.SKEW * Math.abs(m[0]) && Math.abs(m[2]) < TXT.SKEW * Math.abs(m[3]); }
  /* (review v157) only when the page also has upright text: a page whose
     text all runs sideways (a landscape table, a turned scan's OCR) is read as before */
  function txtHasUpright(content){ return content.items.some(function(it){ return it.str && it.str.trim() && txtHorizontal(it); }); }
  function txtSideText(content){
    if(!txtHasUpright(content)) return '';
    var s = '';
    // separate pieces down a margin rarely belong to one word: a space between them
    content.items.forEach(function(it){ if(it.str !== undefined && !txtHorizontal(it)) s += it.str + ' '; });
    return s.replace(/\s+/g, ' ').trim();
  }
  function txtLinesOf(content){
    var lines = [], cur = null, upright = txtHasUpright(content);
    content.items.forEach(function(it){
      if(it.str === undefined) return; // marked-content markers
      if(upright && !txtHorizontal(it)) return; // (v157) read apart: txtSideText
      var x = it.transform[4], y = it.transform[5], h = it.height || Math.abs(it.transform[3]) || 10;
      var w = it.width || 0;
      var newLine = !cur || Math.abs(y - cur.y) > TXT.LINE_TOL * Math.max(h, cur.h);
      if(newLine){ cur = { y: y, h: h, text: '', xEnd: x }; lines.push(cur); }
      else if(it.str && cur.text && !/\s$/.test(cur.text) && !/^\s/.test(it.str)){
        var gap = x - cur.xEnd, charW = it.str.length ? w / it.str.length : h * 0.5;
        // (v157) ...also before a piece drawn LEFT of the previous one on the same baseline ("1 of 10Lin I, et al.")
        if(gap > TXT.GAP_SPACE * Math.max(charW, 1) || gap < -Math.max(charW, 1)) cur.text += ' ';
      }
      cur.text += it.str;
      cur.xEnd = x + w;
      if(it.hasEOL) cur = null;
    });
    return lines;
  }
  /* (v157) Office bullets from Symbol/Wingdings arrive as private-use
     characters (U+F0B7 ...): a box or nothing in a text editor. U+F0B7 is
     the Symbol bullet anywhere; the others only as a line's first
     character, where they are list bullets. And a LaTeX (OT1) accent is a
     separate spacing mark before its letter ("co\u00A8effici\u00A8enten"):
     joined into the accented letter when such a letter exists. */
  var TXT_PUA_BULLET = '\uF0B7';
  var TXT_LEAD_BULLETS = { '\uF0A7': '\u25AA', '\uF0D8': '\u27A2', '\uF076': '\u2756', '\uF0FC': '\u2713', '\uF06E': '\u25A0', '\uF06C': '\u25CF', '\uF071': '\u2751', '\uF0E0': '\u2192' };
  var TXT_SPACING_ACCENTS = { '\u00A8': '\u0308', '\u00B4': '\u0301', '\u02C6': '\u0302', '\u02DC': '\u0303' };
  function txtCleanLine(text){
    var out = text.split(TXT_PUA_BULLET).join('\u2022');
    out = out.replace(/^(\s*)([\uF020-\uF0FF])/, function(m, sp, ch){ return sp + (TXT_LEAD_BULLETS[ch] || ch); });
    return out.replace(/([\u00A8\u00B4\u02C6\u02DC])([A-Za-z])/g, function(m, acc, letter){
      var joined = (letter + TXT_SPACING_ACCENTS[acc]).normalize('NFC');
      return joined.length === 1 ? joined : m;
    });
  }
  function txtPageText(content, paragraphs){
    var lines = txtLinesOf(content).filter(function(l){ return l.text.trim(); }), side = txtSideText(content);
    lines.forEach(function(l){ l.text = txtCleanLine(l.text); }); // (v157)
    if(!paragraphs) return lines.map(function(l){ return l.text.replace(/\s+$/, ''); }).concat(side ? [side] : []).join(TXT.EOL);
    var out = [], para = '';
    lines.forEach(function(l, i){
      var prev = lines[i - 1];
      var newPara = !prev || Math.abs(prev.y - l.y) > TXT.PARA_GAP * Math.max(l.h, prev.h) || l.y > prev.y;
      if(newPara && para){ out.push(para); para = ''; }
      var t = l.text.trim();
      // (v157) a word broken at the end of a line ("evidence-" + "to-practice", "prob-" + "lematic"):
      // joined without the space; the hyphen stays, as it may be a real one
      para += (para && !TXT_HYPHEN_END.test(para) ? ' ' : '') + t;
    });
    if(para) out.push(para);
    if(side) out.push(side);
    return out.join(TXT.EOL + TXT.EOL);
  }
  var TXT_HYPHEN_END = /[A-Za-zÀ-ÖØ-öø-ÿĀ-žА-я]-$/;
  /* (v157) A glyph whose font has no ToUnicode map arrives as a control
     character (U+0001 ... "\x01r\x02sk\x02bing" for "Ærøskøbing"); it went
     into the .txt file as it was, without a word. Same set as PDF to Word
     (PC_UNMAPPED_RE, app-convert.js, minus the line breaks and tab this tool
     writes itself): shown as U+FFFD and counted, so the note can say so. */
  var TXT_UNMAPPED_RE = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F�]/g;
  function txtMarkUnmapped(text){
    var n = 0;
    var out = text.replace(TXT_UNMAPPED_RE, function(){ n++; return '�'; });
    return { text: out, unmapped: n };
  }
  async function txtOnePdf(file, paragraphs, progress){
    var bytes = new Uint8Array(await file.arrayBuffer()), task = null;
    try{
      var pdfDoc;
      try{
        // (v147) without images: only text is read (white text is checked on a full copy, app.js pcRenderTwin)
        task = pcGetDocument(pcTextOnlySource(bytes), function(){ return file.arrayBuffer(); });
        pdfDoc = await task.promise;
      }catch(e){
        pcThrowIfOutOfMemory(e);
        pcLogUnexpected(e); throw (e && e.userFacing) ? e : userError(e && e.name === 'PasswordException' ? 'password' : 'invalidPdf');
      }
      if(await pcIsPureXfaJs(pdfDoc)) throw pcUserError(pcT('xfa'));
      var n = pdfDoc.numPages, parts = [], empty = [], unmapped = 0;
      for(var p = 1; p <= n; p++){
        pcCheckCancel();
        var page = await pdfDoc.getPage(p);
        try{
          var marked = txtMarkUnmapped(txtPageText(await page.getTextContent(), paragraphs)); // (v157)
          var text = marked.text;
          unmapped += marked.unmapped;
          if(!text.trim()) empty.push(p);
          parts.push(text);
        }finally{ page.cleanup(); }
        progress(p / n);
      }
      if(empty.length === n) throw userError('txtNoText');
      var body = parts.join(TXT.EOL + TXT.EOL) + TXT.EOL;
      return { blob: new Blob([body], { type: 'text/plain;charset=utf-8' }), filename: baseFileName(file.name) + '.txt', pages: n, empty: empty, unmapped: unmapped };
    }finally{
      await destroyTask(task);
    }
  }
  pcOnPanel('txt', function(){ setupTool('txt', {
    accept: isPdf, optionsId: 'txt-layout-options', workingKey: 'txtWorking', zipName: 'pdf-text',
    run: async function(files, layout, ctx){
      pcRequirePdfJs();
      var scanNames = [], scanWhere = [], unmappedNames = [];
      var out = await eachFile(files, ctx, async function(file, i){
        var r = await txtOnePdf(file, layout === 'paragraphs', function(frac){ ctx.setProgress((i + frac) / files.length); });
        if(r.unmapped) unmappedNames.push(file.name); // (v157)
        if(r.empty.length){
          scanNames.push(file.name);
          scanWhere.push(r.empty.length === 1 ? t('txtPage', r.empty[0]) : t('txtPagesOf', r.empty.length, r.pages));
        }
        return r;
      });
      out.info = out.results.length > 1 ? t('txtInfoMany', out.results.length) : out.results[0].pages === 1 ? t('txtInfoOnePage') : t('txtInfoOne', out.results[0].pages);
      out.note = [scanNames.length ? t('txtScanNote', scanNames.join(', '), scanWhere.join('; ')) : '',
        unmappedNames.length ? t('txtUnmapped', unmappedNames.join(', ')) : ''].filter(Boolean).join(' ');
      return out;
    }
  }); });

  /* ---------- (v110) CROP PAGES ---------- */
  var CROP = { MM: 72 / 25.4, MIN_PT: 10, PREVIEW_MAX_W: 420, PREVIEW_MAX_SCALE: 2.5, AUTO_PX: 1000, EDGE_STEP: 4, NONE_PT: 1, INK_DIFF: 24, INK_MIN_PX: 2, INK_MIN_FRAC: 0.004, KEEP_DEFAULT_MM: 5, RESIZE_MS: 150 };
  var crop = { pdf: null, page: 1, pages: 0, previewFor: null, rendering: 0, vw: 0, vh: 0, auto: null };
  function cropEl(id){ return $('crop-' + id); }
  function cropMode(){ var o = document.querySelector('#crop-mode-options .quality-opt.selected'); return o ? o.dataset.value : 'manual'; }
  /* (v111) Typed as text (a number field turned "12,5" into nothing in
     Firefox and 125 in Chrome): digits with an optional . or , decimal. */
  var CROP_MARGIN_IDS = ['crop-top', 'crop-right', 'crop-bottom', 'crop-left'];
  var CROP_NUM_RE = /^\s*\d+(?:[.,]\d+)?\s*$/;
  function cropNum(id){
    var inp = cropEl(id);
    if(!inp || inp.value.trim() === '') return 0;
    if(!CROP_NUM_RE.test(inp.value)) throw Object.assign(fieldError('cropBad'), { fieldId: 'crop-' + id });
    return parseFloat(inp.value.replace(',', '.'));
  }
  /* The margins as typed, in points: {top, right, bottom, left} as the reader sees the page. */
  function cropMargins(){
    var m = { top: cropNum('top'), right: cropNum('right'), bottom: cropNum('bottom'), left: cropNum('left') };
    Object.keys(m).forEach(function(k){ m[k] *= CROP.MM; });
    return m;
  }
  /* The visible rectangle minus the margins, back in the page's own coordinates (rotation included). */
  function cropRect(page, m){
    var f = pcVisualFrame(page);
    var u0 = m.left, u1 = f.vw - m.right, v0 = m.bottom, v1 = f.vh - m.top;
    if(u1 - u0 < CROP.MIN_PT || v1 - v0 < CROP.MIN_PT) throw Object.assign(fieldError('cropTooMuch'), { fieldId: CROP_MARGIN_IDS });
    var a = f.toUser(u0, v0), b = f.toUser(u1, v1);
    return { x: Math.min(a[0], b[0]), y: Math.min(a[1], b[1]), width: Math.abs(b[0] - a[0]), height: Math.abs(b[1] - a[1]) };
  }
  function cropApply(page, r){
    page.setMediaBox(r.x, r.y, r.width, r.height);
    page.setCropBox(r.x, r.y, r.width, r.height);
    ['TrimBox', 'BleedBox', 'ArtBox'].forEach(function(k){ page.node.delete(pcN(k)); });
  }
  /* Where the ink is on a rendered page, in points as the reader sees the
     page, or null for a blank page. (v157) The paper colour is read from the
     page edge (a scan is light grey, not white), and a row or column only
     counts as ink when enough of it differs: dust and scan noise don't hold
     the margin open. */
  function cropPaper(d, W, H){
    var r = [], gg = [], b = [];
    var add = function(x, y){ var i = (y * W + x) * 4; r.push(d[i]); gg.push(d[i + 1]); b.push(d[i + 2]); };
    for(var x = 0; x < W; x += CROP.EDGE_STEP){ add(x, 0); add(x, H - 1); }
    for(var y = 0; y < H; y += CROP.EDGE_STEP){ add(0, y); add(W - 1, y); }
    var med = function(a){ a.sort(function(p, q){ return p - q; }); return a[a.length >> 1]; };
    return [med(r), med(gg), med(b)];
  }
  function cropInkBox(canvas, scale){
    var g = pcCanvas2d(canvas), W = canvas.width, H = canvas.height;
    var d = g.getImageData(0, 0, W, H).data, paper = cropPaper(d, W, H);
    var rows = new Uint32Array(H), cols = new Uint32Array(W);
    for(var y = 0; y < H; y++){
      for(var x = 0; x < W; x++){
        var i = (y * W + x) * 4;
        if(Math.abs(d[i] - paper[0]) > CROP.INK_DIFF || Math.abs(d[i + 1] - paper[1]) > CROP.INK_DIFF || Math.abs(d[i + 2] - paper[2]) > CROP.INK_DIFF){ rows[y]++; cols[x]++; }
      }
    }
    var minRow = Math.max(CROP.INK_MIN_PX, W * CROP.INK_MIN_FRAC), minCol = Math.max(CROP.INK_MIN_PX, H * CROP.INK_MIN_FRAC);
    var y0 = 0, y1 = H - 1, x0 = 0, x1 = W - 1;
    while(y0 < H && rows[y0] < minRow) y0++;
    if(y0 === H) return null;
    while(y1 > y0 && rows[y1] < minRow) y1--;
    while(x0 < W && cols[x0] < minCol) x0++;
    if(x0 === W) return null;
    while(x1 > x0 && cols[x1] < minCol) x1--;
    return { left: x0 / scale, right: (W - 1 - x1) / scale, top: y0 / scale, bottom: (H - 1 - y1) / scale };
  }
  async function cropRenderInk(pdfPage){
    var vp1 = pdfPage.getViewport({ scale: 1 });
    var scale = Math.min(CROP.AUTO_PX / Math.max(vp1.width, vp1.height), 4);
    var vp = pdfPage.getViewport({ scale: scale });
    var c = document.createElement('canvas');
    try{
      c.width = Math.max(1, Math.floor(vp.width)); c.height = Math.max(1, Math.floor(vp.height));
      var g = pcCanvas2d(c);
      g.fillStyle = '#ffffff'; g.fillRect(0, 0, c.width, c.height);
      await pdfPage.render({ canvasContext: g, viewport: vp }).promise;
      return cropInkBox(c, scale);
    }finally{ pcReleaseCanvas(c); }
  }
  /* Auto: the ink box of every page plus the margin to keep; a blank page stays as it is. */
  function cropAutoMargins(ink, keepPt){
    return { top: Math.max(0, ink.top - keepPt), right: Math.max(0, ink.right - keepPt), bottom: Math.max(0, ink.bottom - keepPt), left: Math.max(0, ink.left - keepPt) };
  }
  /* (v119, nt-v110-rest) Only some pages: the same optional page list as Rotate
     (empty = every page), made by script so no page markup changes. */
  function cropPagesField(){
    var after = cropEl('auto');
    if(!after) return null;
    var wrap = document.createElement('div');
    wrap.className = 'nup-field crop-pages';
    var lab = document.createElement('label');
    lab.htmlFor = 'crop-pages';
    lab.textContent = pcT('rotatePages');
    var inp = document.createElement('input');
    inp.type = 'text'; inp.id = 'crop-pages'; inp.autocomplete = 'off'; inp.className = 'text-input'; // no numeric keypad: iOS has no "-" or "," there
    inp.placeholder = '1, 3-5';
    wrap.appendChild(lab); wrap.appendChild(inp);
    after.insertAdjacentElement('afterend', wrap);
    return inp;
  }
  function cropPageSpec(inp){
    try{ return pcParsePageSpec(inp ? inp.value : ''); }
    catch(e){ if(e && e.field) e.fieldId = 'crop-pages'; throw e; }
  }
  async function cropOnePdf(file, mode, keepPt, progress, spec){
    var doc = await loadPdfLib(file);
    if(pcXfaKind(doc) === 'hybrid') noteName(xfaDropped, file);
    var pages = doc.getPages(), blank = [], same = 0, m = mode === 'manual' ? cropMargins() : null;
    var small = [], tried = 0, tooMuch = null; // (v157)
    var only = null;
    if(spec && spec.length){
      try{ only = new Set(pcResolvePageSpec(spec, pages.length)); }
      catch(e){ if(e && e.field) e.fieldId = 'crop-pages'; throw e; }
    }
    var task = null, pdfDoc = null;
    try{
      if(mode === 'auto'){
        try{
          task = pcGetDocument(pcPdfSource(new Uint8Array(await file.arrayBuffer())));
          pdfDoc = await task.promise;
        }catch(e){ pcThrowIfOutOfMemory(e); pcLogUnexpected(e); throw (e && e.userFacing) ? e : userError(e && e.name === 'PasswordException' ? 'password' : 'invalidPdf'); }
      }
      for(var i = 0; i < pages.length; i++){
        pcCheckCancel();
        if(only && !only.has(i + 1)){ progress((i + 1) / pages.length); continue; } // (v119) not in the page list: unchanged
        var margins = m;
        if(mode === 'auto'){
          var pdfPage = await pdfDoc.getPage(i + 1), ink;
          try{ ink = await cropRenderInk(pdfPage); }finally{ pdfPage.cleanup(); }
          if(!ink){ blank.push(i + 1); progress((i + 1) / pages.length); continue; }
          margins = cropAutoMargins(ink, keepPt);
          // (v157) nothing worth cutting: the page is left as it is and counts as untouched
          if(Math.max(margins.top, margins.right, margins.bottom, margins.left) < CROP.NONE_PT){ same++; progress((i + 1) / pages.length); continue; }
        }
        // (v157) one page smaller than the margins (a 3 pt stamp page) no longer refuses the whole
        // file: it stays as it is and the note names it; only when no page fits is it a typing error
        tried++;
        try{ cropApply(pages[i], cropRect(pages[i], margins)); }
        catch(e){ if(!(e && e.fieldId === CROP_MARGIN_IDS)) throw e; small.push(i + 1); tooMuch = e; }
        progress((i + 1) / pages.length);
      }
    }finally{ await destroyTask(task); }
    if(tried && small.length === tried) throw tooMuch;
    pcCheckCancel();
    return { blob: pdfBlob(await pcSavePdf(doc)), filename: baseFileName(file.name) + '-cropped.pdf', blank: blank, same: same, small: small, pages: pages.length };
  }
  /* ---- preview of the first file ---- */
  async function closeCropPreview(){
    var pdf = crop.pdf; crop.pdf = null; crop.pages = 0; crop.auto = null;
    if(pdf){ try{ await pdf.destroy(); }catch(e){ pcLogUnexpected(e); } }
  }
  var cropOpenSeq = 0; // (v142) see signOpenSeq
  async function openCropPreview(file){
    var my = ++cropOpenSeq, pw = previewPassword(file); // see openSignPreview
    crop.previewFor = file;
    await closeCropPreview();
    var place = cropEl('place'), msg = cropEl('preview-error'), task = null;
    if(!place) return;
    msg.hidden = true;
    clearPreviewPassword('crop');
    if(!file){ place.hidden = true; return; }
    place.hidden = false;
    try{
      await pcLoadPdfLibs();
      pcRequirePdfJs();
      task = pcGetDocument(Object.assign(pcPdfSource(new Uint8Array(await file.arrayBuffer())), pw ? { password: pw } : {}));
      var pdf = await task.promise;
      if(my !== cropOpenSeq){ await destroyTask(task); return; }
      task._pcDoc = pdf; crop.pdf = pdf; crop.pages = pdf.numPages; crop.page = 1;
      await renderCropPreview();
    }catch(e){
      if(task && crop.pdf !== task._pcDoc) await destroyTask(task);
      if(my !== cropOpenSeq) return;
      if(crop.pdf && task && crop.pdf === task._pcDoc) await closeCropPreview(); // (v111) a page that fails: no half-open copy
      if(isPasswordError(e)){
        crop.pages = 0; cropEl('stage').hidden = true;
        askPreviewPassword('crop', msg, file, !!pw, function(f){ openCropPreview(f).catch(pcLogUnexpected); }, cropEl('place-title'));
        return;
      }
      cropPreviewError(e);
    }
  }
  function cropPreviewError(e){
    pcLogUnexpected(e);
    crop.pages = 0;
    showPreviewMsg(cropEl('preview-error'), reasonOf(e, 'invalidPdf'));
    cropEl('stage').hidden = true;
  }
  /* (v111) Another page, or a new width: errors shown like the first page's. */
  function cropRerender(){
    var file = crop.previewFor;
    renderCropPreview().catch(function(e){ if(crop.previewFor === file) cropPreviewError(e); });
  }
  async function renderCropPreview(){
    var pdf = crop.pdf;
    try{ await drawCropPreview(pdf); }
    catch(e){ if(crop.pdf === pdf) throw e; } // (v142) its document was closed meanwhile (a newer preview): nothing to show
  }
  async function drawCropPreview(pdf){
    var canvas = cropEl('preview'), stage = cropEl('stage');
    if(!pdf || !canvas) return;
    var ticket = ++crop.rendering;
    var page = await pdf.getPage(crop.page);
    try{
      if(ticket !== crop.rendering) return;
      var vp1 = page.getViewport({ scale: 1 });
      stage.hidden = false;
      var cssW = Math.min(CROP.PREVIEW_MAX_W, stage.parentElement.clientWidth || CROP.PREVIEW_MAX_W);
      crop.cssW = cssW;
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      var vp = page.getViewport({ scale: canvasScale(vp1, Math.min(cssW * dpr / vp1.width, CROP.PREVIEW_MAX_SCALE)) });
      var off = document.createElement('canvas');
      try{
        off.width = Math.max(1, Math.floor(vp.width)); off.height = Math.max(1, Math.floor(vp.height));
        var g = pcCanvas2d(off);
        g.fillStyle = '#ffffff'; g.fillRect(0, 0, off.width, off.height);
        await page.render({ canvasContext: g, viewport: vp }).promise;
        if(ticket !== crop.rendering) return;
        canvas.width = off.width; canvas.height = off.height;
        canvas.getContext('2d').drawImage(off, 0, 0);
        crop.auto = cropInkBox(off, vp.scale); // the preview doubles as the auto-trim probe of this page
      }finally{ pcReleaseCanvas(off); }
      stage.style.width = cssW + 'px';
      crop.vw = vp1.width; crop.vh = vp1.height;
      cropEl('pageinfo').textContent = t('cropPage', crop.page, crop.pages);
      pagerButtons(cropEl('prev'), cropEl('next'), crop.page, crop.pages);
      cropOverlay();
    }finally{ page.cleanup(); }
  }
  /* (v115) In auto mode the trimmed margins of this page as text too: the
     grey shade alone told a screen reader (and anyone unsure) nothing. */
  function cropAutoInfo(m, mode){
    var stage = cropEl('stage'), el = cropEl('auto-info');
    if(!stage) return;
    if(!el){
      el = document.createElement('p'); el.id = 'crop-auto-info'; el.className = 'field-hint'; el.setAttribute('aria-live', 'polite');
      stage.insertAdjacentElement('afterend', el);
    }
    var auto = mode === 'auto';
    el.hidden = !auto;
    if(!auto) return;
    var mm = function(v){ return Math.round(v / CROP.MM); };
    el.textContent = crop.auto ? t('cropAutoInfo', mm(m.top), mm(m.right), mm(m.bottom), mm(m.left)) : t('cropAutoPageNone');
  }
  /* The grey shade over what will be cut off. */
  // (v115) mode: the option just clicked (its .selected is set after this tool's own click handler ran)
  function cropOverlay(mode){
    mode = typeof mode === 'string' ? mode : cropMode();
    var ov = cropEl('overlay');
    if(!ov || !crop.vw) return;
    var m;
    try{
      m = mode === 'auto' ? (crop.auto ? cropAutoMargins(crop.auto, cropNum('keep') * CROP.MM) : { top: 0, right: 0, bottom: 0, left: 0 }) : cropMargins();
    }catch(e){ ov.hidden = true; var ai = cropEl('auto-info'); if(ai) ai.hidden = true; return; } // an invalid field: its own error is shown on Crop
    var pct = function(v, total){ return Math.max(0, Math.min(100, v / total * 100)).toFixed(2) + '%'; };
    ov.hidden = false;
    cropAutoInfo(m, mode);
    ov.style.top = pct(m.top, crop.vh); ov.style.bottom = pct(m.bottom, crop.vh);
    ov.style.left = pct(m.left, crop.vw); ov.style.right = pct(m.right, crop.vw);
  }
  pcOnPanel('crop', function(){
    var cropToggle = function(mode){
      var man = cropEl('manual'), aut = cropEl('auto');
      if(man) man.hidden = mode !== 'manual';
      if(aut) aut.hidden = mode !== 'auto';
      cropOverlay(mode);
    };
    document.querySelectorAll('#crop-mode-options .quality-opt').forEach(function(o){
      o.addEventListener('click', function(){ cropToggle(o.dataset.value); });
    });
    ['top', 'right', 'bottom', 'left', 'keep'].forEach(function(id){ var inp = cropEl(id); if(inp) inp.addEventListener('input', cropOverlay); });
    cropEl('prev').addEventListener('click', function(){ if(crop.page > 1){ crop.page--; cropRerender(); } });
    cropEl('next').addEventListener('click', function(){ if(crop.page < crop.pages){ crop.page++; cropRerender(); } });
    // (v111) only when the width really changed, once it settles (iOS fires
    // resize while scrolling, Android when the keyboard opens)
    var cropResizeTimer = null;
    window.addEventListener('resize', function(){
      clearTimeout(cropResizeTimer);
      cropResizeTimer = setTimeout(function(){
        var stage = cropEl('stage');
        if(!crop.pdf || isProcessing || !stage || stage.hidden) return;
        if(Math.min(CROP.PREVIEW_MAX_W, stage.parentElement.clientWidth || CROP.PREVIEW_MAX_W) !== crop.cssW) cropRerender();
      }, CROP.RESIZE_MS);
    });
    var cropPagesInput = cropPagesField(); // (v119)
    setupTool('crop', {
      accept: isPdf, optionsId: 'crop-mode-options', workingKey: 'cropWorking', zipName: 'cropped-pages',
      fieldId: ['crop-top', 'crop-right', 'crop-bottom', 'crop-left', 'crop-keep', 'crop-pages'],
      onFiles: (function(gate){ return function(files){ gate(files[0] || null); }; })(previewGate('crop', openCropPreview, function(){ return crop.previewFor; })),
      run: async function(files, mode, ctx){
        var keepPt = 0;
        if(mode === 'auto'){ pcRequirePdfJs(); keepPt = cropNum('keep') * CROP.MM; }
        else cropMargins(); // a typo is a field error before any work
        var spec = cropPageSpec(cropPagesInput);
        resetNotes();
        var blankNames = [], untouched = [], smallNames = [];
        // (v111) like Sign: the preview's copy is closed while working (memory on a phone)
        var previewFile = crop.previewFor, out;
        cropOpenSeq++; // (v142) see Sign
        await closeCropPreview();
        crop.previewFor = null;
        try{
          out = await eachFile(files, ctx, async function(file, i){
            var r = await cropOnePdf(file, mode, keepPt, function(frac){ ctx.setProgress((i + frac) / files.length); }, spec);
            if(r.blank.length + r.same >= r.pages){ untouched.push(file.name); }
            else if(r.blank.length) blankNames.push(file.name + ' (' + r.blank.slice(0, 8).join(', ') + (r.blank.length > 8 ? '…' : '') + ')');
            if(r.small.length) smallNames.push(file.name + ' (' + r.small.slice(0, 8).join(', ') + (r.small.length > 8 ? '…' : '') + ')'); // (v157)
            return r;
          });
        }finally{ if(previewFile && crop.previewFor === null) openCropPreview(previewFile).catch(pcLogUnexpected); }
        out.info = out.results.length === 1 ? t('cropInfoOne') : t('cropInfoMany', out.results.length);
        out.note = [takeNotes(), blankNames.length ? t('cropBlankNote', blankNames.join(', ')) : '', untouched.length ? t('cropAutoNone', untouched.join(', ')) : '',
          smallNames.length ? t('cropSmallNote', smallNames.join(', ')) : ''].filter(Boolean).join(' ');
        return out;
      }
    });
  });

  /* ---------- (v110) EXTRACT IMAGES ---------- */
  var IMGS = { MIN_SIDE: 8, JPG_QUALITY: 0.92, WAIT_MS: 30000,
    // (v111) the largest picture a canvas may hold here (iPhone: 16.7 MP); bigger ones are saved smaller
    MAX_PX: pcIsPhone() ? MAX_PIXELS : 64e6, MAX_SIDE: pcIsPhone() ? MAX_SIDE : 16384 };
  /* pdf.js decodes images while the operator list is already in: wait for
     this one (get with a callback fires once it is there). A decode that
     never finishes must not hang the tool: after IMGS.WAIT_MS it counts as
     unreadable. */
  function imgsObj(page, id){
    var store = id.indexOf('g_') === 0 ? page.commonObjs : page.objs; // g_: shared between pages
    return new Promise(function(res){
      var timer = null;
      var done = function(img){ clearTimeout(timer); pcCancelHooks.delete(stop); res(img); };
      var stop = function(){ done(undefined); }; // (v111) Cancel doesn't wait for the decode
      timer = setTimeout(stop, IMGS.WAIT_MS);
      pcCancelHooks.add(stop);
      store.get(id, done);
    });
  }
  /* pdf.js hands an image as raw pixels (grey 1-bit, RGB or RGBA) or as a
     decoded bitmap. Raw pixels become RGBA here, without a canvas. */
  function imgsRgba(img){
    var K = pdfjsLib.ImageKind, w = img.width, h = img.height, n = w * h, s = img.data, d = new Uint8ClampedArray(n * 4);
    if(img.kind === K.RGBA_32BPP){ d.set(s.subarray(0, n * 4)); return d; }
    if(img.kind === K.RGB_24BPP){ for(var i = 0, j = 0; i < n; i++, j += 3){ d[i * 4] = s[j]; d[i * 4 + 1] = s[j + 1]; d[i * 4 + 2] = s[j + 2]; d[i * 4 + 3] = 255; } return d; }
    if(img.kind === K.GRAYSCALE_1BPP){
      var rowBytes = (w + 7) >> 3;
      for(var y = 0; y < h; y++) for(var x = 0; x < w; x++){
        var v = ((s[y * rowBytes + (x >> 3)] >> (7 - (x & 7))) & 1) ? 255 : 0, k = (y * w + x) * 4;
        d[k] = d[k + 1] = d[k + 2] = v; d[k + 3] = 255;
      }
      return d;
    }
    throw new Error('unknown image kind ' + img.kind);
  }
  /* The factor a picture is made smaller by to fit a canvas here (1 = as it is). */
  function imgsShrink(w, h){
    return Math.max(1, Math.ceil(Math.sqrt(w * h / IMGS.MAX_PX)), Math.ceil(Math.max(w, h) / IMGS.MAX_SIDE));
  }
  /* Averages k×k blocks: a smaller picture that still looks like the original. */
  function imgsBoxDown(d, w, h, k){
    var w2 = Math.max(1, Math.floor(w / k)), h2 = Math.max(1, Math.floor(h / k)), o = new Uint8ClampedArray(w2 * h2 * 4), kk = k * k;
    for(var y = 0; y < h2; y++) for(var x = 0; x < w2; x++){
      var r = 0, g = 0, b = 0, a = 0;
      for(var dy = 0; dy < k; dy++){
        var row = ((y * k + dy) * w + x * k) * 4;
        for(var dx = 0; dx < k; dx++){ var q = row + dx * 4; r += d[q]; g += d[q + 1]; b += d[q + 2]; a += d[q + 3]; }
      }
      var t2 = (y * w2 + x) * 4; o[t2] = r / kk; o[t2 + 1] = g / kk; o[t2 + 2] = b / kk; o[t2 + 3] = a / kk;
    }
    return { data: o, w: w2, h: h2 };
  }
  /* (v119, nt-v110-rest) An image mask (a stencil: black-and-white scans are
     often stored this way) as black on white, the way the page shows it.
     pdf.js gives it as a bitmap (painted = opaque black, the rest see-through)
     or as packed bits (0 = painted, rows padded to whole bytes). */
  function imgsMaskRgba(m){
    var w = m.width, h = m.height, d = new Uint8ClampedArray(w * h * 4), s = m.data;
    if(m.kind === pdfjsLib.ImageKind.RGBA_32BPP){ // a large mask pdf.js made smaller itself
      for(var i = 0; i < w * h; i++){ var v = 255 - s[i * 4 + 3]; d[i * 4] = d[i * 4 + 1] = d[i * 4 + 2] = v; d[i * 4 + 3] = 255; }
      return d;
    }
    var rowBytes = (w + 7) >> 3;
    for(var y = 0; y < h; y++) for(var x = 0; x < w; x++){
      var v2 = ((s[y * rowBytes + (x >> 3)] >> (7 - (x & 7))) & 1) ? 255 : 0, k = (y * w + x) * 4;
      d[k] = d[k + 1] = d[k + 2] = v2; d[k + 3] = 255;
    }
    return d;
  }
  function imgsMaskCanvas(m){
    var k = imgsShrink(m.width, m.height), c = document.createElement('canvas');
    if(m.bitmap){
      c.width = Math.max(1, Math.floor(m.width / k)); c.height = Math.max(1, Math.floor(m.height / k));
      var g = c.getContext('2d', { willReadFrequently: true });
      if(!g) throw new Error('Canvas allocation failed');
      g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height);
      g.drawImage(m.bitmap, 0, 0, c.width, c.height);
      return { canvas: c, reduced: k > 1, mask: true };
    }
    var px = { data: imgsMaskRgba(m), w: m.width, h: m.height };
    if(k > 1) px = imgsBoxDown(px.data, px.w, px.h, k);
    c.width = px.w; c.height = px.h;
    var g2 = c.getContext('2d', { willReadFrequently: true });
    if(!g2) throw new Error('Canvas allocation failed');
    g2.putImageData(new ImageData(px.data, px.w, px.h), 0, 0);
    return { canvas: c, reduced: k > 1, mask: true };
  }
  /* The picture on a canvas within the limits, and whether it had to be made smaller. */
  function imgsToCanvas(img){
    if(img.mask) return imgsMaskCanvas(img.mask);
    var k = imgsShrink(img.width, img.height), c = document.createElement('canvas');
    if(img.bitmap){
      c.width = Math.max(1, Math.floor(img.width / k)); c.height = Math.max(1, Math.floor(img.height / k));
      c.getContext('2d', { willReadFrequently: true }).drawImage(img.bitmap, 0, 0, c.width, c.height);
      return { canvas: c, reduced: k > 1 };
    }
    var px = { data: imgsRgba(img), w: img.width, h: img.height };
    if(k > 1) px = imgsBoxDown(px.data, px.w, px.h, k);
    c.width = px.w; c.height = px.h;
    var g = c.getContext('2d', { willReadFrequently: true });
    if(!g) throw new Error('Canvas allocation failed');
    g.putImageData(new ImageData(px.data, px.w, px.h), 0, 0);
    return { canvas: c, reduced: k > 1 };
  }
  /* One look at the pixels: is anything see-through, and a fingerprint
     (size + a sample of the pixels) so the same picture on several pages
     is saved once. pdf.js names images per page, so the name can't tell. */
  function imgsInspect(c){
    var d = c.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, c.width, c.height).data, alpha = false;
    for(var i = 3; i < d.length; i += 4) if(d[i] < 255){ alpha = true; break; }
    // (v157) every pixel, two independent hashes: a sample of ±4096 pixels
    // took different pictures (mostly blank, or differing in one corner) for one
    var h = 2166136261, h2 = 5381;
    for(var j = 0; j < d.length; j += 4){
      var v = d[j] | (d[j + 1] << 8) | (d[j + 2] << 16) | (d[j + 3] << 24);
      h = Math.imul(h ^ v, 16777619);
      h2 = (Math.imul(h2, 33) + v) | 0;
    }
    return { alpha: alpha, key: c.width + 'x' + c.height + ':' + (h >>> 0).toString(16) + (h2 >>> 0).toString(16) };
  }
  async function imgsBlob(img, format, seen){
    var made = imgsToCanvas(img), c = made.canvas;
    try{
      var look = imgsInspect(c);
      if(seen[look.key]) return null;
      seen[look.key] = true;
      var jpg = format === 'jpg' && !look.alpha && !made.mask; // (v119) a stencil is black and white: PNG keeps it sharp
      var blob = await new Promise(function(res){ c.toBlob(res, jpg ? 'image/jpeg' : 'image/png', IMGS.JPG_QUALITY); });
      if(!blob) throw pcUserError(pcT('outOfMemory'));
      return { blob: blob, ext: jpg ? '.jpg' : '.png', reduced: made.reduced };
    }finally{ pcReleaseCanvas(c); }
  }
  /* (v119) pdf-lib's view of the file, to find the stored JPEG behind each
     picture pdf.js paints. null when it can't open it (the pictures are then
     saved from pdf.js' pixels, as before). */
  async function imgsRawDoc(bytes){
    // the typed password explicitly: this copy is only read, it must not trigger the "no longer has a password" note
    try{ return (await openPdfForEdit(bytes, null, { keepXfa: true })).doc; }
    catch(e){
      if(pcIsCancel(e)) throw e;
      pcRethrowMemory(e);
      if(e && e.name === 'PasswordException' && pcHostPassword()){
        try{ return (await openPdfForEdit(bytes, pcHostPassword(), { keepXfa: true })).doc; }catch(e2){ if(pcIsCancel(e2)) throw e2; pcRethrowMemory(e2); return null; }
      }
      pcLogUnexpected(e); return null;
    }
  }
  /* pdf.js object id -> { ref, obj } for one page, only when pdf.js' painted
     pictures and the page's own Do list match one for one, size for size
     (pcPageImageOrder); otherwise null and nothing is guessed. */
  async function imgsRawMatch(doc, index, ops){
    var list = await pcPageImageOrder(doc.context, doc.getPage(index));
    if(!list) return null;
    var OPS = pdfjsLib.OPS, painted = [];
    for(var i = 0; i < ops.fnArray.length; i++){
      var fn = ops.fnArray[i];
      if(fn !== OPS.paintImageXObject && fn !== OPS.paintImageXObjectRepeat) continue;
      var a = ops.argsArray[i];
      if(!painted.length || painted[painted.length - 1].id !== a[0]) painted.push({ id: a[0], w: a[1], h: a[2] });
    }
    var drawn = list.filter(function(x, j){ return j === 0 || list[j - 1].ref !== x.ref; });
    if(painted.length !== drawn.length) return null;
    var map = new Map();
    for(var j = 0; j < drawn.length; j++){
      var W = drawn[j].obj.dict.lookup(PDFLib.PDFName.of('Width')), H = drawn[j].obj.dict.lookup(PDFLib.PDFName.of('Height'));
      if(!W || !H || W.asNumber() !== painted[j].w || H.asNumber() !== painted[j].h) return null;
      if(map.has(painted[j].id) && map.get(painted[j].id).ref !== drawn[j].ref) return null;
      map.set(painted[j].id, drawn[j]);
    }
    return map;
  }
  function imgsPad(p, n){ return String(p).padStart(String(n).length, '0'); } // (v157) p02 before p10
  async function imgsOnePdf(file, format, fi, total, ctx){
    var bytes = new Uint8Array(await file.arrayBuffer()), task = null, results = [], seen = {}, seenRef = {}, small = 0, masks = false, unreadable = 0, reduced = 0;
    // (v119) JPG: the photos stored as JPEG are saved with their own bytes (no second compression)
    // not on a phone: a second parse of the whole file costs memory there
    var raw = format === 'jpg' && !pcIsPhone() ? await imgsRawDoc(bytes) : null;
    try{
      var pdfDoc;
      try{ task = pcGetDocument(pcPdfSource(raw ? bytes.slice() : bytes)); pdfDoc = await task.promise; } // (pdf.js takes over its buffer: pdf-lib keeps reading the original)
      catch(e){ pcThrowIfOutOfMemory(e); pcLogUnexpected(e); throw (e && e.userFacing) ? e : userError(e && e.name === 'PasswordException' ? 'password' : 'invalidPdf'); }
      if(await pcIsPureXfaJs(pdfDoc)) throw pcUserError(pcT('xfa'));
      var n = pdfDoc.numPages, base = baseFileName(file.name), OPS = pdfjsLib.OPS;
      for(var p = 1; p <= n; p++){
        pcCheckCancel();
        ctx.setStatus(t('imgsPageN', fi + 1, total, p, n));
        var page = await pdfDoc.getPage(p), k = 0;
        try{
          var ops = await page.getOperatorList();
          var rawOf = null;
          // (v119 review) a page pdf-lib can't follow (strict inflate, fewer pages) falls back to pdf.js' pixels
          if(raw){ try{ rawOf = await imgsRawMatch(raw, p - 1, ops); }catch(e){ if(pcIsCancel(e)) throw e; pcRethrowMemory(e); pcLogUnexpected(e); } }
          for(var i = 0; i < ops.fnArray.length; i++){
            var fn = ops.fnArray[i], img = null, id = null;
            if(fn === OPS.paintImageXObject || fn === OPS.paintImageXObjectRepeat){
              id = ops.argsArray[i][0];
              if(seen[id]) continue;
              var orig = rawOf && rawOf.get(id);
              var jpeg = orig ? pcPlainJpegBytes(orig.obj) : null;
              if(jpeg){
                seen[id] = true;
                if(seenRef[orig.ref.tag]) continue; // the same picture again (another page)
                seenRef[orig.ref.tag] = true;
                if(ops.argsArray[i][1] < IMGS.MIN_SIDE || ops.argsArray[i][2] < IMGS.MIN_SIDE){ small++; continue; }
                k++;
                results.push({ blob: new Blob([jpeg], { type: 'image/jpeg' }), filename: base + '-p' + imgsPad(p, n) + '-' + k + '.jpg' });
                continue;
              }
              img = await imgsObj(page, id);
              pcCheckCancel();
              // (v111) null: pdf.js could not decode it; undefined: it never finished
              if(img == null){ unreadable++; seen[id] = true; continue; }
            }
            else if(fn === OPS.paintInlineImageXObject){ img = ops.argsArray[i][0]; }
            else if(fn === OPS.paintImageMaskXObject || fn === OPS.paintImageMaskXObjectRepeat){
              // (v119) a stencil is saved too (black on white), once
              var mk = ops.argsArray[i][0];
              if(mk && typeof mk.data === 'string'){ id = mk.data; if(seen[id]) continue; mk = await imgsObj(page, id); pcCheckCancel(); }
              if(mk == null){ if(id){ unreadable++; seen[id] = true; } continue; }
              if(mk.isSingleOpaquePixel || !mk.width) continue;
              img = { mask: mk, width: mk.width, height: mk.height };
            }
            else if(fn === OPS.paintImageMaskXObjectGroup){ masks = true; continue; } // many small stencils (drawn letters): not pictures
            else continue;
            if(!img || !img.width) continue;
            if(id) seen[id] = true;
            if(img.width < IMGS.MIN_SIDE || img.height < IMGS.MIN_SIDE){ small++; continue; }
            pcCheckCancel();
            var r = await imgsBlob(img, format, seen);
            if(!r) continue; // the same picture again (another page)
            if(r.reduced) reduced++;
            k++;
            results.push({ blob: r.blob, filename: base + '-p' + imgsPad(p, n) + '-' + k + r.ext });
          }
        }finally{ page.cleanup(); }
        ctx.setProgress((fi + p / n) / total);
      }
    }finally{ await destroyTask(task); }
    if(!results.length) throw userError(unreadable ? 'imgsUnreadable' : masks ? 'imgsMaskNote' : 'imgsNone', unreadable);
    return { list: results, small: small, masks: masks, unreadable: unreadable, reduced: reduced };
  }
  pcOnPanel('imgs', function(){ setupTool('imgs', {
    accept: isPdf, optionsId: 'imgs-format-options', workingKey: 'imgsWorking', zipName: 'pdf-images',
    run: async function(files, format, ctx){
      pcRequirePdfJs();
      var small = 0, masks = false, unreadable = 0, reduced = 0;
      var out = await eachFile(files, ctx, async function(file, i){
        var r = await imgsOnePdf(file, format || 'jpg', i, files.length, ctx);
        small += r.small; masks = masks || r.masks; unreadable += r.unreadable; reduced += r.reduced;
        return r.list;
      });
      out.info = out.results.length === 1 ? t('imgsInfoOne') : t('imgsInfoMany', out.results.length);
      out.note = [small ? t('imgsSkippedNote', small) : '', masks ? t('imgsMaskNote') : '', unreadable ? t('imgsUnreadable', unreadable) : '', reduced ? t('imgsReducedNote', reduced) : ''].filter(Boolean).join(' ');
      return out;
    }
  }); });

  var MSG112 = {
    en: { orgWorking: "Putting the pages in order…", orgInfo: "1 PDF, {0} pages", orgInfoOne: "1 PDF, 1 page", orgTools: "Page tools", orgEarlier: "Move earlier", orgLater: "Move later", orgRotL: "Rotate left", orgRotR: "Rotate right", orgDelete: "Delete", orgBlankAdd: "Blank page", orgReset: "Start over", orgHint: "Tap pages to pick them, then use the buttons. Nothing picked: the buttons act on the page with the focus. On a computer you can also drag pages.", orgGroup: "Pages of your PDF", orgOne: "Organize works on one PDF at a time. Merge your files first, then organize the result.", orgLoading: "Loading the pages…", orgTooMany: "This PDF has {0} pages, too many to organize here. Use Split, Extract pages or Delete pages instead.", orgPage: "page {0}", orgBlank: "blank page", orgPos: "Position {0} of {1}", orgTurned: "turned {0}°", orgSummary: "{0} pages", orgPickedN: "{0} picked", orgPickFirst: "Pick a page first.", orgMoved: "Moved to position {0}.", orgTurnedN: "{0} pages turned.", orgEmpty: "Keep at least one page.", orgDeletedN: "{0} pages deleted.", orgBlankAdded: "Blank page added at position {0}.", orgResetDone: "Back to the original order.", orgChanged: "The pages of this PDF can't be read reliably, so the new order can't be applied safely. Merge it on its own first (Merge PDF), then organize the result.", orgNoThumbs: "This file is too large to show page previews on this device: the pages are shown by number.", orgWait: "The pages are still loading. Try again in a moment.", orgPwFirst: "First type the PDF's password above, so its pages can be shown." },
    nl: { orgWorking: "Pagina's ordenen…", orgInfo: "1 PDF, {0} pagina's", orgInfoOne: "1 PDF, 1 pagina", orgTools: "Paginaknoppen", orgEarlier: "Naar voren", orgLater: "Naar achteren", orgRotL: "Links draaien", orgRotR: "Rechts draaien", orgDelete: "Verwijderen", orgBlankAdd: "Lege pagina", orgReset: "Opnieuw beginnen", orgHint: "Tik op pagina's om ze te kiezen en gebruik dan de knoppen. Niets gekozen: de knoppen werken op de pagina met de focus. Op een computer kan je pagina's ook verslepen.", orgGroup: "Pagina's van je PDF", orgOne: "Ordenen werkt met één PDF tegelijk. Voeg je bestanden eerst samen en orden dan het resultaat.", orgLoading: "Pagina's laden…", orgTooMany: "Deze PDF heeft {0} pagina's, te veel om hier te ordenen. Gebruik Splitsen, Pagina's uithalen of Pagina's verwijderen.", orgPage: "pagina {0}", orgBlank: "lege pagina", orgPos: "Plaats {0} van {1}", orgTurned: "{0}° gedraaid", orgSummary: "{0} pagina's", orgPickedN: "{0} gekozen", orgPickFirst: "Kies eerst een pagina.", orgMoved: "Verplaatst naar plaats {0}.", orgTurnedN: "{0} pagina's gedraaid.", orgEmpty: "Hou minstens één pagina over.", orgDeletedN: "{0} pagina's verwijderd.", orgBlankAdded: "Lege pagina toegevoegd op plaats {0}.", orgResetDone: "Terug in de oorspronkelijke volgorde.", orgChanged: "De pagina's van deze PDF kunnen niet betrouwbaar gelezen worden, dus de nieuwe volgorde kan niet veilig toegepast worden. Voeg hem eerst alleen samen (PDF samenvoegen) en orden dan het resultaat.", orgNoThumbs: "Dit bestand is te groot om op dit toestel paginavoorbeelden te tonen: de pagina's staan er met hun nummer.", orgWait: "De pagina's worden nog geladen. Probeer het zo meteen opnieuw.", orgPwFirst: "Typ eerst hierboven het wachtwoord van de PDF, zodat de pagina's getoond kunnen worden." },
    fr: { orgWorking: "Mise en ordre des pages…", orgInfo: "1 PDF, {0} pages", orgInfoOne: "1 PDF, 1 page", orgTools: "Outils de page", orgEarlier: "Vers l’avant", orgLater: "Vers l’arrière", orgRotL: "Pivoter à gauche", orgRotR: "Pivoter à droite", orgDelete: "Supprimer", orgBlankAdd: "Page blanche", orgReset: "Recommencer", orgHint: "Touchez des pages pour les choisir, puis utilisez les boutons. Si aucune page n’est choisie, les boutons agissent sur la page qui a le focus. Sur ordinateur, vous pouvez aussi glisser les pages.", orgGroup: "Pages de votre PDF", orgOne: "Organiser fonctionne avec un seul PDF à la fois. Fusionnez d’abord vos fichiers, puis organisez le résultat.", orgLoading: "Chargement des pages…", orgTooMany: "Ce PDF a {0} pages, trop pour l’organiser ici. Utilisez plutôt Diviser, Extraire des pages ou Supprimer des pages.", orgPage: "page {0}", orgBlank: "page blanche", orgPos: "Position {0} sur {1}", orgTurned: "pivotée de {0}°", orgSummary: "{0} pages", orgPickedN: "{0} choisies", orgPickFirst: "Choisissez d’abord une page.", orgMoved: "Déplacée en position {0}.", orgTurnedN: "{0} pages pivotées.", orgEmpty: "Gardez au moins une page.", orgDeletedN: "{0} pages supprimées.", orgBlankAdded: "Page blanche ajoutée en position {0}.", orgResetDone: "Retour à l’ordre d’origine.", orgChanged: "Les pages de ce PDF ne peuvent pas être lues de façon fiable : le nouvel ordre ne peut pas être appliqué sans risque. Fusionnez-le d’abord seul (Fusionner des PDF), puis organisez le résultat.", orgNoThumbs: "Ce fichier est trop volumineux pour afficher les aperçus des pages sur cet appareil : les pages sont affichées par numéro.", orgWait: "Les pages sont encore en cours de chargement. Réessayez dans un instant.", orgPwFirst: "Saisissez d’abord ci-dessus le mot de passe du PDF, pour que ses pages puissent s’afficher." },
    de: { orgWorking: "Seiten werden geordnet…", orgInfo: "1 PDF, {0} Seiten", orgInfoOne: "1 PDF, 1 Seite", orgTools: "Seitenwerkzeuge", orgEarlier: "Nach vorne", orgLater: "Nach hinten", orgRotL: "Links drehen", orgRotR: "Rechts drehen", orgDelete: "Löschen", orgBlankAdd: "Leere Seite", orgReset: "Von vorn", orgHint: "Tippen Sie auf Seiten, um sie auszuwählen, und nutzen Sie dann die Schaltflächen. Nichts ausgewählt: Die Schaltflächen wirken auf die Seite mit dem Fokus. Am Computer können Sie Seiten auch ziehen.", orgGroup: "Seiten Ihres PDFs", orgOne: "Organisieren funktioniert mit einem PDF auf einmal. Fügen Sie Ihre Dateien zuerst zusammen und organisieren Sie dann das Ergebnis.", orgLoading: "Seiten werden geladen…", orgTooMany: "Dieses PDF hat {0} Seiten, zu viele, um es hier zu organisieren. Nutzen Sie stattdessen Teilen, Seiten extrahieren oder Seiten löschen.", orgPage: "Seite {0}", orgBlank: "leere Seite", orgPos: "Position {0} von {1}", orgTurned: "um {0}° gedreht", orgSummary: "{0} Seiten", orgPickedN: "{0} ausgewählt", orgPickFirst: "Wählen Sie zuerst eine Seite.", orgMoved: "An Position {0} verschoben.", orgTurnedN: "{0} Seiten gedreht.", orgEmpty: "Behalten Sie mindestens eine Seite.", orgDeletedN: "{0} Seiten gelöscht.", orgBlankAdded: "Leere Seite an Position {0} eingefügt.", orgResetDone: "Zurück zur ursprünglichen Reihenfolge.", orgChanged: "Die Seiten dieses PDFs lassen sich nicht zuverlässig lesen, daher kann die neue Reihenfolge nicht sicher angewendet werden. Lassen Sie es zuerst allein durch „PDF zusammenfügen“ laufen und organisieren Sie dann das Ergebnis.", orgNoThumbs: "Diese Datei ist zu groß, um auf diesem Gerät Seitenvorschauen zu zeigen: Die Seiten werden mit ihrer Nummer angezeigt.", orgWait: "Die Seiten werden noch geladen. Versuchen Sie es gleich noch einmal.", orgPwFirst: "Geben Sie zuerst oben das Passwort des PDFs ein, damit die Seiten angezeigt werden können." },
    es: { orgWorking: "Ordenando las páginas…", orgInfo: "1 PDF, {0} páginas", orgInfoOne: "1 PDF, 1 página", orgTools: "Herramientas de página", orgEarlier: "Mover antes", orgLater: "Mover después", orgRotL: "Girar a la izquierda", orgRotR: "Girar a la derecha", orgDelete: "Eliminar", orgBlankAdd: "Página en blanco", orgReset: "Empezar de nuevo", orgHint: "Toca páginas para elegirlas y usa los botones. Si no eliges ninguna, los botones actúan sobre la página con el foco. En el ordenador también puedes arrastrar las páginas.", orgGroup: "Páginas de tu PDF", orgOne: "Organizar funciona con un PDF a la vez. Une primero tus archivos y luego organiza el resultado.", orgLoading: "Cargando las páginas…", orgTooMany: "Este PDF tiene {0} páginas, demasiadas para organizarlo aquí. Usa Dividir, Extraer páginas o Eliminar páginas.", orgPage: "página {0}", orgBlank: "página en blanco", orgPos: "Posición {0} de {1}", orgTurned: "girada {0}°", orgSummary: "{0} páginas", orgPickedN: "{0} elegidas", orgPickFirst: "Elige primero una página.", orgMoved: "Movida a la posición {0}.", orgTurnedN: "{0} páginas giradas.", orgEmpty: "Deja al menos una página.", orgDeletedN: "{0} páginas eliminadas.", orgBlankAdded: "Página en blanco añadida en la posición {0}.", orgResetDone: "De vuelta al orden original.", orgChanged: "Las páginas de este PDF no se pueden leer de forma fiable, así que el nuevo orden no se puede aplicar con seguridad. Únelo primero por separado (Unir PDF) y luego organiza el resultado.", orgNoThumbs: "Este archivo es demasiado grande para mostrar vistas previas en este dispositivo: las páginas se muestran con su número.", orgWait: "Las páginas todavía se están cargando. Inténtalo de nuevo en un momento.", orgPwFirst: "Primero escribe arriba la contraseña del PDF para que se puedan mostrar sus páginas." },
    pt: { orgWorking: "Organizando as páginas…", orgInfo: "1 PDF, {0} páginas", orgInfoOne: "1 PDF, 1 página", orgTools: "Ferramentas de página", orgEarlier: "Mover para trás", orgLater: "Mover para frente", orgRotL: "Girar à esquerda", orgRotR: "Girar à direita", orgDelete: "Excluir", orgBlankAdd: "Página em branco", orgReset: "Recomeçar", orgHint: "Toque nas páginas para escolhê-las e use os botões. Sem nenhuma escolhida, os botões agem na página com o foco. No computador, você também pode arrastar as páginas.", orgGroup: "Páginas do seu PDF", orgOne: "Organizar funciona com um PDF por vez. Junte seus arquivos primeiro e depois organize o resultado.", orgLoading: "Carregando as páginas…", orgTooMany: "Este PDF tem {0} páginas, demais para organizar aqui. Use Dividir, Extrair páginas ou Excluir páginas.", orgPage: "página {0}", orgBlank: "página em branco", orgPos: "Posição {0} de {1}", orgTurned: "girada {0}°", orgSummary: "{0} páginas", orgPickedN: "{0} escolhidas", orgPickFirst: "Escolha uma página primeiro.", orgMoved: "Movida para a posição {0}.", orgTurnedN: "{0} páginas giradas.", orgEmpty: "Mantenha pelo menos uma página.", orgDeletedN: "{0} páginas excluídas.", orgBlankAdded: "Página em branco adicionada na posição {0}.", orgResetDone: "De volta à ordem original.", orgChanged: "As páginas deste PDF não podem ser lidas de forma confiável, então a nova ordem não pode ser aplicada com segurança. Junte-o sozinho primeiro (Juntar PDF) e depois organize o resultado.", orgNoThumbs: "Este arquivo é grande demais para mostrar prévias das páginas neste dispositivo: as páginas aparecem pelo número.", orgWait: "As páginas ainda estão carregando. Tente de novo em instantes.", orgPwFirst: "Primeiro digite acima a senha do PDF para que as páginas possam ser exibidas." }, it: { orgWorking: "Riordino delle pagine…", orgInfo: "1 PDF, {0} pagine", orgInfoOne: "1 PDF, 1 pagina", orgTools: "Strumenti pagina", orgEarlier: "Sposta prima", orgLater: "Sposta dopo", orgRotL: "Ruota a sinistra", orgRotR: "Ruota a destra", orgDelete: "Elimina", orgBlankAdd: "Pagina vuota", orgReset: "Ricomincia", orgHint: "Tocca le pagine per selezionarle, poi usa i pulsanti. Se non ne selezioni nessuna, i pulsanti agiscono sulla pagina attiva. Su un computer puoi anche trascinare le pagine.", orgGroup: "Pagine del tuo PDF", orgOne: "Organizzare PDF funziona con un PDF alla volta. Unisci prima i tuoi file, poi organizza il risultato.", orgLoading: "Caricamento delle pagine…", orgTooMany: "Questo PDF ha {0} pagine, troppe per organizzarlo qui. Usa invece Dividere PDF, Estrarre pagine o Eliminare pagine.", orgPage: "pagina {0}", orgBlank: "pagina vuota", orgPos: "Posizione {0} di {1}", orgTurned: "ruotata di {0}°", orgSummary: "{0} pagine", orgPickedN: "{0} selezionate", orgPickFirst: "Seleziona prima una pagina.", orgMoved: "Spostata in posizione {0}.", orgTurnedN: "{0} pagine ruotate.", orgEmpty: "Lascia almeno una pagina.", orgDeletedN: "{0} pagine eliminate.", orgBlankAdded: "Pagina vuota aggiunta in posizione {0}.", orgResetDone: "Ripristinato l'ordine originale.", orgChanged: "Le pagine di questo PDF non si possono leggere in modo affidabile, quindi il nuovo ordine non si può applicare in sicurezza. Prima uniscilo da solo (Unire PDF), poi organizza il risultato.", orgNoThumbs: "Questo file è troppo grande per mostrare le anteprime su questo dispositivo: le pagine sono indicate con il loro numero.", orgWait: "Le pagine si stanno ancora caricando. Riprova tra un momento.", orgPwFirst: "Prima digita qui sopra la password del PDF, così le pagine possono essere mostrate." }, pl: { orgWorking: "Porządkowanie stron…", orgInfo: "1 PDF, {0} {0#strona|strony|stron}", orgInfoOne: "1 PDF, 1 strona", orgTools: "Narzędzia stron", orgEarlier: "Przesuń wcześniej", orgLater: "Przesuń dalej", orgRotL: "Obróć w lewo", orgRotR: "Obróć w prawo", orgDelete: "Usuń", orgBlankAdd: "Pusta strona", orgReset: "Zacznij od nowa", orgHint: "Dotknij stron, aby je zaznaczyć, a potem użyj przycisków. Jeśli nie zaznaczysz żadnej, przyciski działają na aktywną stronę. Na komputerze możesz też przeciągać strony.", orgGroup: "Strony Twojego PDF", orgOne: "Organizuj PDF działa z jednym plikiem PDF naraz. Najpierw połącz pliki, a potem uporządkuj wynik.", orgLoading: "Wczytywanie stron…", orgTooMany: "Ten PDF ma {0} {0#stronę|strony|stron} – za dużo, żeby go tu uporządkować. Użyj zamiast tego narzędzia Podziel PDF, Wyodrębnij strony lub Usuń strony.", orgPage: "strona {0}", orgBlank: "pusta strona", orgPos: "Pozycja {0} z {1}", orgTurned: "obrócona o {0}°", orgSummary: "{0} {0#strona|strony|stron}", orgPickedN: "Zaznaczono: {0}", orgPickFirst: "Najpierw zaznacz stronę.", orgMoved: "Przeniesiono na pozycję {0}.", orgTurnedN: "Obrócono {0} {0#stronę|strony|stron}.", orgEmpty: "Zostaw co najmniej jedną stronę.", orgDeletedN: "Usunięto {0} {0#stronę|strony|stron}.", orgBlankAdded: "Dodano pustą stronę na pozycji {0}.", orgResetDone: "Przywrócono oryginalną kolejność.", orgChanged: "Stron tego PDF nie da się wiarygodnie odczytać, więc nowej kolejności nie można bezpiecznie zastosować. Najpierw połącz go osobno (Połącz PDF), a potem uporządkuj wynik.", orgNoThumbs: "Ten plik jest za duży, żeby pokazać podglądy na tym urządzeniu: strony są oznaczone numerami.", orgWait: "Strony wciąż się wczytują. Spróbuj ponownie za chwilę.", orgPwFirst: "Najpierw wpisz powyżej hasło do PDF, żeby można było wyświetlić strony." }
  };
  Object.keys(MSG112).forEach(function(l){ Object.assign(MSG[l], MSG112[l]); });
  /* ---------- (v112) ORGANIZE: reorder, rotate, delete pages, add blank pages ----------
     One PDF at a time. The plan is a list of items { id, src (page number,
     0 = blank page), turn (0/90/180/270 added to the page's own rotation),
     sel }. Pages are picked by tapping (or Space), the toolbar acts on the
     picked pages; on a computer pages can also be dragged. The result is
     made with pcAssemble (bookmarks, links, form fields kept). */
  var ORG = { MAX_PAGES: 1500, TURN: 90, FULL: PC_ORG.FULL };
  var org = { file: null, fail: '', noThumbs: false, total: 0, plan: [], byId: new Map(), nextId: 1, gen: 0, cells: new Map(), dragSaved: null, observer: null, focusId: 0, dragId: 0, anchorId: 0 };
  function orgEl(id){ return $('org-' + id); }
  function orgItem(src){ return { id: org.nextId++, src: src, turn: 0, sel: false }; }
  function orgById(id){ return org.byId.get(+id); }
  function orgSetPlan(plan){ org.plan = plan; org.byId = new Map(plan.map(function(it){ return [it.id, it]; })); }
  function orgFromGrid(){ var a = document.activeElement; return !!(a && a.closest && a.closest('#org-grid')); }
  function orgPicked(){ return org.plan.filter(function(it){ return it.sel; }); }

  function orgButton(key, icon, onClick){
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'org-btn';
    b.setAttribute('aria-label', t(key)); b.title = t(key);
    var i = document.createElement('span'); i.setAttribute('aria-hidden', 'true'); i.textContent = icon;
    var l = document.createElement('span'); l.className = 'org-btn-label'; l.textContent = t(key);
    b.append(i, l);
    b.addEventListener('click', onClick);
    return b;
  }
  function orgBuildUi(){
    var ui = orgEl('ui');
    if(!ui || ui.firstChild) return;
    var bar = document.createElement('div');
    bar.className = 'org-bar'; bar.setAttribute('role', 'group'); bar.setAttribute('aria-label', t('orgTools')); bar.id = 'org-bar';
    bar.append(
      orgButton('orgEarlier', '←', function(){ orgMove(-1); }),
      orgButton('orgLater', '→', function(){ orgMove(1); }),
      orgButton('orgRotL', '↺', function(){ orgTurn(-ORG.TURN); }),
      orgButton('orgRotR', '↻', function(){ orgTurn(ORG.TURN); }),
      orgButton('orgDelete', '✕', orgDelete),
      orgButton('orgBlankAdd', '+', orgAddBlank),
      orgButton('orgReset', '⟲', orgReset));
    var hint = document.createElement('p'); hint.className = 'pc-thumbs-hint'; hint.id = 'org-hint'; hint.textContent = t('orgHint');
    var note = document.createElement('p'); note.className = 'pc-thumbs-note'; note.id = 'org-note'; note.hidden = true;
    var grid = document.createElement('div');
    grid.className = 'pc-thumbs-grid org-grid'; grid.id = 'org-grid';
    grid.setAttribute('role', 'group'); grid.setAttribute('aria-label', t('orgGroup')); grid.setAttribute('aria-describedby', 'org-hint');
    var sum = document.createElement('p'); sum.className = 'pc-thumbs-summary'; sum.id = 'org-summary';
    ui.append(hint, bar, note, grid, sum);
    grid.addEventListener('click', orgOnClick);
    grid.addEventListener('keydown', orgOnKey);
    grid.addEventListener('dragstart', orgDragStart);
    grid.addEventListener('dragover', orgDragOver);
    grid.addEventListener('drop', function(e){ e.preventDefault(); });
    grid.addEventListener('dragend', orgDragEnd);
  }
  function orgShowNote(text){
    var note = orgEl('note'), on = !!text;
    note.hidden = !on; note.textContent = text || '';
    orgEl('bar').hidden = on; orgEl('hint').hidden = on;
  }
  /* ---- files ---- */
  async function orgFiles(files){
    orgBuildUi();
    var gen = ++org.gen, file = files.length === 1 ? files[0] : null;
    if(org.observer){ org.observer.disconnect(); org.observer = null; }
    org.cells.clear(); orgEl('grid').textContent = ''; orgEl('summary').textContent = '';
    org.file = file; org.fail = ''; orgSetPlan([]); org.total = 0; org.anchorId = 0; org.focusId = 0;
    var ui = orgEl('ui');
    ui.hidden = !files.length;
    clearPreviewPassword('org');
    if(!files.length) return;
    if(!file){ orgShowNote(t('orgOne')); return; }
    if(previewTooHeavy('org', file)){ org.fail = pcT('mobileMemStop', fmtSize(pcMemEstimate('org', [file]))); orgShowNote(org.fail); return; } // (v157) not read at all
    orgShowNote(t('orgLoading'));
    try{
      await pcLoadPdfLibs();
      pcRequirePdfJs();
      await pcLoadLib('thumbs');
      // (v143) given at another tool's preview, before the previews were loaded; (v147) never wipes one typed at a page picker
      if(previewPassword(file)) window.PCThumbs.setPassword(file, previewPassword(file));
      var n = await window.PCThumbs.pageCount(file);
      if(gen !== org.gen) return;
      if(n > ORG.MAX_PAGES){ org.fail = t('orgTooMany', n); orgShowNote(org.fail); return; }
      org.total = n;
      orgSetPlan(orgOriginal());
      orgShowNote('');
      // (v112) like the page pickers: no previews for a file too large for this device; page numbers only
      org.noThumbs = window.PCThumbs.tooBig(file);
      orgEl('hint').textContent = t('orgHint') + (org.noThumbs ? ' ' + t('orgNoThumbs') : '');
      org.observer = new IntersectionObserver(orgOnVisible, { root: null, rootMargin: '300px' });
      orgRender();
    }catch(e){
      if(gen !== org.gen || (window.PCThumbs && window.PCThumbs.isCancelled(e))) return;
      if(isPasswordError(e)){ // (v143) asked here; Start says to type it first
        org.fail = t('orgPwFirst');
        orgShowNote(org.fail);
        askPreviewPassword('org', orgEl('note'), file, !!previewPassword(file), function(f){ orgFiles([f]).catch(pcLogUnexpected); }, orgEl('ui')); // the note goes once the pages are shown
        return;
      }
      pcLogUnexpected(e);
      // (v112) kept, so Organize PDF shows the same reason instead of "still loading"
      org.fail = reasonOf(e, 'invalidPdf');
      orgShowNote(org.fail);
    }
  }
  /* ---- the grid ---- */
  function orgCell(it){
    var c = org.cells.get(it.id);
    if(c) return c;
    // a div with role=button: Firefox doesn't let a <button> be dragged
    c = document.createElement('div');
    c.setAttribute('role', 'button'); c.className = 'pc-thumb org-cell'; c.draggable = true; c.tabIndex = -1;
    c.dataset.id = String(it.id);
    var frame = document.createElement('span'); frame.className = 'pc-thumb-frame';
    var num = document.createElement('span'); num.className = 'pc-thumb-num'; num.setAttribute('aria-hidden', 'true');
    c.append(frame, num);
    if(!it.src) c.classList.add('org-blank');
    org.cells.set(it.id, c);
    if(it.src && !org.noThumbs) org.observer.observe(c);
    return c;
  }
  function orgLabel(it, pos){
    var base = it.src ? t('orgPage', it.src) : t('orgBlank');
    return t('orgPos', pos, org.plan.length) + ': ' + base + (it.turn ? ', ' + t('orgTurned', it.turn) : '');
  }
  function orgRender(){
    var grid = orgEl('grid'), frag = document.createDocumentFragment();
    if(!org.byId.has(org.focusId)) org.focusId = org.plan.length ? org.plan[0].id : 0;
    org.plan.forEach(function(it, i){
      var c = orgCell(it);
      c.setAttribute('aria-pressed', it.sel ? 'true' : 'false');
      c.setAttribute('aria-label', orgLabel(it, i + 1));
      c.tabIndex = it.id === org.focusId ? 0 : -1;
      c.lastChild.textContent = it.src ? String(it.src) : '+';
      c.style.setProperty('--pc-turn', it.turn + 'deg');
      frag.appendChild(c);
    });
    // cells of items that are gone (deleted) are dropped
    org.cells.forEach(function(c, id){ if(!org.byId.has(id)){ if(org.observer) org.observer.unobserve(c); org.cells.delete(id); } });
    grid.replaceChildren(frag);
    var picked = orgPicked().length;
    orgEl('summary').textContent = t('orgSummary', org.plan.length) + (picked ? ' · ' + t('orgPickedN', picked) : '');
  }
  function orgOriginal(){ var p = []; for(var i = 1; i <= org.total; i++) p.push(orgItem(i)); return p; }
  function orgOnVisible(entries){
    entries.forEach(function(e){
      var c = e.target, frame = c.firstChild; c._pcNear = e.isIntersecting;
      // (v112) pictures far off screen are dropped and come back from the cached URL (memory on iOS with long PDFs)
      if(!e.isIntersecting){ if(frame.firstChild) frame.replaceChildren(); return; }
      if(c._pcUrl){ if(!frame.firstChild) orgShowImg(c, c._pcUrl, org.gen); return; }
      if(c._pcAsked) return;
      var it = orgById(c.dataset.id);
      if(!it || !it.src) return;
      c._pcAsked = true;
      var gen = org.gen;
      window.PCThumbs.thumb(org.file, it.src, function(){ return c._pcNear; }).then(function(url){
        if(gen !== org.gen) return;
        c._pcUrl = url;
        if(c._pcNear) orgShowImg(c, url, gen);
      }, function(err){
        if(gen !== org.gen) return;
        c._pcAsked = false;
        if(window.PCThumbs.isCancelled(err)) return; // asked again when it comes back into view
        org.observer.unobserve(c);
        pcLogUnexpected(err);
        c.classList.add('is-failed'); // only the page number is shown
      });
    });
  }
  function orgShowImg(c, url, gen){
    var img = document.createElement('img'); img.alt = ''; img.decoding = 'async';
    img.onload = function(){ if(gen === org.gen && c._pcNear && !c.firstChild.firstChild) c.firstChild.appendChild(img); };
    img.onerror = function(){ c.classList.add('is-failed'); };
    img.src = url;
  }
  /* ---- picking ---- */
  function orgOnClick(e){
    var c = e.target.closest('.org-cell');
    if(!c) return;
    var id = +c.dataset.id, it = orgById(id);
    if(!it) return;
    var a = e.shiftKey && org.anchorId ? org.plan.indexOf(orgById(org.anchorId)) : -1;
    if(a >= 0){
      var b = org.plan.indexOf(it);
      var lo = Math.min(a, b), hi = Math.max(a, b), on = !it.sel;
      for(var i = lo; i <= hi; i++) org.plan[i].sel = on;
    }else it.sel = !it.sel;
    org.anchorId = id; org.focusId = id;
    orgRender();
    c.focus();
  }
  function orgColumns(){
    var cells = orgEl('grid').children, top = cells[0] ? cells[0].offsetTop : 0, n = 0;
    while(n < cells.length && cells[n].offsetTop === top) n++;
    return Math.max(1, n);
  }
  function orgOnKey(e){
    var c = e.target.closest('.org-cell');
    if(!c) return;
    var i = org.plan.indexOf(orgById(c.dataset.id));
    if(e.key === ' ' || e.key === 'Enter'){ e.preventDefault(); c.click(); return; }
    if(e.key === 'Delete' || e.key === 'Backspace'){ e.preventDefault(); orgDelete(); return; }
    var cols = orgColumns();
    var moves = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: cols, ArrowUp: -cols, Home: -i, End: org.plan.length - 1 - i };
    if(!(e.key in moves)) return;
    e.preventDefault();
    var next = Math.max(0, Math.min(org.plan.length - 1, i + moves[e.key]));
    var from = org.cells.get(org.focusId);
    if(from) from.tabIndex = -1;
    c.tabIndex = -1;
    org.focusId = org.plan[next].id;
    var to = org.cells.get(org.focusId);
    to.tabIndex = 0; to.focus();
  }
  /* ---- actions on the picked pages (or the focused one when none is picked) ---- */
  function orgTargets(){
    var p = orgPicked();
    if(p.length) return p;
    var f = org.byId.has(org.focusId) ? [org.byId.get(org.focusId)] : [];
    if(!f.length) pcAnnounce(t('orgPickFirst'));
    return f;
  }
  function orgAfter(msg){ orgRender(); if(msg) pcAnnounce(msg); }
  function orgMove(step){
    var targets = orgTargets();
    if(!targets.length) return;
    var plan = org.plan.slice(), order = step < 0 ? plan.slice() : plan.slice().reverse();
    order.forEach(function(it){
      if(targets.indexOf(it) < 0) return;
      var i = plan.indexOf(it), j = i + step;
      if(j < 0 || j >= plan.length || targets.indexOf(plan[j]) >= 0) return; // at the edge or behind another picked page
      plan[i] = plan[j]; plan[j] = it;
    });
    var before = org.plan.indexOf(targets[0]), grid = orgFromGrid();
    org.plan = plan;
    org.focusId = targets[0].id;
    var at = plan.indexOf(targets[0]);
    orgAfter(at !== before ? t('orgMoved', at + 1) : '');
    if(grid) org.cells.get(org.focusId).focus(); // from the buttons, focus stays on the button
  }
  function orgTurn(deg){
    var targets = orgTargets();
    targets.forEach(function(it){ it.turn = ((it.turn + deg) % ORG.FULL + ORG.FULL) % ORG.FULL; });
    if(targets.length) orgAfter(t('orgTurnedN', targets.length));
  }
  function orgDelete(){
    var targets = orgTargets();
    if(!targets.length) return;
    if(targets.length >= org.plan.length){ pcAnnounce(t('orgEmpty'), true); return; }
    var first = org.plan.indexOf(targets[0]), grid = orgFromGrid();
    orgSetPlan(org.plan.filter(function(it){ return targets.indexOf(it) < 0; }));
    org.focusId = org.plan[Math.min(first, org.plan.length - 1)].id;
    if(targets.some(function(it){ return it.id === org.anchorId; })) org.anchorId = 0;
    orgAfter(t('orgDeletedN', targets.length));
    if(grid) org.cells.get(org.focusId).focus();
  }
  function orgAddBlank(){
    var p = orgPicked(), at = p.length ? org.plan.indexOf(p[p.length - 1]) + 1 : org.plan.length;
    var it = orgItem(0);
    org.plan.splice(at, 0, it); org.byId.set(it.id, it);
    org.focusId = it.id;
    orgAfter(t('orgBlankAdded', at + 1));
  }
  function orgReset(){
    orgSetPlan(orgOriginal());
    org.anchorId = 0;
    orgAfter(t('orgResetDone'));
  }
  /* ---- dragging (mouse; touch uses the arrow buttons) ---- */
  function orgDragStart(e){
    var c = e.target.closest('.org-cell');
    if(!c) return;
    org.dragId = +c.dataset.id; org.dragSaved = org.plan.slice();
    c.classList.add('org-dragging');
    try{ e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', c.dataset.id); }catch(err){ /* only needed by Firefox to start a drag */ }
  }
  function orgDragOver(e){
    if(!org.dragId) return;
    e.preventDefault();
    var over = e.target.closest('.org-cell');
    if(!over || +over.dataset.id === org.dragId) return;
    var from = org.plan.indexOf(orgById(org.dragId)), to;
    var r = over.getBoundingClientRect(), after = e.clientX > r.left + r.width / 2;
    var it = org.plan.splice(from, 1)[0];
    to = org.plan.indexOf(orgById(over.dataset.id)) + (after ? 1 : 0);
    if(to === from) { org.plan.splice(from, 0, it); return; }
    org.plan.splice(to, 0, it);
    orgRender();
  }
  function orgDragEnd(e){
    var c = org.cells.get(org.dragId), id = org.dragId, saved = org.dragSaved;
    if(c) c.classList.remove('org-dragging');
    org.dragId = 0; org.dragSaved = null;
    if(!id) return;
    var cancelled = e.dataTransfer && e.dataTransfer.dropEffect === 'none';
    if(cancelled && saved){ org.plan = saved; orgRender(); return; } // Escape or dropped outside the grid
    var before = saved ? saved.indexOf(orgById(id)) : -1, at = org.plan.indexOf(orgById(id));
    org.focusId = id;
    orgAfter(at !== before ? t('orgMoved', at + 1) : '');
  }
  /* ---- the result ---- */
  /* (perf) The new file is made by pcOrganizePdfFile (pc-pdfcore.js), in the worker. */
  async function orgBuild(file, plan, ctx){
    var opt = { plan: plan, total: org.total, msgs: jobMsgs({ changed: t('orgChanged') }) };
    var r = await ctx.worker.run('organizePdf', file, opt, function(frac){ ctx.setProgress(frac); });
    noteJob(file, r);
    // as pcAssembleNotes (app.js) wrote them from the new document
    r.notes = [r.formRenamed ? pcT('formRenamedNote', file.name) : '', r.formXfa ? pcT('xfaHybridNote', file.name) : ''].filter(Boolean).join(' ');
    return r;
  }
  pcOnPanel('org', function(){
    setupTool('org', {
      accept: isPdf, workingKey: 'orgWorking', zipName: 'organized-pdf',
      onFiles: function(files){ org.loading = orgFiles(window.PDFC_FILES.unique(files)).catch(pcLogUnexpected); },
      run: async function(files, _opt, ctx){
        if(files.length !== 1) throw userError('orgOne');
        // (v157) Start while the pages are still being read waits for them (it said "try again in a moment")
        if(files[0] === org.file && !org.plan.length && org.loading) await org.loading;
        if(files[0] === org.file && org.fail){
          var pwField = $('pc-pvw-in-org');
          if(pwField) pwField.setAttribute('aria-invalid', 'true'); // (v143) the status box hands the focus to it
          throw pcUserError(org.fail);
        }
        if(files[0] !== org.file || !org.plan.length) throw userError('orgWait');
        var plan = org.plan.map(function(it){ return { src: it.src, turn: it.turn }; });
        resetNotes();
        var r = await orgBuild(files[0], plan, ctx);
        var pages = plan.length;
        return { results: [{ blob: r.blob, filename: r.filename }], skipped: [],
          info: pages === 1 ? t('orgInfoOne') : t('orgInfo', pages), note: [takeNotes(), r.notes].filter(Boolean).join(' ') };
      }
    });
  });

  // Exposed for automated tests only.
  /* (v147) The shared wiring for tools that live in their own file (src/tool-*.js):
     the same helpers, so they don't keep copies of this logic. Their own text comes
     from their own table; these helpers' messages (invalidPdf, password, couldNot…) from this file's. */
  window.PCTools = { setupTool: setupTool, eachFile: eachFile, loadPdfLib: loadPdfLib, askPreviewPassword: askPreviewPassword,
    previewGate: previewGate, previewPassword: previewPassword, takeNotes: takeNotes, resetNotes: resetNotes, noteName: noteName,
    pdfBlob: pdfBlob, isPdf: isPdf, reasonOf: reasonOf, userError: userError, fieldError: fieldError, memoryOr: memoryOr, t: t };
  /* (v147) For Fill (src/tool-fill.js): the preview helpers of Sign/Crop and the watermark's fonts. */
  Object.assign(window.PCTools, { canvasScale: canvasScale, destroyTask: destroyTask, showPreviewMsg: showPreviewMsg, pagerButtons: pagerButtons,
    clearPreviewPassword: clearPreviewPassword, isPasswordError: isPasswordError,
    fonts: { scriptKey: scriptKey, font: wmFont, file: wmFontFile, textPath: wmTextPath } });
  window.PCTools.txtPageText = txtPageText; // (v147) a page's text as PDF to text reads it (Compare)
  window.PDFC_MORE = { encryptedBytes: encryptedBytes, txtPageText: txtPageText, cropRect: cropRect, cropInkBox: cropInkBox, metaRead: metaRead, metaWipe: metaWipe, parsePages: parsePages, parsePageSpec: pcParsePageSpec, resolvePages: resolvePages, jpegOrientation: jpegOrientation, orientMap: orientMap, shownToUser: pcShownToUser, nupSheet: nupSheet, nupSettings: nupSettings };
})();
